// fa
export const locale = {
  lang: 'fa',
  data: {
    appName: 'پیشگام پیامک',
    layout: {
      footer: {
        aboutUs: 'درباره ما',
        contactUs: 'تماس با ما',
        support: 'پشتیبانی',
      },
      asideMenu: {
        Dashboard: 'داشبورد',
        Infrastructure: 'زیرساخت',
        SystemManagement: 'مدیریت سیستم',
        SendingSystem: 'ارسال',
        Configuration: 'پیکربندی',
        SmsReports: 'گزارشات پیامک',
        Facility: 'امکانات',
        Financial: 'امور مالی ',
        Phonebook: 'دفترچه تلفن',
        Setting: 'تنظیمات',
        Services: 'سرویس ها',
        whiteMessages: 'باشگاه مشتریان',
      },
    },
    pages: {
      dashboard: {
        dailyCountChart: {
          dailySentMessageStatistics: 'آمار روزانه ارسال پیامک',
          lastTenDaysSentMessagesCount: 'تعداد پیام های ارسال شده ده روز گذشته',
          allCount: 'تعداد کل',
          sentCount: 'تعداد ارسال شده',
        },
        dailyTypeChart: {
          dailySentMessageWithTypeStatistics:
            'آمار روزانه ارسال پیامک به تفکیک نوع پیامک',
          lastTenDaysSentMessagesCountByType:
            'تعداد پیام های ارسال شده ده روز گذشته به تفکیک نوع پیام',
        },
        latestInformations: {
          latestNews: 'آخرین اخبار',
        },
        percentChart: {
          sentMessages: 'پیامک های ارسال شده امروز',
          sentMessagesWithPercent:
            'نمودار زیر درصد پیامک های ارسال شده امروز را بر اساس نوع ارسال نمایش می دهد.',
          SentMessagesPercent: 'درصد پیامک های ارسال شده امروز',
          sent: 'ارسال شده',
          notSent: 'ارسال نشده',
          all: 'تعداد کل',
          sendType: 'نوع ارسال',
          sentPercent: 'درصد ارسال شده',
        },
        systemStatistics: {
          organizationInformations: 'اطلاعات سازمان',
          balance: 'موجودی حساب',
          lastloginTime: 'زمان آخرین ورود',
          lastloginIP: 'IP آخرین ورود',
        },
        todayStatistics: {
          sentSmsStatisticsWithType:
            'آمار زیر تعداد پیامک های ارسال شده ده روز اخیر بر اساس نوع ارسال را نمایش می‌دهد.',
          sentMessages: 'پیامک های ارسال شده ده روز اخیر',
        },
      },
      shared: {
        helpPage: {
          menuGuide: 'راهنمای منو',
        },
        editSendReceiversDeliveryStatus: {
          clickHereToGetASampleFile:
            'جهت دریافت نمونه فایل <a class="tw-font-bold tw-cursor-pointer" href="/assets/media/sample/sample.xlsx"download="sampleMobiles.xlsx" id="linkIdSampleMobiles">اینجا</a>کلیک کنید.',
        },
        outboxMessagesDetail: {},
        outboxMessagesSendBulkDetail: {},
      },
      infrastructure: {
        setting: {
          settingForm: {
            ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
              'در صورتی که خط انتخابی خدماتی نباشد، <br /> پیامک برای شماره تلفن هایی که در لیست سیاه هستند ارسال نمی شود.',
          },
        },
        privateNumbers: {
          privateNumbersForm: {
            oneOfTheNumbers1To9: 'یکی از اعداد 1 تا 9',
            twoTo11Times0To9: '2 تا 11 مرتبه 0 تا 9',
            threeTo11Times0To9: '3 تا 11 مرتبه 0 تا 9',
            maximum9Times: 'حداکثر 9 مرتبه ؟',
          },
        },
        menus: {
          menusForm: {
            downloadVideo:
              '<a target="_blank" href="{{fileUrl}}">دانلود ویدیو</a>',
            downloadPDF:
              '<a target="_blank" href="{{fileUrl}}">دانلود پی دی اف</a>',
            downloadFile:
              '<a target="_blank" href="{{fileUrl}}">دانلود فایل</a>',
          },
        },
      },
      facility: {
        phonebook: {
          fromIndex: '<b>از اندیس</b> نباید از<b>تعداد مخاطبین</b> بیشتر باشد.',
          count: '<b>تعداد </b>نباید از <b>تعداد مخاطبین</b> بیشتر باشد.',
          both: 'اندیس گزاری اشتباه است',
        },
      },
      sendingSystem: {
        fastSendSmsPatternByPhonebook: {
          youAreOnlyAbleToSelectTheSMSTemplateAndYouCannotChangeTheTextOfTheMessage:
            'توجه داشته باشید شما فقط قادر به انتخاب الگوی پیامک هستید و نمی توانید متن پیام را دستی تغییر دهید .',
          toSetTheSMSTextClickOnTheSMSTemplateButtonThenChooseYourSMStemplate:
            'برای تنظیم متن پیامک روی کلید <b class="text-primary"> الگوی پیامک </b><i class="mdi mdi-text-box-plus-outline text-primary tw-mx-1 mdi-20px"></i> کلیک کنید سپس الگوی پیامک خود را <b class="!tw-text-violet-600 tw-font-semibold"> انتخاب </b> کنید.',
        },
        sendBulkSms: {
          chooseAreaAndSetFilters:
            'در ابتدا می بایست در قسمت <b class="text-dark tw-font-black"> محدوده ارسال </b> انتخاب نمایید می خواهید به کدام مناطق و با چه فیلترهایی پیامک ارسال نمایید. توجه داشته باشید حداقل باید یک استان و نوع سیم کارت هایی که قرار است پیامک به آنها ارسال شود را مشخص نمایید.',
          calculateNumbers:
            'پس از تنظیم فیلترهای مورد نیاز خود از قسمت <b class="text-dark tw-font-black"> مشخصات ارسال </b> یکبار بر روی کلید <b class="badge badge-teal !tw-text-white tw-rounded-[3px]">محاسبه تعداد شماره <i class="mdi mdi-calculator mdi-18px text-white"> </i> </b> کلیک نمایید.',
          chooseNumbersCount:
            ' سپس از قسمت <b class="text-dark tw-font-black"> مشخصات ارسال </b> مشخص نمایید می خواهید از ردیف چندم به چه تعداد شماره ارسال انجام گیرد.',
          addAreaToList:
            'در مرحله آخر منطقه و فیلترهای مورد نظر شما با کلیک بر روی کلید <b class="badge badge-navyBlue tw-rounded-[3px] !tw-text-white "> افزودن <i class="mdi mdi-plus-thick mdi-18px text-white "></i> </b> به لیست پایانی اضافه می شود. شما می توانید این کار را برای چندین منطقه انجام دهید.',
          clickOnNext:
            'در نهایت با کلیک بر روی دکمه <b class="text-dark tw-font-black"> مرحله بعد </b> به تنظیم پیامک و نحوه ارسال آن منتقل خواهید شد.',
          models: {},
        },
        sendP2PSms: {
          createExcel:
            'توسط این سرویس قادر خواهید بود متن ارسالی را برای هر شماره موبایل شخصی سازی نمایید.برای اینکار کافیست یک فایل اکسل ایجاد نمایید و ستون های حاوی اطلاعات را در آن لحاظ کنید. لازم به ذکر است فایل اکسل می تواند شامل ستون های مختلف باشد و شما متن پیامک را با توجه به متن ستون ها تنظیم نمایید. دقت بفرمایید که سطر اول فایل اکسل خوانده نمی شود بنابراین میتوانید از آن برای درج عنوان استفاده کنید.',
          tipsForExcelTable:
            ' عنوان ستون ها حتما باید از نوع Text ، با حروف انگلیسی و بدون فاصله باشد .',
          sendWithDuplicateNumbersMsg:
            '<b>هشدار</b> : با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
        },
        sendSmartSmsConfirmRequest: {},
        sendBalkSms: {
          yourSendingIsInUpdateStatus:
            'کاربر گرامی توجه داشته باشید ارسال شما متوقف شد و در وضعیت<b class="text-danger"> در حال بروزرسانی </b>قرار گرفت.جهت ادامه روند ارسال، انجام عملیات ویرایش الزامی می باشد.',
        },
        base: {
          baseSendSMS: {
            message:
              'کاربر گرامی توجه داشته باشید ارسال شما متوقف شد و در وضعیت<b class="text-danger"> در حال بروزرسانی </b>قرار گرفت. جهت ادامه روند ارسال، انجام عملیات ویرایش الزامی می باشد.',
          },
        },
        sendSmartSmsCreateRequest: {
          sendSmartSmsAdvanceSearch: {
            searchInPersonalPlaces: ' جستجو در مکان های شخصی',
            personal: 'شخصی',
            category: 'دسته بندی',
            publicSearch: 'جستجوی عمومی',
            public: 'عمومی',
            selectedListPublic: 'مکان های عمومی انتخاب شده',
            selectedListPersonal: 'مکان های شخصی انتخاب شده',
          },
        },
      },
      systemManagement: {
        organizations: {
          organizationDeleteConfirmDialog:
            'توجه داشته باشید تمامی کاربران سازمانی که حذف می گردد نیز حذف خواهد شد.',
          justDeleteOrgan: 'فقط حذف سازمان',
          deleteOrganAndSubsets: 'حذف سازمان و تمامی زیرمجموعه ها',
          organizationsAuthenticationForm: {
            maxSizeIs200kb:
              'حداکثر حجم هر فایل نباید از 200 کیلوبایت بیشتر باشد',
          },
        },
        users: {
          userForm: {
            changeNumber: 'تغییر شماره',
            changeNumberAndAuthenticate: 'تغییر شماره و احرازهویت',
            confirmed: 'تایید شده',
            notConfirmed: 'تایید نشده',
            userAuthMobile: {
              enterVerificationCode:
                'کد تایید ارسال شده به شماره موبایل<b class="text-info">{{mobile}}</b>را وارد کنید .',
            },
          },
          userPersonalInfo: {
            userPersonalInfoForm: {
              editPersonalInfo: 'ویرایش اطلاعات شخصی',
              submitPersonalInfo: 'ثبت اطلاعات شخصی',
            },
          },
        },
      },
      register: {
        form: {
          fields: {
            isRealPerson: 'نوع ',
            workplaceTitle: 'عنوان محل کار',
            workplacePhone: 'تلفن محل کار',
            workplaceZipCode: 'کدپستی محل کار',
            workplaceAddress: 'آدرس محل کار',
            organName: ' نام سازمان',
            nationalId: 'شناسه ملی',
            economicCode: 'کد اقتصادی',
            ceoName: 'نام و نام خانوادگی مدیر عامل',
            ceoMobile: 'تلفن همراه مدیر عامل',
            ceoNationalCode: 'کد ملی مدیر عامل',
            isForeigner: 'اتباع خارجی',
          },
          legends: {
            organizationInfo: 'مشخصات سازمان {{type}}',
            UserInfo: 'مشخصات کاربری',
          },
          messages: {
            organizationDescription:
              'کاربر گرامی جهت تکمیل فرآیند ثبت نام لازم است مشخصات سازمان {{type}} خود را در فرم زیر وارد نمائید.',
            userDescription:
              'کاربر گرامی جهت نهایی کردن فرآیند ثبت نام لازم است مشخصات کاربری  خود را در فرم زیر وارد نمایید.',
          },
        },
      },
      blackList: {
        title: 'لیست سیاه',
        form: {
          addTitle: 'افزودن به لیست سیاه',
        },
      },
      customerDomains: {
        title: 'دامنه ها',
        domainConfigurations: 'تنظیمات دامنه',
        form: {
          addTitle: 'دامنه جدید',
          editTitle: 'ویرایش دامنه',
          detailTitle: 'جزئیات دامنه',
          domainInfo: 'مشخصات دامنه',
          fields: {
            desktop: 'صفحه راه اندازی',
            loginTheme: 'صفحه اصلی',
            resellerDomain: 'دامنه ی مشتری',
            resellerIdentityDomain: ' دامنه ی احرازهویت مشتری',
            agentLogo: 'لوگوی نماینده',
            lastModified: 'تاریخ آخرین ویرایش',
            resellerLink: 'لینک',
            dashboardMode: 'داشبورد',
            loginPageMode: 'صفحه لاگین',
            primaryColor: 'رنگ اصلی',
            secondaryColor: 'رنگ دوم',
            enamad: 'اینماد',
          },
        },
        detailForm: {
          legend: 'جزئیات دامنه',
        },
      },
      smsSenderAgents: {
        title: 'عامل ارسال ',
        form: {
          addTitle: 'عامل ارسال پیامک جدید',
          editTitle: 'ویرایش عامل ارسال پیامک',
          fields: {
            defaultNumber: 'شماره پیش فرض',
            type: 'نوع اپراتور ارسال کننده',
            smsSenderAgentReference: 'عامل ارسال پیامک',
            startTime: 'زمان شروع ارسال',
            endTime: 'زمان پایان ارسال',
            sendSmsAlert: 'ارسال هشدار پیامک',
            isSendActive: 'فعال بودن ارسال',
            isReceiveActive: 'فعال بودن دریافت',
            isSendBulkActive: 'فعال بودن ارسال انبوه',
            sendBulkIsAutomatic: 'ارسال انبوه بصورت خودکار',
            checkMessageId: 'چک کردن شناسه پیام',
            isSendSmartActive: 'وضعیت ارسال هوشمند',
            isActiveAllTime: 'در نظر نگرفتن زمان شروع و پایان',
            sendLink: 'لینک ارسال',
            receiveLink: 'لینک دریافت',
            deliveryLink: 'لینک دلیوری',
            domain: 'دامنه/نام شرکت',
            internalCredit: 'اعتبار داخلی',
            externalCredit: 'اعتبار خارجی',
            queueLength: 'طول صف',
            routeActive: 'وضعیت Route',
            isP2p: 'وضعیت ارسال نظیر به نظیر',
            isSmpp: 'وضعیت Smpp',
            isBts: 'وضعیت Bts',
            udhLen: 'وضعیت طول جدا کننده کاراکتر فارسی',
            receiveInboxType: 'نوع دریافت صندوق',
          },
          legends: {
            accessInformation: 'اطلاعات دسترسی',
            generalInformation: 'اطلاعات عمومی',
            socialMediaSmartDetailsMci:
              'جزئیات ارسال هوشمند شبکه اجتماعی همراه اول',
            socialMediaSmartDetailsMtn:
              'جزئیات ارسال هوشمند شبکه اجتماعی ایرانسل ',
            socialMediaSmartDetailsRightel:
              'جزئیات ارسال هوشمند شبکه اجتماعی رایتل ',
          },
        },
      },
      privateNumbers: {
        title: 'تعریف خطوط اختصاصی',
        addBtns: {
          addSingle: 'افزودن تکی',
          createByRange: 'افزودن به صورت رنجی',
        },
        form: {
          addTitle: 'افزودن خطوط اختصاصی',
          editTitle: 'ویرایش خطوط اختصاصی',
          fields: {
            id: 'شناسه خط',
            priority: 'اولویت ارسال',
            sendToBlackList: 'خط خدماتی',
            deliveryBase: 'کسر هزینه برپایه دلیوری',
            checkFilter: 'بررسی فیلتر پیامک',
            deliveryLevel1: 'کسر هزینه بر پایه دلیوری سطح 1 ',
            deliveryLevel2: 'کسر هزینه بر پایه دلیوری سطح 2 ',
            isAutomaticBulk: 'ارسال اتوماتیک انبوه (فقط صف)',
            confirmP2pAndDynamic: 'ارسال اتوماتیک پویا و نظیر به نظیر',
            isAutomaticGroup: 'ارسال اتوماتیک گروهی',
            isSendBulk: 'ارسال انبوه (آپدیت شماره)',
            isSendGender: 'ارسال جنسیت',
            isSendGroup: 'ارسال گروهی',
            isSendPhonebook: 'ارسال دفترچه تلفن',
            isSendBulk2: 'ارسال انبوه ',
            isSendApiP2P: 'ارسال وب سرویس نظیر به نظیر',
            isSendDynamic: 'ارسال پویا',
            isSendOtp: 'ارسال otp',
            isSendP2P: 'ارسال نظیر به نظیر',
            isSendClub: 'ارسال باشگاه مشتریان',
            isPublic: 'خط عمومی',
            isSendApiSingle: 'ارسال وب سرویس تکی',
            isGeneralBlackList: 'لیست سیاه عمومی',
            isSendSingle: 'ارسال تکی',
            hasSla: 'SLA',
            smsSenderAgentId: 'عامل ارسال ',
            smsSenderAgentName: 'نام عامل ارسال ',
            useForm: 'استفاده بصورت',
            mask: 'نام تجاری',
            range: 'بازه',
            tryCount: 'تعداد سعی مجدد',
            expireTime: 'ساعت انقضا',
            isSendDevice: 'ارسال دستگاه',
            isSendSmart: 'ارسال هوشمند',
            isNeedToSendConfirmationMessage: 'نیاز به ارسال پیام تایید',
            isSendPrivateNumberExpirationMessage:
              'ارسال پیام انقضای شماره اختصاصی',
            refundDeliveryStatusId: 'وضعیت بازگشت هزینه',
            isCanSendFlashSms: 'ارسال فلش',
            tag: 'برچسب',
            isCanSendSmartWithoutConfirmation: 'امکان ارسال هوشمند بدون تایید',
            isSendOccasionPhonebook: 'ارسال مناسبتی دفترتلفن',
            numberStartOfRange: ' شروع بازه',
            numberEndOfRange: ' پایان بازه',
          },
          legends: {
            generalSettings: 'تنظیمات کلی',
            messageSenderInformation: 'مشخصات خط',
            bulkSend: 'ارسال انبوه',
            webServiceSend: 'ارسال وب سرویس',
            toNumberSend: 'ارسال به شماره',
          },
        },
      },
      bulkNumberInformation: {
        name: 'لیست شماره های انبوه(شماره آپدیت)',
        name2: 'لیست شماره های انبوه',
        title: 'لیست شماره های انبوه(شماره آپدیت)',
        title2: 'لیست شماره های انبوه',
        importfromfile: {
          title: 'افزودن از فایل',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            cellPhone: 'شماره همراه',
            zipCode: 'کدپستی',
            areaName: 'کشور',
            cityName: 'شهر',
            stateName: 'استان',
            genderType: 'جنسیت',
            guildName: 'گروه مشاغل',
            subGuildName: 'زیرگروه مشاغل',
            isBlackList: 'لیست سیاه',
            isBlackListLocal: 'لیست سیاه محلی',
            mobileOperator: 'اپراتور همراه',
            simType: 'نوع سیمکارت',
          },
        },
        deleteFromFile: {
          title: 'حذف با فایل',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            cellPhone: 'شماره همراه',
          },
        },
        deleteBtns: {
          deleteMultiple: 'حذف چندتایی',
          deleteFromFile: 'حذف با فایل',
        },
        addBtns: {
          addSingle: 'افزودن تکی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        form: {
          addTitle: 'افزودن شماره',
          legend: 'اطلاعات',
          fields: {
            id: 'شناسه ',
            genderType: ' جنسیت',
            areaName: 'کشور',
            cityName: 'شهر',
            isBlackList: 'لیست سیاه',
            isBlackListLocal: 'لیست سیاه محلی',
            mobile12: 'شماره همراه',
            mobileOperator: 'اپراتور همراه',
            stateName: 'استان',
            guildName: 'گروه مشاغل',
            subGuildName: 'زیرگروه مشاغل',
            simType: 'نوع سیم کارت',
            zipCode10: 'کدپستی',
          },
          legends: {
            generalSettings: ' لیست شماره های انبوه',
            generalSettings2: 'لیست شماره های انبوه دو',
          },
        },
      },
      sendSmartDetailsByDelivery: {
        title: 'جزییات وضعیت ارسال هوشمند',
      },
      organizations: {
        title: 'سازمان ها',
        authenticatedMobile: 'تایید شماره موبایل',
        organizationsExcel: 'دانلود فایل اکسل سازمان ها',
        form: {
          addTitle: 'سازمان جدید',
          editTitle: 'ویرایش سازمان',
          fields: {
            isRealPerson: 'نوع ',
            name: 'نام و نام خانوادگی',
            workplaceTitle: 'عنوان محل کار',
            workplacePhone: 'تلفن محل کار',
            workplaceZipCode: 'کدپستی محل کار',
            workplaceAddress: 'آدرس محل کار',
            organName: ' نام سازمان',
            nationalId: 'شناسه ملی',
            economicCode: 'کد اقتصادی',
            ceoFullName: 'نام ونام خانوادگی مدیر عامل',
            ceoMobile: 'تلفن همراه مدیر عامل',
            ceoNationalCode: 'کد ملی مدیر عامل',
            maximumUser: 'حداکثر کاربر',
            maxOrganization: 'حداکثر سازمان',
            maxCustomFiled: 'حداکثر فیلد سفارشی',
            maxPhonebook: 'حداکثر دفترچه تلفن',
            parentId: 'والد',
            adminUserId: 'مدیر پنل',
            resellerId: 'فروشنده',
            panelPrice: 'قیمت پنل',
            groupPriceTitle: 'تعرفه',
            blackSenderPrivateNumberId: 'فرستنده لیست سیاه',
            maximumPhoneNumber: 'حداکثر شماره تلفن',
            domainId: 'دامنه مشتری',
            sendStartTime: 'زمان شروع ارسال',
            sendEndTime: 'زمان پایان ارسال',
            expireTime: 'ساعت انقضا',
            isShowGeneralNumbers: 'نمایش شماره عمومی برای کاربران',
            isForeigner: 'اتباع خارجی',
            isActiveSend: 'ارسال فعال',
            isConfirmMessage: 'تایید پیام',
            isActiveAllTime: 'در نظر نگرفتن زمان شروع و پایان ارسال',
            isHaveBlackListDeliveryProcess:
              'پردازش لیست سیاه بر اساس وضعیت تحویل',
            isAllowLink: ' ارسال لینک',
            isTax: 'مالیات',
            isAuthenticated: 'احراز هویت',
            isShowGeneralAccount: 'نمایش درگاه عمومی برای کاربران',
            organizationDocuments: 'نوع سند',
            defineNewUser: 'تعریف کاربر جدید',
            isCanSeePublicParentPhonebook: 'نمایش دفترتلفن های عمومی والد',
            isSendAlertToOrganizationAdmin: 'ارسال هشدار برای مدیر سازمان',
            isSendAlertForCreateSmartSmsRequest:
              'ارسال هشدار برای ایجاد درخواست پیامک هوشمند',
            isSendOrganizationExpirationAlertMessage:
              'ارسال پیام هشدار انقضای سازمان',
            isSendAlertForCreateOnlinePayment:
              'ارسال هشدار برای ایجاد پرداخت آنلاین',
            isSendAlertForCreatePayment: 'ارسال هشدار برای ایجاد پرداخت',
            isPostpaid: 'پس پرداخت',
            isCanSendExtraReceivers: 'امکان ارسال به گیرندگان اضافی',
            isCanSetMultipleMobileForUser:
              'امکان تعریف چند شماره موبایل برای کاربر',
            enableSystemDefaultTag: 'فعال بودن تگ پیش فرض',
          },
          legends: {
            generalInformation: 'اطلاعات عمومی',
            systemInformation: 'اطلاعات سیستمی',
            organizationAdminUser: 'مدیر پنل',
          },
        },
        organizationAuthentication: {
          title: 'احراز هویت سازمان ',
          form: {
            addTitle: ' فرم احراز هویت سازمان',
            legend: 'احراز هویت سازمان',
            fields: {
              organizationDocuments: 'نوع سند ',
              documentStatus: 'وضعیت سند ',
              image: 'تصویر سند',
              description: 'توضیحات',
              BusinessLicense: 'تصویر مجوز کسب و کار',
              FoundedAnnounce: 'تصویر اطلاعیه ی تاسیس',
              LatestChangesAnnounce: 'تصویر اعلام آخرین تغییرات',
              CeoNationalCard: 'تصویر کارت ملی مدیرعامل',
              CeoBirthCertificate: 'تصویر شناسنامه مدیر عامل',
              OptionalField1: 'تصویر فیلد دلخواه 1',
              OptionalField2: 'تصویر فیلد دلخواه 2',
            },
          },
        },
        organizationDocumentation: {
          title: 'مدارک سازمان',
          form: {
            addTitle: 'تایید احراز هویت',
            legend: 'فرم تایید احراز هویت',
            fields: {
              isAuthenticated: 'تایید احراز هویت ',
              organizationDocuments: 'نوع سند',
              description: 'توضیحات',
              status: 'وضعیت',
              documentStatus: 'وضعیت فایل',
              organizationDocument: 'نوع فایل',
            },
          },
        },
        organizationResellers: {
          title: 'فروشندگان سازمان',
        },
        deleteOrganization: 'حذف سازمان',
        deleteOrganizationWihDescendantList: 'حذف سازمان و تمامی زیر مجموعه ها',
      },
      organizationCustomFields: {
        title: 'فیلدهای سفارشی',
        form: {
          addTitle: 'فیلد جدید',
          editTitle: 'ویرایش فیلد',
          legend: 'اطلاعات فیلد',
          fields: {
            CustomFieldTypes: 'نوع ',
            nameEn: 'نام انگلیسی ',
            nameFa: 'نام فارسی ',
          },
        },
      },
      users: {
        name: 'لیست کاربران',
        title: 'لیست کاربران',
        increaseUserCreditTitle: 'افزایش اعتبار کاربر',
        decreaseUserCreditTitle: 'کاهش اعتبار کاربر',
        usersExcel: 'دانلود فایل اکسل کاربران',
        addBtns: {
          addSingle: 'افزودن تکی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        importfromfile: {
          title: 'افزودن از فایل',
          downloadSample: 'دانلود فایل نمونه',
          uploadAddDescription:
            '<p class="tw-mt-3 tw-mb-1">⁃فایل هایی با پسوند <b>{{fileType}}</b> مجاز به آپلود می باشند.</p><p class="tw-my-1">⁃دقت بفرمایید که سطر اول فایل اکسل خوانده نمی شود بنابراین می بایست از آن برای درج عنوان استفاده کنید.</p><p class="tw-my-1">⁃جهت دریافت نمونه فایل <a class="tw-font-bold tw-cursor-pointer text-info" href="/assets/media/sample/importUsers.xlsx"download="sampleUsers.xlsx" id="linkIdSampleUsers"> اینجا </a>کلیک کنید.</p><p class="tw-mt-3 tw-mb-1">⁃در صورتی که سازمانی انتخاب نشود، سازمان فعلی به عنوان سازمان کاربران در نظر گرفته می‌شود.</p> <p class="tw-my-1 tw-font-medium">⁃دقت فرمایید در فایل اکسل، برای کاربر در<b class="text-danger"> سطر اول</b>، اطلاعات فیلدهای اختیاری را با اطلاعات مورد نیاز و یا خط تیره(-) پر کنید.</p>',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            userName: 'نام کاربری',
            nationalCode: 'کدملی/شناسه اتباع',
            identityNumber: 'شماره شناسنامه',
            firstName: 'نام',
            lastName: 'نام خانوادگی',
            fatherName: 'نام پدر',
            email: 'ایمیل',
            password: 'کلمه عبور',
            isForeigner: 'اتباع خارجی',
            zipCode: 'کدپستی',
            phone: 'تلفن ثابت',
            mobile: 'شماره موبایل',
            faxNumber: 'شماره فکس',
            address: 'آدرس',
            zoneId: 'شهر',
            birthDate: 'تاریخ تولد',
            expireDate: 'تاریخ انقضا',
            isActiveSend: 'ارسال فعال',
            descriptions: 'توضیحات',
            isDefault: 'پیش فرض',
            roleTemplateId: 'قالب نقش',
            isActive: 'فعال',
          },
        },
        form: {
          addTitle: ' کاربر جدید',
          editTitle: 'ویرایش اطلاعات کاربر',
          fields: {
            foreignerCode: 'کد اتباع',
            zoneId: 'منطقه',
            password: 'کلمه عبور',
            secondPassword: 'کلمه عبور دوم',
            isAdmin: 'مدیر',
            isAuthenticatedMobile: 'تایید موبایل',
            roleTemplateId: 'قالب نقش',
            nationalCode: 'کدملی/کداتباع',
            isSendSmsDescriptionRequired:
              'اجباری بودن توضیحات موقع ارسال کاربران',
            isCanSeeContactsOfPublicPhonebooks:
              'نمایش شماره گروه دفترتلفن عمومی',
            isCanSeeContactsOfPrivatePhonebooks:
              'نمایش شماره گروه دفترتلفن خصوصی',
            isCanSendSmartWithoutConfirmation: 'امکان ارسال هوشمند بدون تایید',
          },
          legends: {
            personalInformation: 'مشخصات کاربری',
            systemInformation: 'مشخصات سیستمی',
            authentication: 'احراز هویت ',
            roleInformation: 'نقش ها',
          },
        },
        userInfo: {
          title: 'احرازهویت کاربران',
          userAuthentication: {
            title: 'احراز هویت کاربران ',
            form: {
              addTitle: 'فرم احراز هویت کاربر ',
              legend: ' احراز هویت کاربر',
              fields: {
                BirthCertificate: 'شناسنامه',
                NationalCard: 'کارت ملی',
                OptionalField1: 'فیلد دلخواه 1',
                OptionalField2: 'فیلد دلخواه 2',
                documentStatus: 'وضعیت سند ',
                description: 'توضیحات',
              },
            },
          },
          userDocumentation: {
            title: 'مدارک کاربر',
            form: {
              addTitle: ' تایید احراز هویت ',
              legend: ' فرم تایید احراز هویت',
              fields: {
                isAuthenticated: 'تایید احراز هویت ',
                userDocuments: 'نوع سند',
                description: 'توضیحات',
                status: 'وضعیت',
                documentStatus: 'وضعیت فایل',
              },
            },
          },
        },
        personalInfo: {
          name: 'اطلاعات کاربری',
          title: 'اطلاعات کاربری',
          editTitle: 'ویرایش اطلاعات شخصی',
          organizationalInfo: 'اطلاعات سازمانی',
          personalInfo: 'اطلاعات شخصی',
          foreigner: 'اتباع خارجی',
          isForeigner: 'اتباع خارجی هستم ',
          foreignerCode: 'کد اتباع',
          firstAlert:
            'کاربر گرامی ، جهت ادامه فرآیند لازم است اطلاعات شخصی خود را تکمیل نمایید .',
          secondAlert:
            'اطلاعات شما با موفقیت ثبت شد .حداکثر تا 48 ساعت آینده نتیجه نهایی به شما اطلاع داده خواهد شد .',
        },
      },
      activeSessions: {
        title: 'نشست های فعال',
      },
      formBuilderResponses: {
        responsesExcel: 'اکسل پاسخ ها',
      },
      userImpersonated: {
        title: 'تاریخچه جعل هویت کاربر',
        form: {
          fields: {
            impersonatorUserName: 'کاربر جعل هویت کننده',
            impersonatorOrganizationName: 'سازمان کاربر جعل هویت کننده',
            impersonatedUserName: 'کاربر جعل هویت شده',
            impersonatedOrganizationName: 'سازمان جعل هویت شده',
          },
        },
      },
      valueOfPurchases: {
        title: 'آمار RFM',
        form: {
          fields: {
            totalPoint: 'مجموع امتیاز',
            points: 'امتیازات',
            totalUsedCredit: 'ارزش خرید',
            realUsedCredit: 'ارزش خرید واقعی',
            totalSentCount: 'تعداد ارسال',
            realSentCount: 'تعداد ارسال واقعی',
            totalSentParts: 'تعداد بخش',
            realSentParts: 'تعداد بخش واقعی',
            sendSmsFrequency: 'تناوب ارسال',
            isRecentSendSmsDifferenceTillNowMoreThanFrequency:
              'اختلاف آخرین ارسال بیشتر از تناوب',
            recentSendSms: 'تاریخ و زمان آخرین ارسال',
            recentSendDifferenceWithFrequencyStatus:
              'وضعیت آخرین ارسال نسبت به تناوب',
            usedCreditPerEachFrequency: 'ارزش خرید به ازای هر تناوب',
          },
        },
      },
      userValueOfPurchasePoints: {
        title: ' امتیازات آمار RFM',
        form: {
          legend: 'امتیاز',
          addTitle: 'امتیاز جدید',
          editTitle: 'ویرایش امتیاز',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userValueOfPurchaseStrategies: {
        title: ' استراتژی های آمار RFM',
        form: {
          legend: 'استراتژی',
          addTitle: 'استراتژی جدید',
          editTitle: 'ویرایش استراتژی',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userPoints: {
        title: 'امتیازات کاربران',
        form: {
          fields: {
            totalPoint: 'مجموع امتیاز',
            points: 'امتیازات',
          },
        },
      },
      alertSetting: {
        title: 'تنظیم اعلان',
        legend: 'تنظیمات',
        form: {
          fields: {
            isEnableSendNotification: 'ارسال اعلان فعال باشد؟',
            daysOfSendFrequencyPeriod: 'تعداد روزهای دوره',
            importanceLevel: 'سطح اهمیت اعلان ها',
            fromDaysMoreThanSendFrequently: 'از چند روز بیشتر از تناوب',
            toDaysMoreThanSendFrequently: 'تا چند روز بیشتر از تناوب ',
          },
        },
      },
      financial: {
        newPayment: {
          invoice: {
            sellerSpecifications: 'مشخصات فروشنده',
            customerSpecifications: 'مشخصات خریدار',
            finalPayment: 'پرداخت نهایی',
            totalAmountRial: 'کل مبلغ (ريال)',
            realLegalPersonName: 'نام شخص حقیقی / حقوقی',
            valueAddedTaxRial: 'ارزش افزوده (ريال)',
            invoiceIssuance:
              'اعتبار این پیش فاکتور به مدت یک روز از تاریخ صدور می باشد',
            noLegalValue:
              'فاقد ارزش و اعتبار حقوقی جهت اعلام و درج در سایت های امور مالیاتی ، دارایی ، بیمه و ... می باشد',
            parliamentTax: 'بند ز مصوب مجلس (ريال)',
          },
        },
      },
      userPasswordHistory: {
        title: 'تاریخچه کلمه عبور کاربر',
        form: {
          fields: {
            createdUserName: 'ویرایش کننده',
          },
        },
      },
      userLogins: {
        title: 'تاریخچه ورودهای کاربر',
      },
      smartDetail: {
        title: 'جزئیات درخواست ارسال هوشمند',
      },
      assignNumbers: {
        title: 'تخصیص خطوط',
        assignPrivateNumbers: {
          title: 'اختصاص خطوط اختصاصی ',
        },
        publicReceiveKeywords: {
          title: 'اختصاص خطوط عمومی',
          form: {
            editTitle: 'ویرایش اختصاص خط عمومی ',
            addTitle: 'اختصاص خط عمومی',
            legend: 'اطلاعات خط عمومی',
          },
        },
        privateReceiveKeywords: {
          title: 'اختصاص خطوط با کلمه کلیدی ',
          form: {
            editTitle: 'ویرایش اختصاص خطوط با کلمه کلیدی',
            addTitle: 'اختصاص با کلمه کلیدی جدید',
            legend: 'اطلاعات خط اختصاصی',
          },
        },
        privateNumberSendLimit: {
          title: 'اختصاص خط به کاربر',
          form: {
            editTitle: 'ویرایش اختصاص خط به کاربر',
            addTitle: 'اختصاص خط جدید به کاربر ',
            legends: {
              general: 'اطلاعات اختصاص خط به کاربر',
              sendTypesList: 'نوع ارسال',
              users: 'کاربران',
              privateNumbers: 'شماره های اختصاصی',
            },
            fields: {
              canSeeReceivedSms: 'مشاهده ی پیام های دریافتی',
            },
          },
        },
      },
      transferPrivateNumbers: {
        title: 'انتقال خطوط اختصاصی ',
        form: {
          editTitle: 'تغییر مالکیت',
          addTitle: 'تغییر مالکیت',
          legend: 'تغییر مالکیت خط اختصاصی',
          fields: {
            numberType: 'نوع خط',
            newOwner: 'مالک جدید',
            preOwner: 'مالک قبلی',
            privateNumber: 'شماره اختصاصی',
            TransferDateTime: 'تاریخ انتقال خط',
          },
        },
      },
      inboxGroups: {
        title: 'گروه صندوق دریافت',
        form: {
          editTitle: 'ویرایش گروه صندوق دریافت',
          addTitle: 'گروه صندوق دریافت جدید',
          legend: 'گروه صندوق دریافت',
          fields: {
            inboxGroupName: ' نام گروه صندوق دریافت',
          },
        },
      },
      inboxes: {
        title: 'صندوق دریافت',
        organizationInboxesTitle: ' صندوق دریافت سازمان ',
        usersInboxesTitle: ' صندوق دریافت کاربران ',
        addToInboxGroup: 'افزودن به گروه',
        inboxesExcel: 'اکسل صندوق دریافت',
        form: {
          editTitle: 'ویرایش صندوق دریافت',
          addTitle: ' صندوق دریافت جدید',
          legend: 'صندوق دریافت',
          changeStatusTitle: 'تغییر وضعیت',
          fields: {
            inboxGroupName: ' نام گروه صندوق دریافت',
            organizationName: 'نام سازمان',
            receiverNumber: 'شماره گیرنده',
            senderMobile: 'شماره فرستنده',
            Encoding: 'پیام Encoding',
            smsParts: 'تعداد بخش',
            smsText: 'متن پیام',
            isRead: 'خوانده شده',
            dateTimeReceive: 'زمان دریافت',
          },
        },
      },
      customPlace: {
        title: 'مکان های شخصی',
        form: {
          editTitle: 'ویرایش مکان شخصی',
          addTitle: ' مکان شخصی جدید',
          legend: 'مکان شخصی',
          customPlaceCreated: 'مکان شخصی ذخیره شد',
          dialogs: {
            polygonAtLeaseMostHave3Point:
              'برای ثبت یک محدوده جغرافیایی می بایست حداقل سه نقطه را در نقشه انتخاب کرده باشید',
          },
          fields: {
            deletedAt: 'تاریخ حذف',
            coordinates: 'مختصات',
            deletedBy: 'حذف کننده',
            isActive: 'فعال',
            parentName: 'والد',
            geometryType: 'نوع مکان',
            cityName: 'شهر',
            provinceName: 'استان',
          },
        },
      },
      groupPrice: {
        title: 'بازه‌ ها',
        titleWithCategoryName: 'لیست بازه های {{categoryName}}',
        groupPriceCategories: {
          title: 'تعرفه ها',
          categoryName: 'نام تعرفه',
          groupPriceCount: 'تعداد بازه‌ ها',
          form: {
            addTitle: 'تعرفه جدید',
            editTitle: 'ویرایش تعرفه',
          },
        },
        form: {
          legend: 'اطلاعات بازه',
          editTitle: 'ویرایش بازه',
          addTitle: 'بازه جدید',
          fields: {
            mtnSmartPercent: 'درصد تعرفه ارسال هوشمند ایرانسل',
            rightelSmartPercent: 'درصد تعرفه ارسال هوشمند رایتل',
            mciSmartPercent: 'درصد تعرفه ارسال هوشمند همراه اول',
            copyGroupPrice: 'کپی تعرفه',
            isPercentageBenefitForInternational:
              'آیا تعرفه بین الملل، درصدی است؟',
            internationalBenefitValuePercent: 'درصد سود بین الملل',
            internationalBenefitValue: 'مقدار سود بین الملل ',
          },
        },
        detailForm: {
          title: 'جزئیات بازه',
          legend: 'جزئیات بازه',
          editTitle: 'ویرایش جزئیات بازه',
          addTitle: 'جزئیات بازه جدید',
        },
        socialMediaDetailForm: {
          title: 'جزئیات بازه',
          legend: 'جزئیات بازه',
          editTitle: 'ویرایش جزئیات شبکه های اجتماعی بازه',
          addTitle: 'جزئیات بازه شبکه های اجتماعی جدید',
        },
      },
      myGroupPriceDetails: {
        title: 'تعرفه من',
      },
      sendSmsFromMap: {
        title: 'ارسال  پیامک از نقشه(شماره آپدیت)',
        title2: 'ارسال پیامک از نقشه',
        fields: {
          selectCity: 'انتخاب شهر',
          selectPostalCode: 'انتخاب کد پستی',
          selectMessageSettings: 'تنظیمات ارسال',
          regionSettings: 'تنظیمات ارسال منطقه',
          detailOfSendingRegions: 'نمایش مناطق ارسالی',
          Irancell: 'ارسال به ایرانسل',
          total: 'تعداد کل',
          count: 'تعداد ارسال',
          startFrom: 'ارسال از شماره',
          simpleCount: 'تعداد ارسال',
          simpleStartFrom: 'از',
          hamrahAval: 'ارسال به همراه اول',
          totalSendCount: 'مجموع تعداد ارسال',
          acceptAndNext: 'مرحله بعد',
        },
      },
      baseSendSms: {
        legends: {
          messageInformation: 'مشخصات پیامک',
          sendDateTimeType: 'تنظیمات ارسال',
        },
        fields: {
          receivers: 'گیرندگان',
          sendDay: 'روز ارسال',
          sendHour: 'ساعت ارسال',
          startDay: 'روز شروع',
          endDay: 'روز پایان',
          startHour: 'ساعت شروع',
          endHour: 'ساعت پایان',
          sendDirect: 'ارسال مستقیم',
          typeSend: 'نوع ارسال',
          sendPeriod: 'ارسال دوره‌ای',
          sendGradual: 'ارسال تدریجی',
          periodText: 'هر چند {{type}} یکبار',
          everyFewMinutes: 'هر چند دقیقه',
          numberOfSubmissions: 'تعداد ارسالی',
        },
        justSendToWhiteList: 'فقط ارسال به لیست سفید',
        isFlashSms: 'ارسال فلش',
        gradualAlert: 'حداقل تعداد گیرندگان می بایست 1000 شماره باشد .',
        fastSend: 'ارسال سریع',
        sendSms: 'ارسال پیامک',
        editSendSms: 'ویرایش ارسال',
        warningMessageBeforeClosingEditPage:
          ' کاربر گرامی با بستن این صفحه ، ارسال شما متوقف خواهد شد و امکان ویرایش مجدد امکان پذیر نمی باشد . با این وجود آیا مایل به بستن این صفحه هستید ؟',
      },
      sendSMS: {
        title: 'ارسال پیامک',
        editTitle: 'ویرایش ارسال',
        fields: {
          receivers: 'گیرندگان',
        },
        legends: {
          receivers: 'گیرندگان',
          phonebook: 'دفترچه تلفن',
          sendDateTime: 'زمان ارسال',
        },
        sendSms: 'ارسال پیامک',
        addReceivers: 'افزودن شماره',
        removeReceivers: 'حذف شماره',
        missive: 'شماره های حذفی',
      },
      sendSMSWithPhonebook: {
        title: 'ارسال پیامک با دفترچه تلفن',
        editTitle: 'ویرایش ارسال پیامک با دفترچه تلفن ',
        legends: {
          phonebook: 'دفترچه تلفن',
        },
      },
      sendBalkSms: {
        title: 'ارسال انبوه (شماره آپدیت)',
        title2: ' ارسال انبوه  ',
        titlePostalCode: 'ارسال منطقه ای',
        editTitle: 'ویرایش ارسال انبوه ',
        fields: {
          state: 'استان',
          city: 'شهر',
          region: 'منطقه',
          businessGroup: 'گروه مشاغل',
          businessSubGroup: 'زیر گروه مشاغل',
          sendToRegionDetails: 'انتخاب گیرندگان',
          totalMobileNumber: 'تعداد کل شماره ها',
          totalSmsSendOnStep: 'تعداد ارسال',
          startFromOnStep: 'ارسال از شماره',
          mobilePrefixOnStep: 'پیش شماره',
          mobileType: 'نوع شماره ',
          permanentNumber: 'دائمی',
          creditNumber: 'اعتباری',
          id: 'شناسه ',
          operatorType: 'اپراتور',
          hamrahAval: 'همراه اول',
          irancell: 'ایرانسل',
          postalCode: 'کد پستی',
          zonePostalCode: 'کدپستی مناطق',
          gender: 'جنسیت',
          male: 'آقا',
          female: 'خانم',
          none: 'خالی',
          calculateTotalCount: 'محاسبه تعداد شماره',
          addToQueries: 'افزودن',
          selectBalkQueries: 'انتخاب شماره های ارسالی',
          selectMessageSettings: 'تنظیمات ارسال',
          senderNumberId: 'فرستنده',
          sendDateTime: 'زمان ارسال',
          smsBody: 'متن پیام',
          smsBodyWithSignature: 'متن پیامک با امضا',
          receivers: 'گیرندگان',
          sendHour: 'ساعت ارسال',
          sendDay: 'روز ارسال',
          startDay: 'روز شروع',
          endDay: 'روز پایان',
          startHour: 'ساعت شروع',
          endHour: 'ساعت پایان',
          sendPeriod: 'ارسال دوره‌ای',
          sendGradual: 'ارسال تدریجی',
          typeSend: 'نوع ارسال',
          periodText: 'هر چند {{type}} یکبار',
          sendingRegion: 'محدوده ارسال',
          asIfStartWith: 'پیش شماره %s ',
          postalCodeContains: 'کد پستی  %s',
          acceptAndNext: 'مرحله بعد',
          totalCountOfSendingSms: 'تعداد کل پیامک هایی که ارسال می‌شود',
        },
        errors: {
          emptyRegion: 'با تنظیمات انتخابی شما شماره ای در سیستم ثبت نشده است',
          smsCountBiggerThanTotal:
            'تعداد انتخابی از رکوردی که برای شروع انتخاب کرده اید بیشتر از کل شماره ها می باشد',
          pleaseEnterValidDateForSend:
            'لطفاً اطلاعات صحیحی برای ارسال وارد نمایید',
          firstSelectWhereToSendSms:
            'ابتدا انتخاب نمایید به کجا می خواهید پیامک ارسال کنید',
          mostSelectAtLeastState:
            'توجه داشته باشید حداقل می بایست یک استان را برای ارسال پیامک انتخاب نمایید',
          mostSelectAtLeastSimType:
            'توجه باشید حداقل می بایست مشخص نمایید می خواهید به چه نوع سیم کارتی پیامک ارسال شود',
        },
      },
      campaigns: {
        title: 'کمپین ها',
        form: {
          addTitle: 'کمپین جدید',
        },
      },
      sendQueue: {
        title: 'صف ارسال سازمان',
        usersTitle: 'صف ارسال کاربران',
        userTitle: 'صف ارسال کاربر',
        resellerTitle: 'صف ارسال فروشنده',
        fields: {
          id: 'شناسه',
          smsText: 'پیامک',
          failureCode: 'خطا ',
          sendType: 'نوع ارسال',
          sendSubType: 'نوع زمان ارسال ',
          senderNumber: 'فرستنده',
          recipientCount: 'تعداد گیرندگان',
          mciCount: 'همراه اول',
          mtnCount: 'ایرانسل',
          rightelCount: 'رایتل',
          otherCount: 'سایر',
          campaign: 'کمپین',
          sendPrice: 'هزینه ارسال کل',
          resolutionOfParliamentPrice: 'مصوبه مجلس',
          resolutionPrice: 'هزینه ارسال بدون مصوبه',
          pageSize: 'سایز صفحه',
          pageIndex: 'اندیس صفحه',
          fromIndex: 'از اندیس',
          zipCode: 'کد پستی',
          periodType: 'نوع ارسال دوره ای',
          period: 'دوره ای',
          dateTimeStart: 'شروع ارسال',
          dateTimeEnd: 'پایان ارسال',
          dateTimeNext: 'ارسال بعدی',
          dateTimeSend: 'زمان ارسال',
          smsCount: 'تعداد بخش',
          smsParts: 'تعداد بخش',
          operatorNumberCount: ' تعداد اپراتور ',
          blackListCount: 'تعداد لیست سیاه ',
          wrongNumberCount: 'تعداد شماره های اشتباه',
          socialMediaApplicationName: 'برنامه شبکه اجتماعی',
          socialMediaFileTitle: 'فایل شبکه اجتماعی',
          isFlashSms: 'ارسال فلش',
          internationalCount: ' بین الملل',
          processTextResults: 'تحلیل پیامک',
          p2PIsSendDuplicateNumber: 'ارسال با شماره های تکراری نظیر به نظیر',
        },
        detail: {
          title: 'جزئیات ارسال',
        },
        receivers: {
          title: 'لیست گیرندگان ',
          toNumber: 'شماره گیرنده',
          deliveryStatus: 'وضعیت تحویل',
          sendStatus: 'وضعیت ارسال',
          statusDateTime: 'تاریخ وضعیت ',
          receiversExcel: 'دانلود اکسل',
          sendDateTime: 'تاریخ ارسال',
        },
        sendBulkDetails: {},
      },
      createSmartSmsRequest: {
        title: 'درخواست ارسال هوشمند',
        legends: {
          requestProperties: 'مشخصات درخواست',
          publicProperties: 'مشخصات عمومی ارسال',
          requestPublicPlace: 'منطقه مد نظر جهت ارسال',
        },
        errors: {
          forceToEnterDatePeriod: 'انتخاب بازه زمانی حضور اشخاص الزامی می باشد',
          mostSelectPolygon:
            ' حداقل می بایست یک محدوده را در نقشه تعیین نمایید یا مختصات مناطق را در فیلد مختصات مناطق موردنظر وارد کنید',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
          titleIsRequired: 'عنوان الزامی است',
        },
        messages: {
          hint: 'بسته به شهر و استان انتخابی، میتوانید حداکثر بازه ی یک ساعته انتخاب کنید. برای استان ها و شهرهای بزرگ زیر 5 دقیقه و برای استان و شهر های کوچک میتوانید حداکثر تا یک ساعت بازه ی زمانی انتخاب کنید. ',
        },
        dialogs: {
          polygonAtLeaseMostHave3Point:
            'برای ذخیره محدوده جغرافیایی می بایست حداقل سه نقطه را در نقشه انتخاب کرده باشید',
        },
        horizontalAccordion: {
          workplace: 'محل کار (اقامت روز)',
          home: 'منزل (اقامت شب)',
          bankProfile:
            'پروفایل بانکی (بر اساس سرشماره پیامک های دریافتی از بانک ها)',
          jobProfile: 'پروفایل شغل',
          travelProfile: ' پروفایل سفر (داخلی/خارجی)',
          customerClub: 'باشگاه مشتریان',
          profile:
            'پروفایل بیشترین تماس و پیامک ورودی/خروجی از یک یا چند شماره خاص',
          hobbies: 'علاقمندی ها (ورزشی، خرید، سفر، ...)',
        },
        filters: {
          title: 'فیلترها',
          gender: 'جنسیت',
          age: 'سن',
          deviceType: 'نوع دستگاه',
          deviceBrand: 'برند دستگاه',
          eghamatgah: 'اقامتگاه',
          gardeshgari: 'گردشگری',
          bankProfile: 'پروفایل بانکی',
          jobs: 'پروفایل شغلی',
          favorites: 'علاقه مندیها',
          ertebatat: 'ارتباطات بر بستر مخابراتی',
          artisticCulture: 'فرهنگی هنری',
          artists: 'هنرمندان',
          writers: 'نویسندگان',
          reporters: 'خبرنگاران',
          actors: 'بازیگران',
          publishers: 'ناشرین',
          notImplemented: 'در حال حاضر این فیلتر غیر فعال می باشد',
          mobilePrefix: 'پیش شماره',
        },
        enterPublicPlaceName: 'نام گذاری منطقه انتخابی',
        publicPlaceName: 'نام مکان عمومی',
        publicPlaceCreated: 'مکان عمومی ذخیره شد',
        deviceTypes: 'نوع دستگاه',
        deviceBrands: 'برند دستگاه',
        requestName: 'عنوان درخواست',
        ageFrom: 'از سن',
        ageTo: 'تا سن',
        residenceState: 'محل سکونت',
        joberState: 'محل فعالیت شغلی',
        travellerState: 'ارسال به مسافرین',
        travellerProvinces: 'استان مبدا مسافر',
        periodicSmartSms: 'کمپین ارسال هوشمند',
        isShowGrayListExpireHour: 'در نظرگرفتن شماره ی تکراری',
        timingOfRepetitions: 'زمان بندی تکراری ها (ساعت)',
        grayListExpireHour: 'تا چند ساعت، شماره ای تکراری در نظر گرفته شود؟',
        smartRequestType: 'نوع درخواست ارسال هوشمند',
        club: 'باشگاه مشتریان',
        operationType: 'نوع عملیات',
        cellList: 'لیست سلولی',
        mobilePrefix: 'پیش شماره',
        deviceModels: 'مدل دستگاه',
      },
      confirmSmartSmsRequest: {
        title: 'ارسال پیامک هوشمند',
        legends: {
          smsPart: 'تنظیمات پیامک',
          requestData: 'مشخصات دریافت کنندگان',
          requestPublicPlace: 'منطقه مد نظر جهت ارسال',
          publicMap: 'منطقه انتخابی',
          yourCampaignFrom: 'کمپین مد نظر شما از تاریخ ',
          untilDate: 'تا تاریخ ',
          period: 'دوره',
          runAnd: 'اجرا شده و',
          person: 'نفر',
          ofTheTargetNumbersWillReceiveSMS:
            'از شماره های مد نظر پیامک را دریافت میکنند',
          every: 'هر',
        },
        errors: {
          couldNotEditRequest:
            'درخواست شما در وضعیتی نیست که شما بتوانید اطلاعات آن را تایید یا رد نمایید.',
          pleaseWaitUntilTheRequestStateChanged:
            'لطفاً تا تغییر وضعیت درخواست منتظر بمانید.',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
        },
        dialogs: {},
        fields: {
          sendDay: 'تاریخ ارسال',
          sendHour: 'ساعت ارسال',
          sentDelayType: 'نوع ارسال',
          sentDelayValue: 'زمان پس از دریافت',
          percentageToSend: 'درصد ارسال',
          countToSend: 'تعداد ارسال',
          sendCountType: 'نوع محاسبه تعداد ارسال',
          percentage: 'درصد',
          count: 'تعداد',
          maxSendCount: 'حداکثر تعداد ارسال کمپین هوشمند',
          maxDailySendCount: 'سقف تعداد روزانه',
          socialMediaApplicationName: 'برنامه شبکه اجتماعی',
          socialMediaFileTitle: 'فایل شبکه اجتماعی',
        },
        filter: {
          yourMessageSendTo:
            'پیامک شما برای افرادی با مشخصات زیر در محدوده های انتخابی ارسال خواهد شد:',
          sent: 'در محدوده های انتخابی ارسال خواهد شد',
        },
        periodTypeValue: 'واحد زمان',
        periodText: 'تکرار هر :',
        UsePercentage: 'استفاده از درصد',
        count: 'مقدار',
        createCampain: 'ایجاد و اجرای کمپین',
        editCampaign: ' ویرایش کمپین',
      },
      smsTemplate: {
        title: 'الگوی پیامک',
        form: {
          addTitle: 'الگوی پیامک جدید',
          editTitle: 'ویرایش الگوی پیامک',
        },
      },
      smsTemplateGroup: {
        title: 'گروه الگوی پیامک',
        form: {
          editTitle: 'ویرایش گروه الگوی پیامک',
          addTitle: 'گروه الگوی پیامک جدید',
        },
      },
      accountInformation: {
        title: 'حساب ها',
        form: {
          editTitle: 'ویرایش شماره حساب',
          addTitle: 'شماره حساب جدید',
          legend: 'اطلاعات حساب',
          fields: {
            accountNo: 'شماره حساب',
            branch: 'شعبه',
            cardNo: 'شماره کارت',
            iban: 'شماره شبا',
            owner: 'مالک ',
          },
        },
      },
      bankOnlineGateways: {
        title: 'درگاه‌های پرداخت',
        form: {
          bankOnlineGatewaysForm: 'اطلاعات درگاه پرداخت',
          editTitle: 'ویرایش درگاه پرداخت',
          addTitle: 'درگاه پرداخت جدید',
          fields: {
            accountInformationId: 'شماره حساب',
            accountInformationOwner: 'مالک شماره حساب',
            typeIPG: 'نوع درگاه پرداخت اینترنتی',
            configJson: 'تنظیمات',
            isGeneralUse: 'استفاده عمومی',
            isFactorUse: 'استفاده از فاکتور',
          },
        },
      },
      zones: {
        title: 'مناطق',
        form: {
          editTitle: 'ویرایش منطقه',
          addTitle: 'منطقه جدید',
          legends: {
            generalSettings: 'تنظیمات کلی',
            mapSetting: 'تنظیمات نقشه',
          },
        },
        newCountry: 'کشور جدید',
        newState: 'استان جدید',
        newCity: 'شهر جدید',
        newArea: 'منطقه جدید',
        editCountry: 'ویرایش کشور',
        editState: 'ویرایش استان',
        editCity: 'ویرایش شهر',
      },
      roles: {
        title: 'نقش ها',
        cloneRole: 'کپی نقش',
        form: {
          editTitle: 'ویرایش نقش',
          addTitle: 'نقش جدید',
          cloneTitle: 'کپی نقش',
          legend: 'دسترسی ها',
          editRoleConfirmation: {
            inRole: 'در نقش',
            theFollowingChangesWillBeApplied: 'تغییرات زیر اعمال خواهد شد ',
            accessIsRemoved: 'دسترسی حذف می شود ',
            theOrganizationIsDeleted: 'سازمان حذف می شود ',
            listOfOrganizationsToBeDeleted: 'سازمان هایی که حذف می شوند ',
            description1:
              'با حذف این موارد در تمامی زیرگروه ها و داده های ذخیره شده مرتبط نیز اعمال خواهد شد ',
            enterTheNumberBelowToConfirmTheChanges:
              'جهت تایید تغییرات عدد زیر را وارد کنید ',
          },
        },
        userRoles: {
          title: 'تخصیص نقش به کاربران',
        },
      },
      roleTemplates: {
        title: 'قالب های آماده برای نقش ها',
        form: {
          editTitle: 'ویرایش قالب نقش',
          addTitle: 'قالب نقش جدید',
          legend: 'دسترسی ها',
          secondStep: {
            title:
              'در صورت فعال کردن دکمه ی زیر نقش هایی که برای این قالب نقش ساخته شده اند تغییر میکنند',
            isChangeRoles: 'آیا نقش ها تغییر کند؟',
          },
        },
        organizationRoles: {
          title: 'تخصیص قالب نقش به سازمان ها',
        },
      },
      guilds: {
        title: 'اصناف',
        form: {
          editTitle: 'ویرایش صنف',
          addTitle: 'صنف جدید',
          legend: 'اطلاعات صنف',
        },
      },
      kibanaDashboards: {
        title: 'داشبوردهای kibana',
        form: {
          editTitle: 'ویرایش داشبورد',
          addTitle: 'داشبورد جدید',
          legend: 'اطلاعات داشبورد',
        },
      },
      refundDeliveryStatus: {
        title: 'وضعیت های برگشت هزینه',
        form: {
          editTitle: 'ویرایش وضعیت های برگشت هزینه',
          addTitle: 'وضعیت های برگشت هزینه جدید',
          legend: 'اطلاعات وضعیت های برگشت هزینه',
          fields: {
            deliveryStatuses: ' وضعیت تحویل',
          },
        },
      },
      resellers: {
        title: 'فروشندگان',
        form: {
          editTitle: 'ویرایش فروشنده',
          addTitle: 'فروشنده جدید',
          legend: 'اطلاعات فروشنده',
          fields: {
            reseller: 'فروشنده',
            pricePerSms: 'مبلغ به ازای هر پیامک',
            panelPercent: 'درصد پنل',
            target: 'هدف فروش',
          },
        },
        resellers: {
          title: 'لیست فروشندگان',
        },
        resellerOrganizations: {
          title: 'سازمان های فروشنده',
        },
      },
      resellersTarget: {
        title: 'هدف فروشنده',
        form: {
          editTitle: 'ویرایش هدف فروشنده',
          addTitle: 'هدف فروشنده جدید ',
          legend: ' هدف فروشنده ',
          fields: {
            times: 'زمان',
            targetValue: 'هدف(تعداد پیامک)',
            credit: 'هدف(مبلغ نهایی)',
          },
        },
      },
      systemSetting: {
        title: 'تنظیمات سیستم',
        form: {
          editTitle: 'ویرایش تنظیمات سیستم',
          addTitle: 'تنظیمات جدید',
          legend: ' تنظیمات سیستم',
          description:
            'شما میتوانید در این فرم، تنظیمات مربوط به قسمت های مختلف پنل خود را مقداردهی کنید ',
        },
      },
      panelSetting: {
        title: 'تنظیمات پنل ',
        form: {
          editTitle: 'ویرایش تنظیمات',
          addTitle: 'تنظیمات جدید',
          legend: 'تنظیمات',
          description:
            'شما میتوانید در این فرم، تنظیمات مربوط به قسمت های مختلف پنل خود را مقداردهی کنید ',
        },
      },
      creditNotification: {
        title: 'اطلاع رسانی اعتبار سازمان',
        form: {
          editTitle: 'ویرایش اعتبار سازمان ',
          addTitle: 'اعتبار سازمان جدید ',
          legend: 'اطلاع رسانی اعتبار سازمان',
          fields: {
            lastSendDateTime: 'تاریخ آخرین ارسال',
            isSend: 'ارسال شده',
            scheduledMessageId: 'شناسه آخرین ارسال',
          },
        },
      },
      otp: {
        title: 'قالب پیامک احرازهویت',
        form: {
          editTitle: 'ویرایش قالب پیامک ',
          addTitle: 'قالب پیامک جدید ',
          changeStatusTitle: 'تغییر وضعیت',
          code: '۱۲۳',
          name: 'علی',
          code2: 'کد {0}',
          name2: '{1} عزیز,',
          description: 'به پیشگام رایان خوش آمدید.',
          code3: 'کد 123',
          name3: 'علی عزیز,',
          legends: {
            specifications: 'قالب پیامک',
            help: 'راهنما',
          },
          messages: {
            description1:
              'پارامترهای متغیر در متن پیام را بصورت {#} وارد کنید ',
            description2:
              ' نوع # در مورد بالا عددی بوده و از 0 شروع می‌شود و به ترتیب افزایش می یابد {0},{1},{2},… ',
            description3:
              'هنگام ارسال پیام احرازهویت باید به تعداد پارامترهای متغیر تعریف شده در پیام، پارامتر ارسال شود',
            description4:
              ' برای ارسال { یا } در قالب پیامک، از {{ یا }} استفاده کنید',
            sampleOtp: 'نمونه قالب پیامک',
            sampleParameters: 'نمونه پارامترهای ارسالی برای پیامک بالا ',
            finalMessage: 'پیامک ارسالی به کاربر',
          },
          fields: {
            priority: 'اولویت',
            smsText: 'متن پیام',
            lastModified: 'تاریخ آخرین ویرایش',
            OtpStatus: 'وضعیت',
          },
        },
      },
      menus: {
        name: 'مدیریت منو',
        title: 'مدیریت منو',
        form: {
          editTitle: 'ویرایش منو',
          addTitle: 'منو جدید',
          legends: {
            generalMenu: 'مشخصات',
            helpMenu: 'راهنما',
          },
          fields: {
            route: 'مسیر',
            order: 'ترتیب',
            claim: 'دسترسی',
            class: 'کلاس',
            claims: ' دسترسی ها',
            helpText: 'متن راهنما',
            imageHelp: 'تصویر راهنما',
            videoHelp: 'ویدیوی راهنما',
            pdfHelp: 'فایل پی دی اف راهنما',
            fileHelp: 'فایل راهنما',
          },
        },
        uploadFileForm: {
          editTitle: 'ویرایش راهنما',
          addTitle: 'راهنما جدید',
          legend: 'راهنما ',
          fields: {
            helpFileType: 'نوع فایل',
            file: 'فایل',
          },
        },
      },
      help: {
        title: 'راهنما ',
        helpDetail: 'جزئیات راهنما',
      },
      organizationTransactions: {
        title: 'تراکنش ها ',
        resellerTransactionTitle: 'تراکنش های فروشنده',
        outboxTransactionsTitle: 'تراکنش های صندوق ارسال',
        transactionsDetailTitle: 'جزئیات تراکنش',
        resellerTransactionsDetailTitle: 'جزئیات تراکنش فروشنده',
        transactionsExcel: 'دانلود فایل اکسل تراکنش ها',
        resellerTransactionsExcel: 'دانلود فایل اکسل تراکنش های فروشنده',
        form: {
          editTitle: 'ویرایش تراکنش ',
          addTitle: 'تراکنش جدید',
          fields: {
            packageId: 'شناسه بسته',
            packageTitle: 'عنوان بسته',
            outboxId: 'شناسه صندوق ارسال ',
            paymentId: 'شناسه پرداخت',
            isIncrement: 'افزایشی',
            typeTransaction: 'نوع تراکنش',
            typeCreditChange: ' نوع تغییر اعتبار',
            currentCredit: 'اعتبار فعلی',
          },
          legend: 'اطلاعات تراکنش ',
        },
      },
      sendLimits: {
        title: 'محدودیت ارسال روی خط',
        form: {
          editTitle: 'ویرایش محدودیت ',
          addTitle: 'محدودیت جدید',
          legend: 'اطلاعات محدودیت',
          fields: {
            privateNumberNumber: 'خط',
            dailySendLimit: 'محدودیت ارسال در روز',
            monthlySendLimit: 'محدودیت ارسال در ماه',
          },
        },
      },
      allPrivateNumberSendLimit: {
        title: 'لیست خطوط کاربران',
        form: {
          fields: {
            sendTypesList: 'نوع ارسال',
            privateNumber: 'شماره اختصاصی',
            canSeeReceivedSms: ' مشاهده پیام ورودی',
          },
        },
      },
      automaticResend: {
        title: 'تنظیم ارسال مجدد خودکار',
        form: {
          editTitle: 'ویرایش تنظیم ',
          addTitle: 'تنظیم جدید',
          fields: {
            privateNumber: 'شماره ی اختصاصی',
            deliveryStatus: 'وضعیت تحویل',
            targetPrivateNumbers: 'خط فرستنده',
          },
          legend: 'اطلاعات تنظیم',
        },
      },
      payments: {
        title: 'لیست پرداخت ها',
        resellerTitle: 'لیست پرداخت های فروشنده',
        detail: 'جزئیات پرداخت',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
        paymentsExcel: 'دانلود فایل اکسل پرداخت ها',
        fields: {
          accountInformationId: 'حساب',
          accountInformationOwner: 'مالک حساب ',
          accountInformationAccountNo: 'شماره حساب',
          accountInformationCardNo: 'شماره کارت',
          accountInformationBank: 'بانک',
          paymentDate: 'تاریخ پرداخت',
          typePayment: 'نوع پرداخت',
          typeStatus: 'وضعیت پرداخت',
          billNumber: 'شماره سند',
          isOnlineGeneral: 'درگاه عمومی',
          createdBy: 'ایجاد کننده',
          orderId: 'شماره سفارش',
          adminResellerCode: 'کد نمایندگی ادمین',
          resellerCode: 'کد فروشنده',
          userFirstLastName: 'نام و نام خانوادگی کاربر',
          chequeImageAddress: 'تصویر چک',
          receiverOrganizationName: 'سازمان دریافت کننده',
          userName: 'کاربر پرداخت کننده',
          payerOrganizationName: 'سازمان پرداخت کننده',
          isHaveImage: 'تصویر دارد',
          smsCountPerPriceDescription: 'توضیحات تعداد پیامک',
          smsCount: 'تعداد پیامک',
          resolutionOfParliament: 'مصوبه مجلس',
          groupPriceDetailPrice: 'قیمت جزئیات تعرفه',
        },
      },
      paymentsForConfirm: {
        title: 'لیست پرداخت ها برای تایید',
        resellerTitle: 'لیست پرداخت ها برای تایید فروشنده',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
      },
      newPayment: {
        title: 'افزایش موجودی ',
        legend: 'مشخصات پرداخت',
        publicPaymentGateway: 'درگاه پرداخت را انتخاب کنید',
        fields: {
          accountInformationId: 'حساب',
          billNumber: 'شماره سند',
          branchCode: 'کد شعبه',
          chequeAccountNumber: 'شماره شبا صاحب چک',
          chequeImage: 'تصویر چک',
          chequeAmount: 'مبلغ چک ',
          chequeImageAddress: ' تصویر چک ',
          dueDate: ' تاریخ سررسید ',
          holderName: 'نام صاحب حساب ',
          isOnlineGeneral: 'درگاه عمومی',
          serialNumber: 'شماره سریال ',
          sayadNumber: 'شماره صیادی ',
          seriesNumber: 'شماره سری',
          nationalCode: 'کدملی / شناسه ملی  ',
          orderId: 'شماره سفارش',
          referenceId: 'شماره مرجع',
          typePayment: 'نوع پرداخت',
          paymentDate: 'تاریخ پرداخت',
          paymentTime: 'ساعت پرداخت',
        },
        invoice: {
          title: 'پیش فاکتور',
        },
      },
      chequePayments: {
        title: 'لیست چک ها ',
        resellerTitle: 'لیست چک های فروشنده',
        detail: 'جزئیات چک',
        fields: {
          branchCode: 'کد شعبه',
          chequeAccountNumber: ' شماره شبا صاحب چک',
          chequeAmount: 'مبلغ چک',
          chequeImageAddress: ' تصویر چک',
          dueDate: 'تاریخ سررسید',
          holderName: 'نام صاحب حساب',
          isPassed: 'پاس شدن',
          nationalCode: 'شناسه ملی / کدملی',
          paymentId: 'شناسه پرداخت',
          sayadNumber: 'شماره صیادی',
          serialNumber: 'شماره سریال',
          seriesNumber: 'شماره سری',
          typeBank: 'بانک',
          payerOrganizationName: 'سازمان پرداخت کننده',
          receiverOrganizationName: 'سازمان دریافت کننده',
        },
      },
      informations: {
        name: 'اطلاعیه',
        title: 'اخبار',
        form: {
          addTitle: 'افزودن خبر',
          editTitle: 'ویرایش خبر',
          fields: {
            id: 'شناسه خط',
            displayForAllSubOrganizations:
              'نمایش برای همه سازمان های زیر مجموعه ',
            customerDomainName: 'دامنه',
            startDate: 'شروع نمایش خبر',
            endDate: 'پایان نمایش خبر',
            isRequiredToSeen: 'نمایش اجباری',
          },
          legend: 'افزودن خبر',
        },
      },
      panelDocumentations: {
        title: 'مستندات پنل',
        webServiceSendHelp: 'راهنما برای ارسال با وب سرویس',
        downloadDocumentations: 'دانلود مستندات',
        smartDocumentations: 'دانلود مستندات ارسال هوشمند',
      },
      audits: {
        title: ' گزارش تغییرات',
        auditList: 'لیست تغییرات',
        auditDetail: 'جزئیات تغییرات',
        fields: {
          referenceId: 'شناسه جدول',
          remoteIpAddress: 'آدرس  آی پی از راه دور',
          localIpAddress: 'آدرس آی پی محلی',
          osInfo: 'اطلاعات سیستم عامل',
          browserName: 'نام مرورگر',
          operationType: 'نوع عملیات',
          operationCount: 'تعداد عملیات',
          old: 'اطلاعات قبلی',
          new: 'اطلاعات جدید',
          comments: 'پیغام ها',
          timezone: 'منطقه زمانی',
          ip: 'آی پی',
          applicationName: 'نام نرم افزار',
          lat: 'عرض جغرافیایی',
          lon: 'طول جغرافیایی',
          country_iso_code: 'کد ایزو کشور',
          country_name: 'نام کشور',
          continent_code: 'کد قاره',
          userAgent: 'عامل کاربر',
          className: 'محل خطا',
          os: {
            full: 'نام کامل سیستم عامل',
            version: 'ورژن سیستم عامل',
            name: 'نام سیستم عامل',
          },
          device: {
            name: 'نام دستگاه',
          },
          clientUserAgent: {
            name: 'نام عامل کاربر مشتری',
            version: 'ورژن عامل کاربر مشتری',
          },
        },
      },
      superAdminAudits: {
        title: 'لاگ های سوپر ادمین',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          document: 'اطلاعات لاگ',
        },
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'کد لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      apiAudits: {
        title: 'لاگ های وب سرویس',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          userInfo: 'اطلاعات کاربری',
          document: 'اطلاعات لاگ',
        },
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userId: 'شناسه کاربری',
          organizationId: 'شناسه سازمان',
          token: 'توکن',
          tokenIp: 'آی پی توکن',
          tokenId: 'شناسه توکن',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          scheduledMessageId: 'شناسه ی پیام',
          status: 'وضعیت',
          requestBody: 'درخواست',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      loginAudits: {
        title: 'لاگ های ورود کاربران',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          userInfo: 'اطلاعات کاربری',
          document: 'اطلاعات لاگ',
        },
        fields: {
          logDateTime: 'تاریخ لاگ',
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userId: 'شناسه کاربری',
          organizationId: 'شناسه سازمان',
          token: 'توکن',
          tokenIp: 'آی پی توکن',
          tokenId: 'شناسه توکن',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          scheduledMessageId: 'شناسه ی پیام',
          status: 'وضعیت',
          requestBody: 'درخواست',
          resultData: 'دیتای نتیجه',
          entryData: 'دیتای ورودی',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      rulesAudits: {
        title: 'لاگ قوانین توکن',
        legends: {},
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          requestToken: 'توکن درخواست',
          status: 'وضعیت',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      systemNumbers: {
        title: 'کلیه خطوط سیستم',
        legend: 'کلیه خطوط سیستم',
        fields: {
          number: 'شماره خط',
          numberType: 'نوع خط',
          organizationName: 'نام سازمان',
        },
      },
      webhook: {
        title: 'وب هوک',
        form: {
          editTitle: 'ویرایش وب هوک',
          addTitle: 'وب هوک جدید',
          legend: 'اطلاعات وب هوک',
          encoding: 'کدینگ',
          messageId: 'شناسه صندوق ارسال',
          status: 'وضعیت',
          sampleCode: 'نمونه کد',
          to: 'خط اختصاصی',
          from: 'شماره ارسال کننده',
          text: 'متن پیام',
          toNumber: 'شماره تلفن گیرنده پیام',
          receivedDate: 'تاریخ دریافت',
          fields: {
            url: 'آدرس',
            tryCount: 'تعداد سعی مجدد',
            webhookType: 'نوع',
          },
          legends: {
            specifications: 'مشخصات',
            address: 'آدرس webhook',
          },
          messages: {
            description1:
              'برای اطلاع از جزئیات پارامترها به راهنما مراجعه کنید.',
            description3: 'آدرس باید با http یا https شروع شده باشد.',
            description2: 'اعتبارسنجی آدرس وارد شده به عهده کاربر می باشد.',
            description4:
              'توجه : وب هوک وضعیت، فقط برای ارسال های وب سرویس ارسال خواهد شد.',
          },
        },
      },
      apiToken: {
        title: 'توکن ',
        ipRules: 'کل قوانین آی پی',
        createIpRules: 'تنظیم قوانین آی پی',
        clientRules: ' قوانین کاربر',
        safeIps: 'آی پی های امن',
        form: {
          editTitle: 'ویرایش توکن',
          addTitle: 'توکن جدید',
          changeStatusTitle: 'تغییر وضعیت توکن',
          legend: 'اطلاعات توکن',
          fields: {
            ip: 'آی پی',
            token: 'توکن',
            status: 'وضعیت',
            isCanSend: 'ارسال',
            isCanSendSmart: 'ارسال هوشمند',
            isIgnoreCheckIp: 'چک نکردن آی پی',
          },
        },
      },
      ipRules: {
        title: 'کل قوانین آی پی ',
        allIpRules: 'کل قوانین',
        form: {
          addTitle: 'جدید',
          editTitle: 'ویرایش',
          legend: 'اطلاعات قانون',
          fields: {
            ip: 'آی پی',
            limit: 'نرخ فراخوانی',
            period: 'دوره فراخوانی',
            periodType: 'نوع دوره فراخوانی',
            endpoint: 'آدرس Api',
            apiTokenId: 'آیدی Api',
            ipRulesFromWebService: 'قوانین آی پی از کش',
            ipRulesFromTable: 'قوانین آی پی از جدول',
          },
        },
      },
      clientRules: {
        title: 'قوانین کاربر ',
        form: {
          addTitle: 'جدید',
          editTitle: 'ویرایش',
          legend: 'اطلاعات قانون',
          fields: {
            ip: 'آی پی',
            limit: 'نرخ فراخوانی',
            period: 'دوره فراخوانی',
            endpoint: 'آدرس Api',
            apiTokenId: 'آیدی Api',
            clientId: 'آیدی کاربر',
            clientRulesFromWebService: 'قوانین کاربر از کش',
            clientRulesFromTable: 'قوانین کاربر از جدول',
          },
        },
      },
      pollParsersInboxes: {
        title: 'ارسال کنندگان',
        inboxesExcel: 'دانلود فایل اکسل',
      },
      modules: {
        title: 'ماژول ها',
        modules: {
          title: 'ماژول ها',
        },
        modulesOrganizations: {
          title: 'ماژول های سازمان ها',
          form: {
            editTitle: 'ویرایش ماژول سازمان',
            addTitle: 'اختصاص ماژول به سازمان',
            legend: 'مشخصات',
            fields: {
              moduleId: 'شناسه ماژول',
              organizationId: 'شناسه سازمان',
            },
          },
        },
      },
      filterWords: {
        title: 'کلمات فیلتر شده',
        form: {
          editTitle: 'ویرایش کلمات',
          addTitle: 'کلمات جدید',
          fields: {
            userFirstName: 'نام کاربر',
            userLastName: 'نام خانوادگی کاربر',
          },
        },
      },
      organizationsBlackListExceptions: {
        title: 'لیست استثناها',
        form: {
          addTitle: 'استثناهای جدید',
        },
      },
      phonebook: {
        title: 'دفترچه تلفن',
        form: {
          addTitle: 'افزودن به دفترچه تلفن',
          editTitle: 'ویرایش دفترچه تلفن',
          fields: {
            title: 'عنوان',
            isPublic: 'وضعیت عمومی',
            isShowNumber: 'وضعیت نمایش شماره',
            contactsCount: 'تعداد مخاطبین',
            whiteMessageId: 'شناسه باشگاه ',
            deviceConnectionPort: 'شناسه دستگاه باشگاه مشتریان',
            isSendMessageAfterAddFromDevice:
              'ارسال پیام پس از افزودن از دستگاه',
          },
          legends: {
            phonebookInformation: 'اطلاعات دفترچه تلفن',
          },
        },
        customFieldsForm: {
          title: ' فیلدهای سفارشی دفترچه تلفن',
          searchInCustomFields: 'جستجو در فیلدهای سفارشی',
        },
      },
      contacts: {
        title: ' مخاطبین',
        deleteContactsFormPhonebooks: {
          title: 'حذف مخاطب از گروه ها',
          message:
            'گروه هایی که قصد دارید مخاطبین از آنها حذف شوند را انتخاب نمائید. ',
          selectCurrentGroup: 'انتخاب گروه فعلی',
        },
        addBtns: {
          addSingle: 'افزودن تکی',
          addListNumber: 'افزودن شماره لیستی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        form: {
          addTitle: 'افزودن مخاطب',
          editTitle: 'ویرایش مخاطب',
          fields: {
            job: 'شغل  ',
            birthdate: 'تاریخ تولد',
            telephone: 'تلفن ',
            cellphone: 'شماره همراه',
            phonebookGroup: 'گروه دفترچه تلفن',
            createType: 'نوع ایجاد',
          },
          legends: {
            contactInfo: 'اطلاعات مخاطب',
            customFields: 'فیلد های دلخواه',
          },
        },
        importfromfile: {
          title: 'افزودن مخاطبین از فایل',
          legends: {
            importFromFile: 'افزودن مخاطبین از فایل',
            previewFile: 'پیش نمایش',
          },
          fields: {
            selectfile: 'انتخاب فایل',
            firstNameFieldName: 'فیلد نام',
            lastNameFieldName: 'فیلد نام خانوادگی',
            emailFieldName: 'فیلد پست الکترونیکی',
            birthDateFieldName: 'فیلد تاریخ تولد',
            telephoneFieldName: 'فیلد تلفن ثابت',
            jobFieldName: 'فیلد شغل',
            addressFieldName: 'فیلد آدرس',
            empty: 'خالی',
            cellPhone: 'فیلد تلفن همراه',
            phonebookGroup: 'گروه دفترچه تلفن',
          },
        },
      },
      dynamicTemplate: {
        title: ' قالب های پویا ',
        form: {
          addTitle: 'قالب پویا جدید',
          editTitle: 'ویرایش قالب پویا',
          fields: {
            customText: 'متن دلخواه',
            format: 'قالب',
          },
          messages: {
            description1:
              'جهت افزودن فیلدهای ثابت روی نام فیلد در لیست بالا کلیک کنید.',
            description2:
              'همچنین از قسمت مشخصات می توانید جهت افزودن متن و فیلد دلخواه اقدام نمائید  .',
            note1: 'در طراحی قالب پویا به نکات زیر توجه داشته باشید :',
            note2:
              ' اگر فیلد دلخواه یا فیلد ثابتی در قالب پویا تعریف شد که مقداری در مخاطب برای آن ثبت نشده باشد، در پیامک متن آن خالی ارسال می شود .',
            note3:
              'اگر فیلد دلخواهی در قالب پویا تعریف شد که در گروه مخاطبین (دفترچه تلفن) وجود نداشته باشد، در پیامک متن آن خالی ارسال می شود .',
          },
        },
      },
      outboxMessages: {
        title: ' صندوق ارسال سازمان ',
        usersTitle: ' صندوق ارسال کاربران',
        userTitle: ' صندوق ارسال کاربر',
        resellerTitle: ' صندوق ارسال کاربران فروشنده فعلی',
        resellersTitle: ' صندوق ارسال کاربران فروشنده ',
        usersOutboxMessages: ' تمامی کاربران',
        userOutboxMessages: 'فقط سوپرادمین',
        editStatusTitle: 'ویرایش انتخابی وضعیت تحویل گیرندگان',
        getNewDeliveryStatusTitle: 'درخواست آخرین وضعیت تحویل',
        outboxExcel: 'دانلود فایل اکسل صندوق ارسال',
        outboxExcelWithMoreDetail:
          ' دانلود فایل اکسل صندوق ارسال با جزئیات بیشتر',
        advancedSearch: {
          title: 'جستجوی پیشرفته',
          zipCode: 'کدپستی',
          phonebookIds: 'گروه دفترتلفن',
          toNumber: 'گیرنده',
          guild: 'گروه مشاغل',
          zone: 'منطقه',
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          description: 'توضیحات',
          smsText: 'متن پیام',
          sendStartDate: 'تاریخ شروع ارسال',
          sendEndDate: 'تاریخ پایان ارسال',
          sendStartHour: 'ساعت شروع ارسال',
          sendEndHour: 'ساعت پایان ارسال',
          sendStatus: 'وضعیت ارسال ',
          deliveryStatus: 'وضعیت تحویل گیرندگان',
        },
        resendDetail: {
          title: 'جزئیات ارسال مجدد',
          createdBy: 'ایجاد کننده',
          scheduledMessageId: 'شناسه قبلی',
          newScheduledMessageId: 'شناسه جدید',
          deliveryStatuses: 'نوع ارسال مجدد',
        },
        fields: {
          countSendBlackList: 'تعداد ارسال لیست سیاه',
          blackListCount: 'تعداد لیست سیاه',
          countResendOther: 'تعداد ارسال مجدد',
          cpType: 'عامل ارسال',
          exportDataStatus: 'وضعیت خروجی داده',
          receiverCount: 'گیرندگان',
          organizationId: 'شناسه سازمان',
          scheduledMessageId: 'شناسه',
          sendingTryCount: 'تعداد تلاش برای ارسال',
          campaign: 'کمپین',
          mciCount: 'همراه اول',
          mtnCount: 'ایرانسل',
          otherCount: 'سایر',
          rightelCount: 'رایتل',
          internationalCount: 'بین الملل',
          smsEncoding: 'نوع رمزگذاری',
          smsParts: 'بخش',
          smsText: 'پیامک',
          status: 'وضعیت',
          contactsCount: 'تعداد مخاطبین',
          resellerName: 'فروشنده',
          sendSubType: 'نوع زمان ارسال ',
          sendType: 'نوع ارسال ',
          isResend: 'ارسال مجدد',
          senderNumber: 'فرستنده',
          wrongNumberCount: 'تعداد شماره های اشتباه',
          isWhiteMessage: 'ارسال سفید',
          isFlashSms: 'ارسال فلش',
          period: 'دوره ای',
          processTextResults: 'تحلیل پیامک',
          p2PIsSendDuplicateNumber: 'ارسال با شماره های تکراری نظیر به نظیر',
        },
        detail: {
          title: 'جزئیات ارسال',
          PhonebookRecipientTitle: 'جزئیات ارسال با دفترچه تلفن',
        },
        resendByDeliveryStatus: {
          title: 'ارسال مجدد بر اساس وضعیت',
          statues: 'وضعیت ها',
          isSendFromMyPanel: 'ارسال از پنل من',
          extraReceivers: 'گیرندگان اضافی',
          selectDeliveryStatus: 'انتخاب وضعیت',
          messageInformation: 'مشخصات پیامک',
          receiversAndSendDateTime: 'گیرندگان و زمان ارسال',
          deliveryStatusRequiredMsg: 'انتخاب حداقل یک وضعیت الزامی می باشد.',
          sendDirect: 'ارسال مستقیم',
          sendGradual: 'ارسال تدریجی',
          isFlashSms: 'ارسال فلش',
        },
      },
      dynamicSendSms: {
        title: 'ارسال پویا',
        form: {
          addTitle: 'ارسال پویا',
          editTitle: 'ویرایش ارسال پویا',
          fields: {
            customText: 'متن دلخواه',
            format: 'قالب',
            dynamicTemplates: 'قالب های پویا',
          },
        },
        messages: {
          warningMessageBeforeClosingEditPage:
            'توجه داشته باشید با زدن کلید (بازگشت) ارسال شما متوقف خواهد شد. ',
          note1: 'در ارسال پویا به نکات زیر توجه داشته باشید :',
          note2:
            ' اگر فیلد دلخواه یا فیلد ثابتی در قالب پویا تعریف شد که مقداری در مخاطب برای آن ثبت نشده باشد، در پیامک متن آن خالی ارسال می شود .',
          note3:
            'اگر فیلد دلخواهی در قالب پویا تعریف شد که در گروه مخاطبین (دفترچه تلفن) وجود نداشته باشد ، در پیامک متن آن خالی ارسال می شود .',
        },
        legends: {
          messageInformation: 'مشخصات پیامک',
          phonebook: 'دفترچه تلفن',
        },
      },
      sendP2pSms: {
        title: 'ارسال نظیر به نظیر',
        trackingNumberTitle: 'ارسال نظیر به نظیر با کد پیگیری',
        editTitle: 'ویرایش ارسال نظیر به نظیر',
        legends: {
          selectFile: 'انتخاب فایل',
          smsTextSetting: ' متن پیامک',
          smsSetting: 'تنظیمات پیامک',
        },
        fields: {
          toNumberFieldName: 'ستون شماره موبایل ها',
          trackingNumberFieldName: 'ستون کد پیگیری',
        },
        messages: {
          description1:
            'جهت تنظیم متن پیامک ، می توانید ستون موردنظر را با کلیک کردن از لیست ستون ها انتخاب نمائید.',
          description2:
            ' همچنین برای جابجایی ستون ها در کادر آبی ، ستون را گرفته و جابجا کنید.',
          description3:
            ' لازم به ذکر است جهت افزودن متن دلخواه می توانید متن موردنظر خود را داخل فیلد متن دلخواه تایپ کنید و با زدن کلید افزودن ',
          description4: 'متن خود را به پیامک اضافه کنید.',
          sendWithDuplicateNumbersMsg:
            'هشدار : با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
        },
      },
      sendP2pSmartSms: {
        title: 'ارسال هوشمند نظیر به نظیر',
        editTitle: 'ویرایش ارسال هوشمند نظیر به نظیر',
        legends: {
          selectFile: 'انتخاب فایل',
          smsTextSetting: ' متن پیامک',
          smsSetting: 'تنظیمات پیامک',
          publicMap: 'منطقه انتخابی',
        },
        fields: {
          toNumberFieldName: 'ستون شماره موبایل ها',
        },
        messages: {
          description1:
            'جهت تنظیم متن پیامک ، می توانید ستون موردنظر را با کلیک کردن از لیست ستون ها انتخاب نمائید.',
          description2:
            ' همچنین برای جابجایی ستون ها در کادر آبی ، ستون را گرفته و جابجا کنید.',
          description3:
            ' لازم به ذکر است جهت افزودن متن دلخواه می توانید متن موردنظر خود را داخل فیلد متن دلخواه تایپ کنید و با زدن کلید افزودن ',
          description4: 'متن خود را به پیامک اضافه کنید.',
          sendWithDuplicateNumbersMsg:
            'هشدار : با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
        },
        errors: {
          couldNotEditRequest:
            'درخواست شما در وضعیتی نیست که شما بتوانید اطلاعات آن را تایید یا رد نمایید.',
          pleaseWaitUntilTheRequestStateChanged:
            'لطفا تا تغییر وضعیت درخواست منتظر بمانید.',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
        },
      },
      sendSmartSMS: {
        title: ' درخواست ارسال هوشمند ',
        detail: 'جزئیات درخواست',
        smartSmsDetailExcel: 'دانلود اکسل جزئیات ارسال هوشمند ',
        smartSmsDetailTableExcel: 'دانلود اکسل جدول جزئیات ارسال هوشمند',
        form: {
          addTitle: 'ارسال هوشمند جدید',
          editTitle: 'ویرایش ارسال هوشمند',
          legend: 'ارسال هوشمند',
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
            title: 'عنوان',
            responseData: 'پاسخ',
          },
        },
      },
      smartSmsRequests: {
        title: ' لیست درخواست های ارسال هوشمند',
        detail: 'جزئیات درخواست',
        smartSmsRequestExcel: 'دانلود اکسل درخواست ارسال هوشمند',
        form: {
          addTitle: 'ارسال هوشمند جدید',
          editTitle: 'ویرایش ارسال هوشمند',
          legend: ' لیست درخواست های ارسال هوشمند',
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
            title: 'عنوان',
            responseData: 'پاسخ',
          },
        },
        exportRequest: 'ذخیره درخواست در فایل',
        exportStatus: 'ذخیره وضعیت در فایل',
        importRequestStatus: 'به روزرسانی وضعیت از فایل',
        importRequestFromFile: 'ایجاد در خواست از فایل',
      },
      resellerSmartSmsRequests: {
        title: ' لیست درخواست های ارسال هوشمند فروشنده',
        form: {
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
          },
        },
      },
      sendOccasionSms: {
        title: 'ارسال مناسبتی',
        legends: {
          messageInformation: 'مشخصات پیامک',
          phonebook: 'دفترچه تلفن',
        },
        fields: {
          howManyDaysSendItBeforeDueDate: 'ارسال قبل از تاریخ  رویداد (روز)',
          calendarEvents: 'مناسبت تقویمی',
          calenderOrganizationEvents: 'مناسبت سازمانی',
          toConsiderYear: 'سال در نظر گرفته شود',
        },
      },
      fastSendSmsPatternByPhonebook: {
        title: 'ارسال پیام الگو',
      },
      pollParsers: {
        surveyTitle: 'نظرسنجی',
        competitionTitle: 'مسابقه',
        options: 'گزینه ها',
        selectOption: 'انتخاب گزینه',
        form: {
          pollAddTitle: 'نظرسنجی جدید',
          pollEditTitle: 'ویرایش نظرسنجی',
          competitionAddTitle: 'مسابقه جدید',
          competitionEditTitle: 'ویرایش مسابقه',
          legends: {
            surveySpecifications: 'مشخصات نظرسنجی',
            surveyResponse: 'پاسخ به شرکت کنندگان در نظرسنجی',
            surveyMatchOptions: 'گزینه های نظرسنجی',
            competitionSpecifications: 'مشخصات مسابقه',
            competitionResponse: 'پاسخ به شرکت کنندگان در مسابقه',
            competitionMatchOptions: 'گزینه های مسابقه',
          },
          fields: {
            privateNumberId: 'ورود از شماره',
            senderPhonebookId: 'عضو',
            optionTitle: 'عنوان گزینه',
            answerValue: 'کلمه کلیدی',
            phonebookName: 'ذخیره در دفترچه تلفن',
            isCorrect: 'صحیح',
            isJustTrueAnswer: 'فقط پاسخ صحیح',
            isMainQuestion: 'سوال اصلی',
          },
          messages: {
            emptyOption: 'هنوز گزینه ای ثبت نشده!',
            onlyOneCorrectOption: 'گزینه صحیح قبلاً ثبت شده است.',
            optionTitleRequired: 'عنوان گزینه را وارد کنید',
            keywordRequired: 'کلمه کلیدی را وارد کنید',
            uniqueTitle: 'عنوان گزینه نمی تواند تکراری باشد',
            uniqueKeyword: 'کلمه کلیدی نمی تواند تکراری باشد',
          },
        },
        stats: {
          title: 'مشاهده آمار',
          correctAnswerCount: 'تعداد پاسخ صحیح',
          incorrectAnswerCount: 'تعداد پاسخ غلط',
          surveyStats: 'آمار نظرسنجی',
          competitionStats: 'آمار مسابقه ',
          doughnutChartTitle: 'نمودار گزینه های انتخاب شده',
          pieChartTitle: 'نمودار تعداد انتخاب های صحیح و غلط',
        },
      },
      textParsers: {
        title: 'تحلیلگر پیامک',
        form: {
          addTitle: 'تحلیلگر جدید',
          editTitle: 'ویرایش تحلیلگر',
          fields: {
            isChildrenChange: 'اعمال برای همه زیرمجموعه ها',
            title: 'عنوان فیلتر پیامک',
            privateNumberId: 'شماره گیرنده',
            senderConditionType: 'شرط',
            senderConditionValue: 'مقدار',
            senderPhonebookId: 'عضو',
            ifConditionType: 'اگر',
            ifConditionValue: 'مقدار',
            thenConditionType: 'آنگاه',
            thenConditionValue: 'مقدار',
            senderNumber: 'شماره فرستنده',
            mobileNumber: 'شماره گیرنده',
            email: 'ایمیل گیرنده',
            matchingDynamicTemplateId: 'استفاده از قالب در صورت تطابق',
            noMatchingDynamicTemplateId: 'استفاده از قالب در صورت عدم تطابق',
            ipAndPort: 'آی پی و پورت',
            sentDelayType: 'نوع ارسال',
            sentDelayValue: 'زمان پس از دریافت',
          },
          legends: {
            filterConditions: 'شرایط فیلتر',
            generalInformation: 'مشخصات عمومی',
            senderNumber: 'شماره فرستنده',
            duplicateMessageResponse: 'پاسخ پیام تکراری',
          },
        },
      },
      safeIps: {
        safeIpsTitle: 'آی پی های امن',
        confirmUserSafeIpsTitle: 'تایید آی پی های امن',
        confirmUserSafeIps: 'تایید آی پی ',
        form: {
          addTitle: 'آی پی امن جدید',
          editTitle: 'ویرایش آی پی',
        },
      },
      whiteMessages: {
        title: 'لیست درخواست ها',
        form: {
          addTitle: 'درخواست تنظیمات جدید',
          editTitle: 'ویرایش وضعیت درخواست',
          fields: {
            enterSms: 'پیامک ورود مجدد به باشگاه',
            exitSms: 'پیامک خروج از باشگاه',
            returnText: 'متن برگشت ',
            cancelText: 'متن لغو',
            status: 'وضعیت تایید',
            dailyAddLimit: 'حداکثر تعداد افزودن روزانه به دفترچه باشگاه',
            monthlyAddLimit: 'حداکثر تعداد افزودن ماهانه به دفترچه باشگاه',
            isSendCancelText: 'ارسال متن لغو آخر هر پیامک',
            rejectComment: 'توضیحات رد کردن',
            repeatTextDay: 'تکرار متن در هر روز',
          },
          legends: {
            requestDetail: 'جزئیات درخواست',
            defineScenario: 'تعریف سناریو',
          },
        },
      },
      organizationWhiteMessages: {
        title: 'لیست تنظیمات',
        form: {
          addTitle: 'تنظیمات جدید',
          editTitle: 'ویرایش تنظیمت',
          fields: {
            enterSms: 'پیامک ورود به باشگاه',
            exitSms: 'پیامک خروج از باشگاه',
            returnText: 'متن برگشت ',
            cancelText: 'متن لغو',
          },
        },
      },
      sendWhiteMessage: {
        title: 'ارسال پیامک باشگاه',
        editTitle: 'ویرایش ارسال پیامک باشگاه ',
        legends: {
          phonebook: 'دفترچه تلفن',
        },
      },
      aggregators: {
        title: 'پیش شماره اپراتور',
        numberAggregator: 'یافتن اپراتور شماره همراه',
        isValidNumber: 'اعتبارسنجی شماره همراه',
        form: {
          addTitle: 'پیش شماره جدید',
          editTitle: 'ویرایش پیش شماره',
          updateRegexTitle: 'ویرایش regex',
          fields: {
            regex: 'regex',
            smsAggregator: 'اپراتور',
          },
        },
      },
      documentsManagement: {
        title: 'مدیریت مستندات',
        form: {
          addTitle: 'مستندات جدید',
          editTitle: 'ویرایش مستندات ',
          fields: {},
        },
      },
      currentOrganizationSentCountStatistics: {
        title: 'گزارش آماری ارسال سازمان فعلی ',
      },
      currentUserSentCountStatistics: {
        title: 'گزارش آماری ارسال کاربر فعلی ',
      },
      sentCountStatistics: {
        title: 'گزارش آماری ارسال',
      },
      currentOrganizationSendStatusStatistics: {
        title: 'گزارش آماری وضعیت ها سازمان فعلی ',
      },
      currentUserSendStatusStatistics: {
        title: 'گزارش آماری وضعیت ها کاربر فعلی ',
      },
      sendStatusStatistics: {
        title: 'گزارش آماری وضعیت‌ها',
      },
      currentOrganizationOperatorStatistics: {
        title: 'گزارش آماری اپراتورها سازمان فعلی ',
      },
      currentUserOperatorStatistics: {
        title: 'گزارش آماری اپراتورها کاربر فعلی ',
      },
      operatorStatistics: {
        title: 'گزارش آماری اپراتورها',
      },
      statisticsByPartLength: {
        title: 'گزارش جزییات ارسال',
      },
      currentUserStatisticsByPartLength: {
        title: 'گزارش جزییات ارسال کاربر فعلی',
      },
      currentOrganizationStatisticsByPartLength: {
        title: 'گزارش جزییات ارسال سازمان فعلی',
      },
      complexStatistics: {
        title: 'گزارش آماری جامع',
      },
      currentOrganizationComplexStatistics: {
        title: 'گزارش آماری جامع سازمان فعلی',
      },
      currentUserComplexStatistics: {
        title: 'گزارش آماری جامع کاربر فعلی',
      },
      todayStatistics: {
        title: 'گزارش آماری امروز',
      },
      currentOrganizationTodayStatistics: {
        title: 'گزارش آماری امروز سازمان فعلی',
      },
      currentUserTodayStatistics: {
        title: 'گزارش آماری امروز کاربر فعلی',
      },
      currentUserSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی سوپرادمین',
      },
      currentUserSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل کاربر فعلی',
      },
      currentOrganSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل سازمان فعلی',
      },
      superAdminSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل سوپرادمین ',
      },
      currentUserSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی سوپرادمین',
      },
      currentUserSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل کاربر فعلی',
      },
      currentOrganSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل سازمان فعلی',
      },
      superAdminSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل سوپرادمین',
      },
      currentUserOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل کاربر فعلی ',
      },
      currentOrganOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل سازمان فعلی ',
      },
      superAdminOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل سوپرادمین',
      },
      currentUserOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی سوپرادمین',
      },
      statisticalReports: {
        lineComplexDescription: 'نمودار کل پیام های ارسال شده به تفکیک زمان',
        doughnutChartDescription: 'نمودار تعداد پیام های ارسال شده',
        barChartDescription: 'نمودار پیام های ارسال شده ',
        successful: 'موفق',
        unsuccessful: 'ناموفق',
        allCount: 'مجموع',
        sendingStatusDoughnutChart: 'نمودار وضعیت ارسال',
        sendingStatusBarChart: 'نمودار وضعیت ارسال به تفکیک وضعیت',
        untilTargetCount: 'باقیمانده تا هدف',
        targetCount: 'تعداد پیامک هدف',
        sentCount: 'تعداد پیامک ارسالی',
        lineResellersDescription: 'نمودار تعداد پیامک های ارسالی و هدف اعضا',
        barChartResellersDescription:
          'نمودار مجموع تعداد پیامک های ارسالی و هدف',
      },
      operatorsTodayStatistics: {
        title: 'گزارش امروز اپراتورها',
      },
      currentOrganizationResellersStatistics: {
        title: 'گزارش فروش سازمان',
      },
      packageSales: {
        title: 'مدیریت بسته های پیامک',
        form: {
          addTitle: 'بسته پیامک جدید',
          editTitle: 'ویرایش بسته پیامک',
          priceErrorMessage: 'میزان شارژ باید بیشتر از مبلغ پرداختی باشد',
          fields: {
            expirationType: 'نوع',
            expiration: 'مدت اعتبار',
            packageInformations: 'اطلاعات بسته',
            created: 'زمان ایجاد',
          },
        },
      },
      packageOrganizations: {
        title: 'خرید بسته پیامک',
        expirationTypes: {
          0: 'ساعته',
          1: 'روزه',
          2: 'هفته ای',
          3: 'ماهه',
        },
        expirationNames: {
          0: 'ساعتی',
          1: 'روزانه',
          2: 'هفتگی',
          3: 'ماهانه',
        },
        packageOrganizationsCard: {
          legend: 'خرید بسته پیامک',
          discountCodeForOrganizationPackagePrice: 'کد تخفیف',
          packageOrganizationPrice: 'قیمت بسته پیامک',
          buyPackage: 'خرید بسته',
          discountCode: 'کد تخفیف',
          discountPercent: 'درصد تخفیف',
          typeName: 'نوع بسته',
          discount: 'تخفیف',
          expirationType: 'نوع انقضا',
          organizationPackagePriceDetailsBought:
            'مشخصات بسته پیامکی خریداری شده',
          expiration: 'نوع بسته',
          wrongDiscountCodeMessage: 'کد تخفیف وارد شده صحیح نمی‌باشد',
          successfulDiscountSubmitation: 'کد تخفیف با موفقیت ثبت شد.',
        },
      },
      privateNumbersPrice: {
        title: 'قیمت خطوط',
        form: {
          addTitle: 'افزودن قیمت خط',
          editTitle: 'ویرایش قیمت خط ',
          fields: {
            isRound: 'شماره رند',
            numberOfDigits: 'تعداد ارقام',
            reservationPeriod: 'مدت زمان رزرو (روز)',
            reservationPeriodWithoutDay: 'مدت زمان رزرو',
          },
          legends: {
            privateNumberPriceInformation: 'مشخصات خرید خط',
          },
          messages: {
            alert1:
              'در صورت انتخاب <b class="tw-font-bold">شماره رند</b>، <b class="text-danger">در فیلد عنوان نوع رند بودن مشخص شود</b>.( مثال : رند 2 رقمی )',
            alert2:
              'در صورت انتخاب عدد صفر برای فیلد مدت زمان رزرو ، مدت زمان رزرو اعمال نخواهد شد.',
          },
        },
      },
      privateNumbersPriceForUser: {
        title: 'خرید خط برای کاربران',
        form: {
          fields: {
            isRound: 'شماره رند',
            numberOfDigits: 'تعداد ارقام',
            reservationPeriod: 'مدت زمان رزرو (روز)',
            reservationPeriodWithoutDay: 'مدت زمان رزرو',
            privateNumberPriceNumber: 'شماره خط',
            numberPrice: 'قیمت خط',
          },
          legend: 'خرید خط',
          messages: {
            privateNumberPriceDetailsBought: 'مشخصات خط خریداری شده',
            privateNumberPriceAuthenticationAfterBuy:
              'کاربر گرامی برای ارسال پیامک با این شماره لازم است جهت احراز هویت خط اقدام نمائید.',
            privateNumberPriceAuthentication:
              'کاربر گرامی بعد از خرید خط لازم است جهت احراز هویت خط خریداری شده اقدام نمائید.',
            privateNumberPriceNumber: 'شماره خط موردنظر خود را وارد کنید',
            discountCodeForPrivateNumberPrice:
              'اگر برای خرید خط کد تخفیف دارید وارد کنید',
            PrivateNumberPriceWithoutAuthentication:
              'توجه داشته باشید امکان استفاده از خطوط احراز هویت نشده وجود ندارد.',
            notPossibleToChangeTheRequestedRegistrationNumber:
              'با توجه به عدم امکان تغییر در سرشماره درخواستی، لطفا دقت داشته باشد که شماره تکراری نباشد.',
            PrivateNumberPriceDeleteOrCancel:
              '<span class="text-danger">*</span> <span>درخواست ثبت سرشماره انتخاب شده، قابل تغییر، حذف یا انصراف <b class="text-danger">نمی‌باشد</b>. لذا خواهشمند است در این مورد دقت لازم را بعمل آورید. </span>',
            PrivateNumberPriceDeleteOrCancelAfterBuy:
              '<span class="text-danger">*</span> <span>ضمن تشکر از حسن انتخاب شما؛ به اطلاع میرساند درخواست ثبت سرشماره انتخاب شده، قابل تغییر، حذف یا انصراف <b class="text-danger">نمی‌باشد</b>. لذا خواهشمند است در این مورد دقت لازم را بعمل آورید.</span>',
          },
        },
        rules: {
          buyNumberRule1:
            'با اصول و مبانی دین اسلام و قانون اساسی جمهوری اسلامی ایران مغایرت نداشته و در تضاد نباشد.',
          buyNumberRule2: 'باعث تشویش اذهان عمومی نگردد.',
          buyNumberRule3: 'مخل نظم و آرامش حاکم بر جامعه نباشد.',
          buyNumberRule4: 'به اخلاق حسنه حاکم برجامعه آسیب نرساند.',
          buyNumberRule5:
            'با سیاست‌های فرهنگی، اجتماعی و اقتصادی کشور مغایرت نداشته باشد.',
          buyNumberRule6:
            'مغایر بااصول انتخاباتی و قوانین حاکم بر جامعه نباشد.',
          buyNumberRule7:
            'عدم تحریک، تشویق، ترغیب، تهدید یا دعوت به فساد و فحشاء و ارتکاب جرایم منافی عفت یا انحرافات جنسی(قانون جرائم رایانه‌ای و ماده639 قانون مجازات اسلامی)',
          buyNumberRule8:
            'عدم اشاعه فحشاء و منکرات در جامعه (بند2 ماده6 قانون مطبوعات)',
          buyNumberRule9:
            'عدم انتشار، توزیع و معامله محتوای خلاف عفت عمومی (مبتذل و مستهجن) (بند2 ماده 6 قانون مطبوعات و ماده14 قانون جرائم رایانه‌ای) تحریک، تشویق، ترغیب، تهدید یا تطمیع افراد به دستیابی به محتویات مستهجن و مبتذل (ماده515 قانون جرایم رایانه ای)',
          buyNumberRule10:
            'عدم اهانت به امام خمینی (ره) و تحریف آثار ایشان (ماده514 قانون مجازات اسلامی)',
          buyNumberRule11:
            'عدم اهانت به مقام معظم رهبری و سایر مراجع تقلید (بند7 ماده6 قانون قانون مطبوعات)',
          buyNumberRule12:
            'عدم انتشار محتوا علیه اصول قانون اساسی (بند12 ماده6 قانون مطبوعات)',
          buyNumberRule13:
            'عدم فاش نمودن و انتشار غیر مجاز اسرار نیروهای مسلح و نقشه و استحکامات نظامی (بند 6 ماده 6 قانون مطبوعات)',
          buyNumberRule14:
            'عدم انتشار هرگونه محتوا با هدف ترغیب و تشویق مردم به تحریم و یا کاهش مشارکت در انتخابات (بند 3 و 8ماده 66 قانون انتخابات مجلس شورای اسلامی و ماده46 آیین نامه اجرایی)',
          buyNumberRule15:
            'رعایت کلیه ضوابط محتوایی نشر دیجیتال (ضوابط ارائه محصولات فرهنگی دیجیتال)',
          buyNumberRule16:
            'انتشار محتوای دیجیتال که به شرح ذیل، مخل مبانی اسلام و حقوق عمومی باشد ممنوع است:',
          buyNumberRule16_1:
            'تخریب هویت ملی و تمسخر باورها، آیین ها و زبان های دینی',
          buyNumberRule16_2:
            'ترویج ناهنجاری های اجتماعی، منبهات اجتماعی و خرده فرهنگ های مغایر با شریعت اسلامی',
          buyNumberRule16_3:
            'تبلیغ و ترویج فرقه‌های انحرافی، عرفان‌های کاذب و سبک‌های زندگی مخالف با شریعت اسلامی',
        },
      },
      childrenPrivateNumberBuyRequests: {
        title: 'لیست درخواست های خرید خط',
        updateStatusPrivateNumberPriceTitle: 'ویرایش وضعیت درخواست خرید خط',
        form: {
          fields: {
            rejectionDescription: 'دلیل رد درخواست',
            payAmount: 'مبلغ پرداخت',
            isAllowedSendLink: ' ارسال لینک',
            isService: 'خط خدماتی',
            privateNumberPriceIsRound: 'شماره رند',
            privateNumberPriceNumberOfDigits: 'تعداد ارقام',
            privateNumberPriceTitle: 'عنوان خط',
            reservationDate: 'تاریخ رزرو',
            assignmentDate: 'تاریخ اختصاص',
            cancellationDate: 'تاریخ لغو',
          },
        },
      },
      privateNumberBuyRequests: {
        title: 'درخواست های خرید',
        form: {
          fields: {
            rejectionDescription: 'دلیل رد درخواست',
            payAmount: 'مبلغ پرداخت',
            isAllowedSendLink: 'ارسال لینک',
            isService: 'سرویس',
          },
        },
        privateNumberUploadDocuments: {
          title: 'آپلود مدارک',
          form: {
            title: ' مدارک',
            addTitle: 'آپلود مدارک',
            fields: {
              FoundedAnnounce: 'اطلاعیه ی تاسیس',
              CertificateAddedValue: 'گواهی ارزش افزوده',
              CompanyStatute: 'اساسنامه شرکت',
              MinutesCompanyChanges: 'دقایق تغییرات شرکت',
              NationalCard: 'کارت ملی',
              BirthCertificate: 'شناسنامه',
              documentStatus: 'وضعیت',
              description: 'توضیحات',
            },
          },
        },
        privateNumberDocuments: {
          title: ' مدارک',
          form: {
            title: 'تایید احراز هویت',
            addTitle: 'تایید احراز هویت',
            legend: 'فرم تایید احراز هویت',
            fields: {
              FoundedAnnounce: 'اطلاعیه ی تاسیس',
              CertificateAddedValue: 'گواهی ارزش افزوده',
              CompanyStatute: 'اساسنامه شرکت',
              MinutesCompanyChanges: 'دقایق تغییرات شرکت',
              NationalCard: 'کارت ملی',
              BirthCertificate: 'شناسنامه',
              documentStatus: 'وضعیت',
              description: 'توضیحات',
            },
          },
        },
      },
      organizationPackages: {
        title: 'بسته های سازمان',
      },
      childrenOrganizationsPackages: {
        title: 'بسته های سازمان های زیرمجموعه',
      },
      landingPageList: {
        title: 'لیست صفحات وب',
        form: {
          fields: {
            shortUrl: 'آدرس لینک کوتاه',
          },
        },
      },
      readyTemplates: {
        title: 'قالب های آماده',
        form: {
          fields: {
            templatePreview: 'پیش نمایش قالب',
          },
        },
      },
      landingPage: {
        title: 'مدیریت صفحه وب',
        goFullScreen: 'تمام صفحه',
        exitFullScreen: 'حالت عادی',
        desginer: 'ویرایشگر ویژوال',
        cssEditor: 'ویرایشگر Css',
        jsEditor: 'ویرایشگر جاوا اسکریپت',
        compileAndInjectScss: 'کمپایل و تزریق به صفحه',
        injectJs: 'تزریق کد جاوا اسکریپت به صفحه',
        previewInDesktop: 'پیش نمایش در مانیتور',
        previewInTablet: 'پیش نمایش در تبلت',
        previewInMobile: 'پیش نمایش در تلفن همراه',
        previewMode: 'پیش نمایش یا ویرایشگر',
        emptyDesignArea: 'خالی شدن کل طراحی',
        htmlEditor: 'ویرایشگر Html',
        selectFromTemplates: 'انتخاب از قالب های آماده',
        saveLandingPage: 'ذخیره لندینگ پیج',
        saveAsTemplate: 'ذخیره به عنوان قالب',
        ShortLinkAddress: 'آدرس لینک کوتاه',
        selectPageFavIcon: 'انتخاب تصاویر',
        save: 'ذخیره',
        ok: 'اعمال',
        isPublic: 'آیا برای سایرین در دسترسی باشد',
        templatePreview: 'پیش نمایش قالب',
        templateTitle: 'عنوان قالب',
        NoTemplateDeclared: 'هیچ قالبی تعریف نشده است',
        readyTemplateImported: 'قالب آماده بارگذاری شد',
        saveAsReadyTemplate: 'ذخیره به عنوان قالب آماده',
        readyTemplateSaved: 'قالب با موفقیت ثبت گردید',
        landingPageSaved: 'صفحه شخصی ذخیره شد',
        selectTemplatePreview: 'انتخاب قالب پیش نمایش',
        ComponentMostNotRunOnMobileDevice:
          'کاربر گرامی طراحی صفحات فقط با کامپیوتر و لپتاپ امکان پذیر می باشد.',
        selectTemplate: 'انتخاب قالب',
        pageSettings: 'تنظیمات صفحه',
        ide: {
          categories: {
            writing: 'نوشتار',
            H1: 'H1',
            H2: 'H2',
            H3: 'H3',
            H4: 'H4',
            H5: 'H5',
            H6: 'H6',
            Image: 'تصاویر',
            Text: 'پاراگراف',
            Div: 'Div',
            Row: 'سطر',
            Col: 'ستون',
            BlockQuate: 'نقل قول',
            Alert: 'هشدار',
            Button: 'کلید',
            ButtonGroup: 'لیست کلیدها',
            Cards: 'کارت ها',
            EmptyCard: 'کارت خالی',
            DefaultCard: 'کارت معمولی',
            CardWithLink: 'کارت با لینک',
            ProductCard: 'کارت معرفی محصول',
            CardBody: 'بدنه کارت',
            CardHeader: 'سربرگ کارت',
            CardFooter: 'پاورقی کارت',
            ProductProperties: 'مشخصات محصول',
            Property: 'ویژگی',
            CardLink: 'لینک کارت',
            Forms: 'فرم ها',
            EmptyForm: 'فرم خالی',
            TextInput: 'ورودی متن',
            NumberInput: 'ورودی عددی',
            EmailInput: 'ورودی ایمیل',
          },
          element: {
            pleaseentertitle: 'عنوان را بنویسید',
            h1: 'سرفصل 1',
            h2: 'سرفصل 2',
            h3: 'سرفصل 3',
            h4: 'سرفصل 4',
            h5: 'سرفصل 5',
            h6: 'سرفصل 6',
            image: 'تصاویر',
            text: 'متن',
            html: 'محتوای html',
            row: 'سطر',
            col: 'ستون',
            blockquata: 'نقل قول',
            blockquatatitle: 'عنوان نقل قول',
            blockquatasource: 'منبع نقل قول',
            blockquatasourcetext: 'منبع ',
            blockquatasourcetitle: 'عنوان منبع',
            alerttext: 'متن هسدار',
            button: 'کلید',
            buttentitle: 'عنوان کلید',
            buttongroup: 'لیست کلید ها',
            defaultcard: 'کارت معمولی',
            cardheader: 'سربرگ کارت',
            cardbody: 'بدنه کارت',
            cardfooter: 'پاورقی کارت',
            cardtext: 'متن کارت',
            paragraphtext: 'متن درون پاراگراف',
            cardwithlink: 'کارت با لینک',
            subtitle: 'زیر عنوان',
            pleaseenetersubtitle: 'متن عنوان ثانویه را وارد کنید',
            firstlink: 'لینک اول',
            product: 'محصول',
            productdescription: 'توضیحات محصول',
            prodcutproperties: 'ویژگی های محصول',
            secondlink: 'لینک دوم',
            productproperty: 'ویژگی محصول',
            property: 'ویژگی',
            properties: 'ویژگی ها',
            link: 'لینک',
            linktext: 'متن لینک',
            form: 'فرم',
            textinput: 'ورودی متن',
            numberinput: 'ورودی عددی',
            emailinput: 'ورودی پست الکترونیکی',
          },
        },
      },
      voiceMessagesGroup: {
        title: 'گروه صداها',
        form: {
          editTitle: 'ویرایش گروه صدا ',
          addTitle: 'گروه صدا جدید',
        },
      },
      voiceMessages: {
        title: 'صداها',
        form: {
          addTitle: 'افزودن پیام صوتی ',
          editTitle: 'ویرایش وضعیت',
          fields: {
            voiceFile: 'فایل صوتی',
            voiceText: 'متن موردنظر',
            sendingMethod: 'روش ارسال',
          },
          legends: {
            voiceInformation: 'مشخصات فایل صوتی',
            uploadVoiceFile: 'آپلود فایل',
            voiceReader: 'آواخوان',
          },
          messages: {
            generalExplanation:
              '<span> ● جهت ایجاد فایل صوتی ، در ابتدا یک عنوان برای فایل صوتی خود انتخاب نمائید.</span><span class="tw-mt-1"> ● در ادامه می توانید با یکی از روش های ارسال <b>آپلود فایل</b> یا <b>آواخوان (ابزار تبدیل متن به گفتار ) </b>فایل صوتی خود را ایجاد نمایید.</span><b class="text-danger tw-mt-1"> ● توجه داشته باشید هر بخش پیامک معادل 30 ثانیه است .</b>',
            fileUploadGuid:
              '<span> ● در این روش شما می توانید فایل صوتی خود را بارگذاری کنید.</span><span> ● فرمت مجاز فایل صوتی<b>MP3 , WAV</b>و حداکثر حجم مجاز فایل<b> 5 مگابایت </b>می باشد.</span>',
            textToVoiceGuid:
              '<span> ● در این روش شما می توانید فایل صوتی خود را با استفاده از ابزار تبدیل متن به گفتار ایجاد نمائید.</span><span> ● در ابتدا جنسیت صدای گوینده گفتار را مشخص کنید.</span><span> ● در ادامه متن موردنظر خود را بنوسید . برای اینکه گفتار واضح تری داشته باشید از حروف تنوین استفاده نمائید.</span><span> ● در نهایت با زدن کلید پخش متن موردنظر به گفتار تبدیل می شود.</span>',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      medias: {
        title: 'فایل های شبکه اجتماعی',
        form: {
          addTitle: 'افزودن فایل های شبکه اجتماعی ',
          editTitle: 'ویرایش وضعیت',
          fields: {
            fileSizePerKilobyte: 'سایز فایل(Kb)',
            fileTypes: 'نوع فایل',
            url: 'فایل',
          },
        },
      },
      resellerUsers: {
        title: 'لیست کاربران فروشنده',
        form: {
          addTitle: ' کاربر جدید',
          editTitle: 'ویرایش اطلاعات کاربر',
          fields: {
            foreignerCode: 'کد اتباع',
            zoneId: 'منطقه',
            password: 'کلمه عبور',
            secondPassword: 'کلمه عبور دوم',
            isAdmin: 'مدیر',
            isAuthenticatedMobile: 'تایید موبایل',
            roleTemplateId: 'قالب نقش',
            nationalCode: 'کدملی/کداتباع',
            isActiveSend: 'ارسال فعال',
            isAuthenticated: 'احرازهویت',
            parentOrganizationName: 'سازمان والد',
            roles: 'نقش ها',
            isSendSmsDescriptionRequired:
              'اجباری بودن توضیحات موقع ارسال کاربران',
            isCanSeeContactsOfPrivatePhonebooks: 'مشاهده مخاطبین دفترچه خصوصی',
            isCanSeeContactsOfPublicPhonebooks: 'مشاهده مخاطبین دفترچه خصوصی',
            isCanSendSmartWithoutConfirmation: 'امکان ارسال هوشمند بدون تایید',
          },
          legends: {
            personalInformation: 'مشخصات کاربری',
            systemInformation: 'مشخصات سیستمی',
            authentication: 'احراز هویت ',
            roleInformation: 'نقش ها',
          },
        },
      },
      resellerOrganization: {
        title: 'لیست سازمان فروشنده',
        organizationsExcel: 'دانلود اکسل سازمان های فروشنده',
        form: {
          fields: {
            isActiveSend: 'ارسال فعال',
            isActive: 'فعال',
            isRealPerson: 'حقیقی',
            isAuthenticated: 'احرازهویت',
            groupPriceCategoryTitle: 'تعرفه',
            groupPriceTitle: 'بازه',
            domainName: 'دامنه',
            panelPrice: 'قیمت پنل',
            isPostpaid: 'پس پرداخت',
          },
        },
      },
      discount: {
        title: 'تخفیف ها',
        discountUse: 'تخفیف های اعمال شده',
        form: {
          addTitle: 'افزودن تخفیف',
          editTitle: 'ویرایش تخفیف',
          fields: {
            discountCode: 'کد تخفیف',
            discountType: 'نوع تخفیف',
            isPercentage: 'تخفیف درصدی',
            discountPercentageValue: 'درصد تخفیف',
            discountValue: 'مبلغ تخفیف',
            maximumAmount: 'حداکثر میزان تخفیف',
            maximumUse: 'حداکثر تعداد استفاده',
            specialOrganization: 'سازمان ویژه',
          },
          legends: {
            discountInformation: 'مشخصات تخفیف',
          },
        },
      },
      excelRequest: {
        title: 'درخواست اکسل',
        form: {
          changeStatusTitle: 'تغییر وضعیت',
          fields: {
            path: 'مسیر',
            type: 'نوع',
            isReadyForDownload: 'آماده دانلود',
            errors: 'خطا ها',
          },
        },
      },
      plans: {
        title: 'پلن ها',
        plansManagementTitle: 'مدیریت پلن ها',
        form: {
          addTitle: 'تعریف پلن جدید',
          editTitle: 'ویرایش پلن',
          legends: {
            planSpecifications: 'مشخصات پلن',
            modules: 'ماژول ها',
          },
          fields: {
            planType: 'نوع پلن',
            extentionPrice: 'هزینه تمدید',
            planInformation: 'اطلاعات پلن',
            planPrice: 'قیمت پلن',
          },
        },
        planListModuleForUser: {
          title: 'خرید ماژول',
          form: {
            legend: 'خرید ماژول',
            PlanModuleBought: 'مشخصات پلن خریداری شده',
          },
        },
        planListPackageForUser: {
          title: 'خرید پکیج',
          form: {
            legend: 'خرید پکیج',
            PlanModuleBought: 'مشخصات پلن خریداری شده',
          },
        },
      },
      zonePostalCodes: {
        title: 'کدپستی مناطق',
        form: {
          addTitle: 'ایجاد کدپستی مناطق',
          editTitle: 'ویرایش کدپستی مناطق',
          legend: 'اطلاعات کدپستی مناطق',
          fields: {
            otherCount: 'سایر',
            rightelCount: 'رایتل',
            mtnCount: 'ایرانسل',
            mciCount: 'همراه اول',
          },
        },
      },
      informationUsersSeen: {
        title: 'کاربران مشاهده کننده اخبار',
        fields: {
          seenDateTime: 'تاریخ مشاهده',
        },
      },
      sendSmartSmsToResidents: {
        title: 'ارسال هوشمند به ساکنین محدوده',
        createRequest: 'ایجاد درخواست',
        errors: {
          mostSelectPolygon:
            'برای ثبت درخواست می بایست حداقل یک محدوده را در نقشه مشخص کرده باشید.',
        },
      },
      occasionScheduledMessage: {
        title: 'لیست درخواست های ارسال مناسبتی',
        form: {
          fields: {
            phonebookCustomFieldNameEn: 'فیلد سفارشی',
            calenderEvent: ' مناسبت تقویمی',
            toConsiderYear: '  سال در نظر گرفته شود',
            calenderOrganizationEvent: 'مناسبت سازمانی ',
            dynamicTemplateTitle: 'قالب پویا',
            howManyDaysSendItBeforeDueDate: 'ارسال قبل از تاریخ رویداد (روز)',
          },
        },
      },
      shortLinks: {
        title: 'لینک های کوتاه',
        descendantTitle: 'لینک های کوتاه سازمان های زیرمجموعه',
        form: {
          addTitle: 'ایجاد لینک کوتاه',
          legend: 'لینک کوتاه',
          fields: {
            shortUrl: 'لینک کوتاه',
            mainUrl: 'لینک اصلی',
            urlType: 'نوع لینک',
          },
        },
      },
      phonebookFileProgresses: {
        title: 'وضعیت ایجاد مخاطبین',
        fields: {
          fileName: 'نام فایل',
          status: 'وضعیت',
          phonebookId: 'شناسه دفترچه ',
          phonebookName: 'نام دفترچه',
          progressPercent: 'درصد پیشرفت',
          totalCount: 'تعداد کل',
        },
      },
      customerClubDevice: {
        title: 'تنظیمات دستگاه',
        form: {
          addTitle: 'ایجاد تنظیمات دستگاه',
          editTitle: 'ویرایش تنظیمات دستگاه',
          detailTitle: 'جزئیات تنظیمات دستگاه',
          legends: {
            generalInformation: 'اطلاعات کلی',
            details: 'پاسخ',
            phonebooksList: 'لیست دفترچه تلفن ها',
          },
          fields: {
            deviceId: 'شناسه دستگاه',
            webhookUrl: 'آدرس وب هوک',
            phonebookIdList: 'لیست شناسه های دفترتلفن',
            delayType: 'نوع تاخیر در ارسال',
            delayValue: 'میزان تاخیر در ارسال',
            isShowDetail: 'نمایش فرم جزئیات',
          },
        },
      },
      customerClubDeviceNumbers: {
        title: 'شماره های دستگاه',
      },
      frontAudits: {
        title: 'لاگ های فرانت',
      },
      calendarEvent: {
        title: 'مناسبت های تقویمی',
        calendarEvents: 'مناسبت های تقویمی',
        calenderOrganizationEvents: 'مناسبت های ایجاد شده سازمانی',
        form: {
          addTitle: 'ایجاد مناسبت',
          editTitle: 'ویرایش مناسبت',
          deleteTitle: 'حذف مناسبت',
          detailTitle: 'جزئیات مناسبت',
          filterTitle: 'فیلتر مناسبت ها',
          fields: {},
        },
      },

      smartSmsCampaigns: {
        title: 'لیست خاکستری',
        form: {
          addTitle: 'ایجاد لیست خاکستری ',
        },
      },
      smartSmsClubs: {
        title: 'لیست باشگاه مشتریان هوشمند',
        form: {
          addTitle: 'ایجاد باشگاه مشتریان هوشمند',
          addNumbersTitle: 'افزودن شماره به باشگاه',
        },
      },
      numbersAggregator: {
        title: 'استعلام اپراتور شماره ها',
        numbersAggregatorList: 'لیست استعلام اپراتور شماره ها',
      },
      numbersBlackLists: {
        title: 'استعلام لیست سیاه',
        numbersBlackListsList: ' استعلام لیست سیاه شماره ها',
      },
      contactsByCellPhone: {
        title: 'لیست مخاطبین',
        form: {
          editTitle: 'ویرایش مخاطبین',
          legend: 'اطلاعات مخاطب',
          fields: {
            contactCreateType: 'نوع ایجاد',
            job: 'شغل',
            phonebookTypes: 'نوع دفترچه تلفن',
          },
          messages: {
            description:
              'توجه: با ویرایش اطلاعات، مقادیر جدید جایگزین مقادیر قبلی میشوند.',
          },
        },
      },
      queuesStatistics: {
        title: 'آمار صف های ربیت',
        fields: {},
      },
      smartSmsClubFileProgresses: {
        form: {
          fields: {
            smartSmsClubTitle: 'عنوان ',
            progressPercent: 'درصد پیشرفت',
            failedReason: 'علت خطا',
            totalCount: 'تعداد کل',
            status: 'وضعیت',
          },
        },
      },
      fieldsManagement: {
        title: 'مدیریت فیلدها',
        form: {
          addTitle: 'ایجاد فیلد',
          editTitle: 'ویرایش فیلد',
          legend: 'اطلاعات فیلد',
          fields: {
            fieldType: 'نوع فیلد',
            maxValue: 'حداکثر مقدار',
            minValue: 'حداقل مقدار',
            maxLength: 'حداکثر تعداد کاراکتر',
            minLength: 'حداقل تعداد کاراکتر',
            regexValidation: 'Regex',
            maxFileSizeByMegabyte: 'حداکثر سایز فایل(مگابایت)',
          },
        },
      },
      formsManagement: {
        title: 'مدیریت فرم ها',
        form: {
          addTitle: 'ایجاد فرم',
          editTitle: 'ویرایش فرم',
          legend: 'اطلاعات فرم',
          fields: {
            fieldType: 'نوع فیلد',
            maxValue: 'حداکثر مقدار',
            minValue: 'حداقل مقدار',
            maxLength: 'حداکثر طول',
            minLength: 'حداقل طول',
            regexValidation: 'Regex',
            maxFileSizeByMegabyte: 'حداکثر سایز فایل(مگابایت)',
            theme: 'تم',
            field: 'فیلد',
            order: 'ترتیب',
          },
        },
      },
      smartSmsNumberClasses: {
        title: 'لیست کلاس ها',
        form: {
          addTitle: 'افزودن کلاس',
          editTitle: 'ویرایش کلاس',
          legend: 'اطلاعات کلاس',
          fields: {
            operatorClasses: 'کلاس های اپراتور',
          },
        },
      },
      checkNumberClassResponses: {
        title: 'لیست درخواست ها',
        form: {
          addTitle: '',
          editTitle: '',
          fields: {
            checkTime: 'زمان بررسی',
          },
        },
      },
      onlineSurveyList: {
        title: 'لیست نظرسنجی',
      },
      onlineSurveyResponses: {
        title: 'پاسخ های نظرسنجی',
      },
      onlineSurveyStatistics: {
        title: 'آمار نظرسنجی',
      },
      createSmsInformation: {
        title: 'ارسال خبر',
      },
      processTextResults: {
        title: 'تحلیل متن پیامک',
      },
    },
    enums: {
      Desktop: {
        MainDesktop: 'محیط کار پایه',
        OrangeDesktop: 'محیط کار نارنجی',
        WindowsDesktop: 'محیط کار ویندوز',
        AndroidDesktop: 'محیط کار اندروید',
        Default: 'پیش فرض',
        Dark: 'مشکی',
      },
      LoginTheme: {
        Default: 'پیش فرض',
        Dark: 'مشکی',
      },
      ComparisonOperator: {
        EqualTo: 'برابر با',
        NotEqualTo: 'به جز',
        GreaterThan: 'بیشتر از',
        GreaterThanOrEqual: 'برابر یا بیشتر از ',
        LessThan: 'کمتر از ',
        lessThanOrEqual: 'برابر یا کمتر از',
        Contains: 'شامل',
        NotContains: 'شامل نشود',
        StartsWith: 'شروع با',
        EndsWith: 'خاتمه با',
      },
      SenderAgentType: {
        SMS: 'SMS',
        MMS: 'MMS',
        Email: 'ایمیل',
        Voice: 'voice',
      },
      SmsCp: {
        Magfa: 'مگفا',
        Asanak: 'آسانک',
        Armaghan: 'ارمغان',
        RahyabRG: 'رهیاب رایانه گستر',
        RahyabPG: 'رهیاب پیام گستران',
        SLS: 'سرزمین هوشمند',
        Shreeweb: 'بین الملل (Shreeweb)',
        SocialNetworks: 'شبکه های اجتماعی',
        Avanak: 'آوانک',
        Gama: 'گاما',
        PishgamRayan: 'پیشگام رایان ',
      },
      TypePrivateNumber: {
        Bulk: 'Bulk',
        InteractiveBulk: 'InteractiveBulk',
        SmsMT: 'SmsMT',
        SmsMO: 'SmsMO',
        USSDMT: 'USSDMT',
        USSDMO: 'USSDMO',
        OPT: 'OPT',
      },
      SendPriority: {
        Lowest: 'بی اهمیت',
        VeryLow: 'خیلی کم',
        Low: 'کم',
        Normal: 'متوسط',
        AboveNormal: 'بالاتر از حد معمول',
        High: 'زیاد',
        VeryHigh: 'خیلی زیاد',
        Highest: 'فوری',
      },
      PrivateNumberUseForm: {
        OneNumber: 'تک شماره',
        Mask: 'نام تجاری',
        RangeNumber: 'شماره بازه ای',
      },
      ZoneType: {
        Country: 'کشور',
        Province: 'استان',
        City: 'شهر',
        Area: 'منطقه',
      },
      PeriodTypeValue: {
        Minute: 'دقیقه',
        Hour: 'ساعت',
        Daily: 'روز',
        Weekly: 'هفته',
        Monthly: 'ماه',
        Yearly: 'سال',
      },
      SmsSentPeriodType: {
        Minute: 'دقیقه ای',
        Hour: 'ساعتی',
        Daily: 'روزانه',
        Weekly: 'هفته ای',
        Monthly: 'ماهیانه',
        Yearly: 'سالیانه',
      },
      PeriodType: {
        Minute: 'دقیقه',
        Hour: 'ساعتی',
        Daily: 'روزانه',
        Second: 'ثانیه ',
      },
      SendSubTypes: {
        Direct: 'مستقیم',
        Gradual: 'تدریجی',
        Periodic: 'دوره ای',
        GradualPeriodic: 'تدریجی دوره ای',
        Voice: 'صوتی',
      },
      TypeBanks: {
        EghtesadNovin: 'اقتصاد نوین',
        Pasargad: 'پاسارگاد',
        Parsian: 'پارسیان',
        Tat: 'آینده',
        Tejarat: 'تجارت',
        Saman: 'سامان',
        Sepah: 'سپه',
        Shahr: 'شهر',
        Saderat: 'صادرات',
        Mehr: 'مهر',
        Keshavarzi: 'کشاورزی',
        Gardeshgari: 'گردشگری',
        Maskan: 'مسکن',
        Mellat: 'ملت',
        Melli: 'ملی',
      },
      SmartSmsStatus: {
        Done: 'تکمیل شده',
        Failed: 'ناموفق',
        InternalError: 'خطای داخلی',
        NotFound: 'پیدا نشد',
        Stored: 'ذخیره شده',
        Unknown: 'نامشخص',
        Waiting: 'در انتظار',
      },
      TypeIpGs: {
        Sadad: 'سداد',
        BehPardakht: 'به‌پرداخت',
        Aap: 'آپ',
        Top: 'تاپ',
        Saman: 'سامان',
        Sepehr: 'سپهر',
        IdPay: 'آیدی پی',
        IranKish: 'ایران کیش',
        Melli: 'ملی',
        ParbadVirtual: 'پرباد',
        Parsian: 'پارسیان',
        Pasargad: 'پاسارگاد',
        ZarinPal: 'زرین پال',
        PayIr: 'پی',
        Mellat: 'ملت',
        AsanPardakht: 'آسان پرداخت',
      },
      DeliveryStatus: {
        Unknown: 'نامشخص',
        SentAndReceivedbyPhone: 'ارسال موفق و دریافت توسط گوشی ',
        HaveNotReceivedToPhone: 'نرسیده به گوشی ',
        SentToItc: 'ارسال به مخابرات',
        ReceivedByItc: 'رسیده به مخابرات',
        DidNotReceiveToItc: 'نرسیده به مخابرات',
        NotReceivebyServer: 'توسط سرور دریافت نشده',
        ErrorInSending: 'خطا در ارسال',
        WaitingForSend: 'منتظر ارسال',
        Sent: 'ارسال شده',
        NotSent: 'ارسال نشده',
        Expired: 'منقضی',
        IsSending: 'در حال ارسال',
        IsCanceled: 'کنسل شده',
        BlackList: 'لیست سیاه',
        SmsIsFilter: 'متن پیامک فیلتر شده',
        IsDeleted: 'حذف شده',
        WatingForConfirmation: 'منتظر برای تایید',
        NotEnoughBalance: 'کمبود اعتبار',
        IsPreparing: 'درحال آماده سازی',
        IsPreparedForSending: 'آماده برای ارسال',
        AccessDenied: 'عدم دسترسی',
        TextIsEmpty: 'متن پیام خالی',
        InvalidInputXml: 'xml ورودی نامعتبر است',
        InvalidUserOrPassword: 'کاربر یا کلمه عبور نامعتبر',
        InvalidUsedMethod: 'متد استفاده شده نامعتبر ',
        InvalidSender: 'فرستنده نامعتبر',
        InvalidMobile: 'موبایل نامعتبر',
        InvalidReciption: 'هیچ گیرنده ای مشخص نشده',
        Stored: 'ذخیره شده',
        BlackListTable: 'وجود شماره در جدول بلک لیست ',
        GetDeliveryStatus: 'تقاضا جهت دریافت آخرین وضعیت',
        InvalidPrivateNumber: 'خط نامعتبر',
        NotReceiveByPhone: 'نرسیده به گوشی',
        NotReceivedByItc: 'نرسیده به مخابرات',
        DidNotReceivedByItc: 'نرسیده به مخابرات',
        ReceivedByPhone: 'رسیده به گوشی ',
      },
      SendStatus: {
        Unknown: 'نامشخص',
        Sent: 'به اپراتور ارسال شده',
        SentAndGiveBackCredit: 'ارسال شده و برگشت هزینه بررسی شده',
        ErrorInSending: 'خطا در ارسال',
        ErrorInGetItc: 'خطا در دریافت مخابرات',
        BlackList: 'لیست سیاه',
        Stored: 'ذخیره شده',
      },
      MainSettings: {
        SendSmsAlertMessage: ' هشدار ارسال پیامک',
        AppPath: 'مسیر نرم افزار',
        RemoteQueueIp: 'آی پی صف از راه دور',
        DefaultNumber: 'شناسه شماره پیش فرض ',
        IsRemoteQueue: 'صف از راه دور',
        VasRegisterSmsText: 'متن پیامک ثبت خدمات ارزش افزوده',
        MaximumFailedTryCount: 'حداکثر تعداد تلاش ناموفق',
        RetrievePasswordSmsText: 'متن پیامک بازیابی کلمه عبور',
        RegisterFishMobiles:
          'موبایل هایی که باید بعد از ثبت فیش برای آن ها پیامک ارسال شود',
        OnlinePaymentSmsText: ' پیامک پرداخت آنلاین',
        UserExpireSmsText: ' پیامک انقضا کاربر',
        RegisterFishSmsText: ' پیامک ثبت فیش',
        ExportFileAddress: 'آدرس فایل خروجی',
        Tax: 'مالیات',
        AuthenticatedMobileSmsText: 'متن پیامک احراز هویت موبایل',
        LowestCreditOfUser: 'کمترین میزان موجودی کاربر',
        ResolutionOfParliament: 'مصوبه مجلس',
      },
      GenderType: {
        All: 'نامشخص',
        Man: 'مرد',
        Woman: 'زن',
      },
      SimType: {
        All: 'هیچکدام',
        Credits: 'اعتباری',
        Permanent: 'دائمی',
      },
      FailureCode: {
        None: 'بدون خطا',
        UserCreditNotEnough: 'کمبود موجودی',
        AdminCreditNotEnough: 'کمبود موجودی مدیریت',
        PrivateNumberIsExpired: 'خط منقضی شده  ',
        UserIsInactive: 'کاربر غیر فعال ',
        AdminIsInactive: 'نام کاربری مدیر غیرفعال  ',
        PrivateNumberNotValid: 'خط معتبر نیست ',
        NotDefineSmsRateType: 'تعرفه ارسال پیامک  تعیین نشده  ',
        SendError: 'خطا در ارسال پیامک',
        UserCancelRequest: 'کاربر از انجام تراکنش منصرف شده ',
        SystemIsOutOfService: 'سرویس ارسال در دسترس نمی باشد',
        SendTimeNotValid: 'زمان ارسال خارج از بازه مجاز ارسال می باشد',
        SmsTextIsFilter: 'متن پیامک فیلتر می باشد',
        UserIsExpired: 'حساب کاربری منقضی شده ',
        AdminIsExpired: 'حساب مدیریت منقضی شده ',
        LinkIsNotAllowed: 'مجوز ارسال لینک برا شما فعال نمی باشد',
        RecipientNotExist: 'خطا در ارسال گیرندگان',
        ErrorCalculate: 'خطا در شناسایی ارسال',
        ErrorSelectNumber: ' خطای انتخاب شماره ',
        ErrorInSaveJob: ' خطا در ذخیره پیام برای ارسال',
        ScheduledMessageNotFound: 'پیام برنامه ریزی شده یافت نشد',
        OrganizationOrHierarchyIsInactive:
          'سازمان جاری یا یکی از سازمان های پدر غیرفعال است',
        GroupPriceIsNull: 'تعرفه وجود ندارد',
        OrganizationCreditNotEnough: 'کمبود موجودی سازمان',
        OperatorNumberCountIsNull: 'تعداد اپراتور صفر است',
        OrganizationNotFound: 'سازمان یافت نشد',
        NotSended: 'ارسال نشده',
        OrganizationIsExpired: 'سازمان منقضی شده',
        PrivateNumberIsInactive: 'خط غیرفعال',
        OrganizationIsInactive: 'سازمان غیرفعال',
      },
      SendTypes: {
        Bulk: 'انبوه',
        Dynamic: 'پویا',
        P2P: 'نظیر به نظیر',
        Single: 'تکی',
        PhoneBook: 'دفترچه تلفن',
        Api: 'Api',
      },
      QueueStatus: {
        Completed: 'تکمیل شده',
        Confirmed: 'تایید شده',
        Extracted: 'استخراج شده',
        Extracting: 'استخراج کردن',
        Failed: 'ناموفق',
        FailedExtract: 'استخراج ناموفق',
        Ready: 'آماده ارسال',
        Rejected: 'رد شده',
        Stored: 'ذخیره شده',
        Updating: 'در حال بروزرسانی',
        WatingForConfirm: 'در انتظار تایید',
      },
      SmsAggregator: {
        NotValid: 'نامعتبر',
        MCI: 'همراه اول',
        MCI2: 'MCI2',
        Irancell: 'ایرانسل',
        Rightel: 'رایتل',
        Other: 'سایر',
        International: 'بین الملل',
        // Taliya: 'تالیا',
        // MTCE: 'اسپادان',
        // KishTCI: 'همراه کیش',
      },
      SmsLanguage: {
        Farsi: 'فارسی',
        Latin: 'لاتین',
      },
      UseTypes: {
        Unknown: 'نامشخص',
        Normal: 'معمولی',
        WebService: 'وب سرویس',
      },
      NumberType: {
        Public: 'عمومی',
        Private: 'خصوصی',
        PrivateWithKeyword: 'خصوصی با کلمه ی کلیدی',
      },
      TypeCreditChanges: {
        Manage: 'مدیریت',
        BuyPanel: 'خرید پنل',
        ExtendedPanel: 'تمدید پنل',
        Fish: 'فیش بانکی',
        OnlinePayment: 'پرداخت آنلاین',
        PriceNumber: 'هزینه خط اختصاصی',
        ActivationService: 'فعال سازی سرویس ها',
        GiveBackCostOfUnsuccessSent: 'برگشت هزینه ارسال های ناموفق',
        ActivationGeneralPhoneBook: 'فعال سازی گروه های ویژه',
        SendSms: 'ارسال پیامک',
        DeleteUser: 'حذف کاربر',
        TransferPrivateNumber: 'انتقال خط',
      },
      TypeTransactions: {
        Increase: 'افزایشی',
        Decrease: 'کاهشی',
      },
      UserDocuments: {
        BirthCertificate: 'شناسنامه',
        NationalCard: 'کارت ملی',
        OptionalField1: 'فیلد دلخواه 1',
        OptionalField2: 'فیلد دلخواه 2',
      },
      OrganizationDocuments: {
        BusinessLicense: 'مجوز کسب و کار',
        CeoBirthCertificate: 'شناسنامه مدیر عامل',
        CeoNationalCard: 'کارت ملی مدیرعامل',
        FoundedAnnounce: 'اطلاعیه ی تاسیس',
        LatestChangesAnnounce: 'اعلام آخرین تغییرات',
        OptionalField1: 'فیلد دلخواه 1',
        OptionalField2: 'فیلد دلخواه 2',
      },
      DocumentStatus: {
        NotCheckedYet: 'هنوز تایید نشده',
        Accepted: 'تایید شده',
        NotAccepted: 'رد شده',
      },
      CustomFieldTypes: {
        Boolean: 'مقدار فعال / غیرفعال',
        Datetime: 'تاریخ و زمان',
        Float: 'عدد اعشاری',
        Integer: 'عدد صحیح',
        String: 'متن',
      },
      TypePayments: {
        Cash: 'نقدی ',
        Cheque: 'پرداخت چک ',
        Card: 'کارت به کارت ',
        Account: 'واریز به حساب ',
        OnLine: 'پرداخت آنلاین ',
      },
      TypePaymentStatus: {
        Confirmed: 'تایید شده',
        Rejected: 'رد شده',
        Checking: 'درحال بررسی',
        Lending: 'نسیه',
        WatingForPay: 'در انتظار پرداخت',
      },
      OutBoxStatus: {
        Stored: 'ذخیره شده',
        WatingForSend: 'در انتظار ارسال',
        IsBeingSent: 'در حال ارسال',
        Sent: 'ارسال شد',
        SentAndGiveBackCredit: 'ارسال و گرفتن اعتبار',
        Archived: 'بایگانی شد',
        ErrorInSending: 'خطا در ارسال',
        ErrorInGetItc: 'خطا در گرفتن مخابرات',
        BlackList: 'لیست سیاه',
        WatingForConfirm: 'در انتظار تایید',
        Archiving: 'بایگانی کردن',
      },
      Encoding: {
        English: 'انگلیسی',
        Persian: 'فارسی',
      },
      ExportDataStatus: {
        None: 'هیچکدام',
        Get: 'Get',
        Complete: 'Complete',
        Refresh: 'Refresh',
      },
    },
    common: {
      fa: 'فارسی',
      en: 'انگیسی',
      lang: 'زبان',
      dateTime: {
        minute: 'دقیقه',
        hour: 'ساعت',
        day: 'روز',
        week: 'هفته',
        month: 'ماه',
        year: 'سال',
      },
      seasons: {
        Spring: 'فروردین',
        Summer: 'اردیبهشت',
        Fall: 'خرداد',
        Winter: 'تیر',
      },
      daysOfTheWeek: {
        saturday: 'شنبه',
        sunday: 'یکشنبه',
        monday: 'دوشنبه',
        tuesday: 'سه شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنجشنبه',
        friday: 'جمعه',
      },
      calenderDate: {
        solar: 'هجری شمسی',
        ad: 'میلادی',
        lunar: 'هجری قمری',
      },
      color: {
        red: 'قرمز',
        blue: 'آبی',
        purple: 'بنفش',
        gray: 'طوسی',
        navyBlue: 'سرمه ای',
        white: 'سفید',
        green: 'سبز',
        yellow: 'زرد',
        pink: 'صورتی',
      },
      preview: 'پیش نمایش',
      files: 'فایل‌ها',
      replace: 'جایگذاری',
      manual: 'دستی',
      noDataFound: 'اطلاعاتی برای نمایش وجود ندارد!',
      rial: 'ریال',
      allCount: 'تعداد کل',
      sendedCount: 'تعدد ارسال شده',
      row: 'ردیف',
      mobileNumbersCount: 'تعداد شماره موبایل ها ',
      changeMobileNumber: 'تغییر شماره موبایل',
      name: 'نام',
      newName: 'نام جدید',
      firstName: 'نام',
      lastName: 'نام خانوادگی',
      fatherName: 'نام پدر',
      fullName: 'نام و نام خانوادگی ',
      nationalCode: 'کد ملی',
      messageCancelText: 'متن لغو',
      level: 'سطح',
      nationalId: 'شناسه ملی',
      showCalender: 'نمایش تقویم',
      selectedDaysCount: 'تعداد روزهای انتخاب شده',
      chooseSendDays: 'انتخاب روزهای ارسال',
      email: 'ایمیل',
      street: 'خیابان',
      dehestan: 'دهستان',
      neighbourhood: 'محله',
      highway: 'بزرگراه',
      freeway: 'آزادراه',
      tunnel: 'تونل',
      square: 'میدان',
      boulevard: 'بلوار',
      university: 'دانشگاه',
      county: 'شهرستان',
      park: 'پارک',
      captcha: 'کد امنیتی',
      chosen: 'انتخاب شده',
      retry: 'تلاش مجدد',
      SMSSignatureIsEnabled: 'امضای پیامک فعال است',
      faxNumber: 'شماره فکس',
      phone: 'تلفن ثابت',
      referenceId: 'شناسه مرجع',
      occasionScheduledMessageId: 'شناسه ارسال مناسبتی',
      identityNumber: 'شماره شناسنامه',
      birthDate: 'تاریخ تولد',
      gender: 'جنسیت',
      title: 'عنوان',
      group: 'گروه',
      projectName: 'نام پروژه',
      dateExpire: 'تاریخ انقضا',
      dateStart: 'تاریخ شروع',
      projectVersion: 'نسخه پروژه',
      projectConfig: 'تنظیمات پروژه',
      assignDate: 'تاریخ تخصیص',
      PrivateNumberCreated: 'تاریخ ثبت خط اختصاصی',
      claimGroup: 'لیست دسترسی ها',
      active: 'فعال',
      count: 'تعداد',
      file: 'فایل',
      activeSend: 'ارسال فعال',
      sendWithDuplicateNumbers: 'ارسال با شماره های تکراری',
      credit: 'اعتبار',
      mobile: 'شماره موبایل',
      select: 'انتخاب',
      public: 'عمومی',
      private: 'خصوصی',
      parentPublic: 'والد عمومی',
      year: 'سال',
      firstYear: 'سال اول',
      secondYear: 'سال دوم',
      month: 'ماه',
      day: 'روز',
      text: 'متن',
      downloadLink: 'لینک دانلود',
      voiceFileDownloadLink: 'لینک دانلود فایل صوتی',
      voiceFile: 'فایل صوتی',
      voiceMessage: 'پیام صوتی',
      socialMediaApplication: 'برنامه شبکه اجتماعی',
      socialMediaMessage: 'فایل شبکه اجتماعی',
      patch: 'مسیر',
      receipt: 'دریافتی',
      sender: 'ارسالی',
      farsi: 'فارسی',
      latin: 'لاتین',
      nonFarsi: 'غیرفارسی',
      data: 'داده',
      sms: 'پیامک',
      part: 'بخش',
      requestsList: 'لیست درخواست ها',
      binary: 'باینری',
      userName: 'نام کاربری',
      password: 'کلمه عبور',
      rePassword: 'تکرار کلمه عبور',
      newRePassword: 'تکرار کلمه عبور جدید',
      show: 'مشاهده',
      oldPassword: 'کلمه عبور فعلی',
      newPassword: 'کلمه عبور جدید',
      price: 'قیمت',
      number: 'خط',
      save: 'ذخیره',
      maxSendCount: 'حداکثر تعداد ارسال',
      allRecords: 'تعداد کل رکوردها:',
      amount: 'مبلغ',
      notValid: 'معتبر نمی‌باشد.',
      validMobile: 'شماره همراه معتبر می‌باشد',
      notValidMobile: 'شماره همراه نامعتبر می‌باشد',
      setting: 'تنظیمات',
      privateNumber: 'شماره اختصاصی',
      privateNumbers: 'شماره های اختصاصی',
      isAuthenticated: 'احراز هویت',
      isAuthenticatedMobile: 'تایید موبایل',
      organizationName: 'نام سازمان',
      isForeigner: 'اتباع خارجی',
      id: 'شناسه',
      warning: 'هشدار',
      login: 'ورود',
      lockOut: 'مسدود',
      unblock: 'رفع مسدودی',
      sendSubType: 'ارسال',
      sendSubDateType: 'نوع زمان ارسال ',
      loginToUserAccount: 'ورود به حساب کاربر',
      loginOrganization: 'ورود به سازمان',
      loginToAccount: 'ورود به حساب ',
      loginWithIdentity: 'ورود با سامانه احراز هویت',
      signUpWithIdentity: 'ثبت نام با سامانه احراز هویت',
      rememberMe: 'مرا بخاطر بسپار',
      forgetPassword: 'فراموشی کلمه عبور',
      editPassword: 'تغییر کلمه عبور',
      signUp: 'ثبت نام',
      goToLogin: 'رفتن به صفحه ورود',
      account: 'حساب',
      receivers: 'گیرندگان',
      fastSend: 'ارسال سریع',
      testSend: 'ارسال تست',
      tableSetting: 'سفارشی‌سازی ستون‌ها',
      defaultGroupPrice: 'تعرفه پیش فرض',
      PhonebookRecipient: 'گیرندگان ارسال دفترچه تلفن',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      description: 'توضیحات',
      minPrice: 'حداقل قیمت',
      maxPrice: 'حداکثر قیمت',
      typeBank: 'بانک ',
      operation: 'عملیات',
      createDate: 'تاریخ ثبت',
      pattern: 'قالب',
      messageInformation: 'مشخصات پیامک',
      sendDateTimeType: 'تنظیمات ارسال',
      confirmSmartSmsRequest: 'ارسال پیامک هوشمند ',
      createRecepientForPeriodicSmartSms: 'ایجاد کمپین ارسال هوشمند',
      justSendToWhiteList: 'فقط ارسال به لیست سفید',
      scheduledMessageId: 'شناسه ارسال',
      lastModifiedDate: 'تاریخ ویرایش',
      expireDate: 'تاریخ انقضا',
      expireTime: 'ساعت انقضا',
      authenticated: 'احراز هویت',
      addSingle: 'افزودن تکی مخاطب',
      addListNumber: 'افزودن شماره مخاطب لیستی',
      addFromFile: 'افزودن مخاطب از فایل',
      authenticatedMobile: 'تایید شماره موبایل',
      deleteAllContact: 'حذف تمامی مخاطبین',
      columns: 'لیست ستون ها',
      key: 'کلید',
      creditPayment: ' پرداخت اعتباری',
      onlinePayment: 'پرداخت آنلاین',
      value: 'مقدار',
      customText: 'متن دلخواه',
      searchFilter: 'فیلتر جستجو',
      userInfo: 'اطلاعات کاربری',
      userId: 'شناسه کاربری',
      userManual: 'راهنمای استفاده',
      createTemplate: 'طراحی قالب',
      numberList: 'لیست شماره',
      generalIndexes:
        'در صورت وارد نمودن اندیس گذاری کلی، اندیس های بالا در نظر گرفته نمی شود .',
      bulkSendDetail: 'جزئیات ارسال انبوه',
      merchantId: 'شماره پذیرنده',
      terminalId: 'شماره ترمینال',
      androidPreview: 'پیش نمایش اندروید',
      iosPreview: 'پیش نمایش ios',
      terminalKey: 'کلید ترمینال',
      userPassword: 'کلمه عبور کاربر',
      shaKey: 'کلید sha',
      loginAccount: 'ورود به حساب کاربری',
      merchantCode: 'کد پذیرنده',
      privateKey: 'کلید خصوصی',
      activationDate: 'تاریخ فعال شدن',
      acceptorId: 'کد پذیرنده',
      passPhrase: 'عبارت عبور',
      publicKey: 'کلید عمومی',
      sendPrice: 'هزینه ارسال کل',
      privateCode: 'کد خصوصی',
      merchantConfigurationId: 'شماره پیکربندی پذیرنده',
      creditNotEnough: 'اعتبار شما کافی نمی باشد!',
      generalUse: 'استفاده عمومی',
      usingTheInvoice: 'استفاده از فاکتور',
      generalIndexing: 'اندیس گذاری کلی',
      invoice: 'پیش فاکتور',
      orderId: 'شماره سفارش',
      resellerName: 'فروشنده',
      date: 'تاریخ',
      hour: 'ساعت',
      appVersion: 'ورژن سامانه ',
      minute: 'دقیقه',
      pishgamRayanDadehPajoohCo: 'شرکت پیشگام رایان داده پژوه',
      esfahan: 'اصفهان',
      phoneNumberFax: 'شماره تلفن / نمابر',
      postalCode: 'کد پستی',
      pishgamRayanAddress:
        'حد فاصل چهار راه آپادانا و سپهسالار، جنب بانک تجارت، ساختمان تندیس، طبقه ۴، واحد۴۱',
      organization: 'سازمان',
      getterOrganization: 'سازمان گیرنده',
      getterUser: 'کاربر گیرنده',
      currentOrganization: 'سازمان فعلی',
      organizations: 'لیست سازمان ها',
      shortcuts: 'دسترسی سریع',
      operator: 'اپراتور',
      smsEncoding: 'نوع پیام',
      domainId: 'شناسه دامنه',
      domainName: 'نام دامنه',
      parentId: 'شناسه والد',
      parentOrganization: 'سازمان والد',
      user: 'کاربر',
      chosenPhonebooks: 'دفترچه تلفن های انتخاب شده',
      deleteSelectedFile: 'حذف فایل انتخابی',
      users: 'کاربران',
      userList: 'لیست کاربران',
      organizationList: 'لیست سازمان ها',
      senderNumberId: 'ارسال کننده',
      characterCount: 'تعداد کاراکتر',
      smsBody: 'متن پیام',
      claimsCount: 'تعداد کل دسترسی ها',
      menusCount: 'تعداد کل منوها',
      selectedCount: 'انتخاب شده',
      domainHeader: 'هدر',
      convertToPersianNumbers: 'تبدیل ارقام به فارسی',
      realPerson: 'حقیقی',
      legalPerson: 'حقوقی',
      sendHour: 'ساعت ارسال',
      sendDay: 'روز ارسال',
      startDay: 'روز شروع',
      position: 'محل قرارگیری',
      permissions: 'مجوز ها',
      organSignatureAtFirst: 'امضای سازمان در ابتدا',
      privateNumberSignatureAtFirst: 'امضای ارسال کننده در ابتدا',
      organSmsHeaderAtFirst: 'سرتیتر سازمان در ابتدا',
      privateNumberSmsHeaderAtFirst: 'سرتیتر ارسال کننده در ابتدا',
      headerPosition: 'محل قرارگیری سرتیتر ارسال کننده',
      startTime: 'زمان شروع',
      trustMark: 'نماد اعتماد',
      startHour: 'ساعت شروع',
      endDay: 'روز پایان',
      endTime: 'زمان پایان',
      endHour: 'ساعت پایان',
      partCount: 'تعداد بخش',
      campaign: 'کمپین',
      campaignId: 'شناسه کمپین',
      groupPriceCategory: 'تعرفه',
      environmentInfo: 'اطلاعات محیط',
      logInfo: 'اطلاعات لاگ',
      hello: 'سلام',
      selectedTheme: 'انتخاب تم',
      selectedTemplate: 'انتخاب قالب',
      privateNumberList: 'لیست خطوط فعال',
      from: 'از',
      to: 'تا',
      groupDeletion: 'حذف گروهی',
      groupEdit: 'ویرایش گروهی',
      new: 'جدید',
      clickToShow: 'برای مشاهده کلیک کنید',
      phonebook: 'دفترچه تلفن',
      phonebooks: 'دفترچه تلفن ها',
      accountInformation: 'شماره حساب',
      accountInformationCardNo: 'شماره کارت',
      numberOfRecords: 'تعداد رکورد :',
      numberOfViews: 'تعداد نمایش',
      page: 'صفحه',
      panelPrice: 'قیمت پنل',
      username: 'نام کاربری ',
      loading: 'درحال بارگزاری',
      error: 'خطا',
      info: 'توجه',
      type: 'نوع',
      ipAddress: 'آدرس آی پی',
      browser: 'مرورگر',
      device: 'دستگاه',
      os: 'سیستم عامل',
      refreshToken: 'refresh Token',
      refreshTokenExpiration: 'تاریخ انقضا refresh Token',
      isActive: 'فعال',
      deActive: 'غیرفعال',
      personType: 'نوع شخص',
      yourCredit: 'اعتبار شما',
      isPublic: 'عمومی',
      isActiveSend: 'ارسال فعال',
      isDefault: 'پیش فرض',
      contactsCount: 'تعداد مخاطبین',
      changeDefault: 'تغییر پیش فرض',
      myOrganizations: 'سازمان‌های من',
      senderNumber: 'فرستنده',
      defaultOrganization: 'سازمان پیش فرض :',
      activeOrganization: 'سازمان فعال :',
      currentOrganizations: 'سازمان فعلی :',
      detail: 'جزئیات',
      mediaDetail: 'جزئیات شبکه های اجتماعی',
      male: 'مرد',
      female: 'زن ',
      mci: 'همراه اول',
      mtn: 'ایرانسل',
      rightel: 'رایتل',
      confirmSend: 'تایید ارسال',
      rejectSend: 'عدم تایید ارسال',
      organizationId: 'شناسه سازمان',
      currentStatus: 'وضعیت فعلی',
      changeStatusTo: 'تغییر وضعیت به',
      deliveryStatus: 'وضعیت تحویل',
      partLength: 'تعداد بخش',
      sendTo: 'ارسال به ',
      unknown: 'نامشخص',
      dynamicTemplate: 'قالب پویا',
      selectField: 'انتخاب فیلد',
      defineDynamicTemplate: 'تعریف قالب پویا',
      customField: 'فیلد سفارشی',
      customFields: 'فیلدهای سفارشی',
      showDetails: 'نمایش جزئیات',
      selectFilter: 'انتخاب فیلتر',
      English: 'انگلیسی',
      Persian: 'فارسی',
      format: 'قالب',
      increase: 'افزایشی',
      decrease: 'کاهشی',
      paymentId: 'شناسه پرداخت',
      typeTransaction: 'نوع تراکنش',
      whiteMessageId: 'شناسه باشگاه ',
      delete: 'حذف',
      edit: 'ویرایش',
      transferNumber: 'انتقال مالکیت',
      maxDailySendCount: 'حداکثر تعداد ارسال روزانه',
      authenticate: 'احراز هویت',
      uploadDocuments: 'آپلود مدارک',
      fromIndex: 'از اندیس',
      aggregator: 'اپراتور',
      toIndex: 'تا اندیس',
      documentation: 'مدارک',
      textBody: 'متن پیام',
      editStatus: 'ویرایش وضعیت',
      editStatusAll: 'ویرایش وضعیت همه',
      editStatusAllReceivers: 'ویرایش وضعیت تحویل گیرندگان',
      getNewDeliveryStatus: 'درخواست آخرین وضعیت تحویل',
      editReceiversStatus: 'ویرایش وضعیت تحویل گیرندگان',
      editDeliveryStatus: ' ویرایش وضعیت تحویل گیرندگان',
      selectiveEditDeliveryStatus: ' ویرایش انتخابی وضعیت تحویل گیرندگان',
      editDeliveryStatusByExcelFile:
        'ویرایش وضعیت تحویل گیرندگان با آپلود فایل',
      fileUpload: 'آپلود فایل',
      isUploaded: 'آپلود شده',
      yes: 'بله',
      no: 'خیر',
      ok: 'متوجه شدم',
      payment: 'پرداخت',
      discountCode: 'کد تخفیف',
      discount: 'تخفیف',
      success: 'موفق',
      nonSuccess: 'ناموفق',
      total: 'مجموع',
      signature: 'امضای پیامک',
      header: 'سرتیتر پیامک',
      smsCp: 'عامل ارسال پیامک',
      privateNumberSignature: 'امضای ارسال کننده ',
      privateNumberHeader: 'سرتیتر ارسال کننده ',
      organizationSignature: 'امضای سازمان ',
      organizationHeader: 'سرتیتر سازمان ',
      selectFile: 'انتخاب فایل',
      userOrganizations: 'سازمان های کاربر',
      cancel: 'انصراف',
      selectAll: 'انتخاب همه',
      all: 'همه موارد',
      allDayOfWeeK: 'همه روزهای هفته',
      every: 'همه',
      lat: 'عرض (lat)',
      lon: 'طول (lon)',
      distance: 'فاصله',
      importanceLevel: 'سطح اهمیت',
      notificationType: 'نوع پیام',
      distanceOnKm: 'فاصله (کیلومتر)',
      size: 'تعداد',
      closeAll: 'بستن همه',
      nextStep: 'مرحله بعد',
      close: 'بازگشت',
      roles: 'نقش ها',
      roleTemplate: 'قالب نقش ها',
      smsParts: 'بخش',
      smsText: 'پیامک',
      smsBodyText: 'متن پیامک',
      keyword: 'کلمه کلیدی',
      resendSMS: 'ارسال مجدد',
      twoFactorEnabled: 'تایید دو مرحله ای ',
      resendSMSByDeliverStatus: 'ارسال مجدد بر اساس وضعیت',
      resendDetail: 'جزئیات ارسال مجدد',
      address: 'آدرس',
      zipCode: 'کد پستی',
      myCredit: 'اعتبار من',
      currentUserCredit: 'اعتبار فعلی کاربر',
      organizationCredit: 'اعتبار سازمان',
      updateCredit: 'بروزرسانی اعتبار',
      status: 'وضعیت',
      submit: 'ثبت',
      confirm: 'تایید',
      back: 'بازگشت',
      up: 'بالا',
      down: 'پایین',
      sentDateTime: 'تاریخ ارسال',
      groupPriceList: 'تعرفه ها',
      rangeList: 'بازه‌ ها',
      endOfSmsBody: 'انتهای پیامک',
      startOfSmsBody: 'ابتدای پیامک',
      reporting: 'گزارش گیری',
      reportBuilder: 'گزارش ساز',
      report: 'گزارش',
      search: 'جستجو',
      searchPlace: 'مکان های اجتماعی',
      advanceSearch: 'جستجوی پیشرفته',
      groupPrice: 'بازه',
      add: 'افزودن',
      privateNumberPurchaseRules: 'قوانین خرید خط',
      currency: 'ریال',
      currencyWithParentheses: '(ریال)',
      addUser: 'افزودن کاربر جدید',
      toman: ' (تومان)',
      nextLevel: 'مرحله بعد',
      sendAuthCode: 'ارسال کد تایید',
      increaseCredit: 'افزایش اعتبار',
      decreaseCredit: 'کاهش اعتبار',
      creditTransfer: 'انتقال اعتبار',
      play: 'پخش',
      pause: 'متوقف',
      downloadFile: 'دانلود فایل',
      download: 'دانلود',
      downloadExcel: 'دانلود اکسل',
      downloadExcelWithMoreDetail: 'دانلود اکسل با جزئیات بیشتر',
      generalDisplay: 'نمایش کلی',
      groupPriceDetail: 'جزئیات تعرفه',
      displayMode: 'نحوه نمایش',
      displayWithDetails: 'نمایش با جزئیات',
      udhLen: 'وضعیت طول جدا کننده کاراکتر فارسی',
      print: 'چاپ',
      downloadAll: 'دانلود همه',
      saveToCampaign: 'ذخیره به عنوان کمپین',
      authCode: 'کد تایید',
      clearAll: 'پاک کردن همه',
      clear: 'پاک کردن',
      removeAll: 'حذف همه',
      empty: 'موردی یافت نشد!',
      confirmation: 'تایید',
      priority: 'اولویت',
      notConfirmation: 'عدم تایید',
      clipBoard: 'کلیپ بورد',
      onBackToPreviousAccount: 'بازگشت به حساب قبلی',
      language: 'زبان',
      darkMode: 'حالت شب',
      lightMode: 'حالت روز',
      privateNumberId: 'شناسه فرستنده',
      notifications: 'اعلان ها',
      logout: 'خروج از حساب',
      unreadMessages: 'پیام‌های خوانده‌نشده',
      allMessages: 'همه پیام‌ها',
      token: 'توکن',
      resend: 'ارسال مجدد',
      continuation: 'ادامه',
      sendSubmit: 'ثبت و ارسال',
      quickLinks: 'دسترسی سریع',
      refresh: 'بازیابی مجدد',
      refreshMenus: 'بازیابی منوها',
      menus: 'منوها',
      modules: 'ماژول ها',
      buy: 'خرید',
      filters: 'فیلترها',
      cpType: 'عامل ارسال',
      claims: 'دسترسی ها',
      sendSms: 'ارسال پیامک',
      editSendSms: 'ویرایش ارسال',
      specifications: 'مشخصات',
      titleAndTextHelp: 'عنوان و متن راهنما ',
      wordList: 'لیست کلمات',
      send: 'ارسال',
      changePassword: 'تغییر کلمه عبور',
      useType: 'نوع استفاده',
      changeOrganization: 'تغییر سازمان',
      country: 'کشور',
      state: 'استان',
      province: 'استان',
      city: 'شهر',
      area: 'منطقه',
      mobilePrefix: 'پیش شماره',
      bank: 'بانک',
      field: 'فیلد',
      depositPrice: 'مبلغ پرداختی',
      originalPrice: 'میزان شارژ',
      purchaseDate: 'تاریخ خرید',
      remainingCredit: 'اعتبار باقیمانده',
      newFiled: 'فیلد جدید',
      owner: 'مالک',
      SelectedPhonebooks: 'دفترچه تلفن های انتخاب شده',
      clickForMoreInfo: 'جهت نمایش اطلاعات بیشتر کلیک کنید',
      disableItem: 'این مورد غیر فعال است',
      help: 'راهنما',
      editHelp: 'ویرایش راهنما',
      attachment: 'پیوست',
      notFoundHelp: 'راهنما یافت نشد',
      example: 'مثال : ',
      mainClaim: 'دسترسی اصلی',
      class: 'کلاس ',
      icon: 'آیکون',
      minuteBetweenTries: 'مدت تاخیر',
      transferPrivateNumber: 'اختصاص خطوط',
      maxTryCount: 'تعداد تلاش',
      parent: 'والد',
      zero: 'صفر',
      parentName: 'والد',
      database: 'پایگاه داده',
      paymentAmount: 'مبلغ پرداختی',
      chargeRateCredit: 'میزان شارژ',
      table: 'جدول',
      recipientCount: 'تعداد گیرندگان',
      apiAddress: 'آدرس Api',
      finalConfirmation: 'تایید نهایی',
      startDateSearch: 'از تاریخ',
      startTimeSearch: 'از ساعت',
      cancellation: 'لغو',
      cancellationRequest: 'لغو درخواست',
      stayRequest: 'منتظر می مانم',
      link: 'لینک',
      fileLink: 'لینک فایل',
      endDateSearch: 'تا تاریخ',
      endTimeSearch: 'تا ساعت',
      dateExit: 'تاریخ خروج',
      totalSum: 'مجموع کل',
      currentPageTotalSum: 'مجموع کل صفحه جاری',
      openDateFilter: ' فیلتر تاریخ',
      deleteFilter: 'حذف فیلتر',
      addRule: 'افزودن شرط',
      removeRule: 'حذف شرط',
      copyContent: 'کپی کردن محتوا',
      deviceTypes: 'نوع دستگاه',
      deviceBrands: 'برند دستگاه',
      pasteContent: 'جای‌گذاری محتوا',
      copy: 'کپی ',
      atFirst: 'نمایش در ابتدا',
      expandAll: 'بازکردن همه منوها',
      payable: 'قابل پرداخت',
      collapseAll: 'بستن همه منوها',
      paste: 'جای‌گزاری',
      loginToPanel: 'ورود به پنل',
      nameFa: 'نام فارسی',
      nameEn: 'نام انگلیسی',
      transactions: 'تراکنش ها',
      transactionKind: 'گروه تراکنش',
      sendType: 'نوع ارسال',
      nowNo: 'اکنون نه',
      succeed: 'عملیات موفق',
      publicPlace: 'مکان عمومی',
      shortLinkList: 'لیست لینک های کوتاه',
      smsTemplateList: 'لیست الگوهای پیامک',
      emoji: 'ایموجی',
      optional: 'اختیاری',
      savePolygon: 'ذخیره محدوده جغرافیایی منتخب',
      extraReceivers: 'گیرندگان اضافی',
      reseller: 'فروشنده',
      addPublicPlace: 'افزودن مکان عمومی',
      resetPassword: 'تغییر کلمه عبور',
      reset: 'تنظیم مجدد',
      isSignOut: 'خروج',
      removeSelectedItems: 'حذف موارد انتخابی',
      signInSignOut: 'ورود/خروج',
      emptyReceivers: 'لیست گیرندگان خالی است.',
      emptyReceiversOrWrongIndex:
        'لیست گیرندگان خالی است یا اندیس گذاری صحیح نمی‌باشد. ',
      uploadFile: 'آپلود فایل',
      uploadImage: 'آپلود عکس',
      uploadBackground: 'آپلود تصویر زمینه',
      isConfirmed: 'تایید شده',
      inboxGroup: 'گروه صندوق دریافت',
      saveNow: 'اکنون ذخیره شود',
      saveNowAfterSend: 'بعد از ارسال ذخیره شود',
      check: 'بررسی',
      myOrganizationPackages: 'بسته های من',
      getNewStatus: 'دریافت آخرین وضعیت',
      guildName: 'گروه مشاغل',
      subGuildName: 'زیرگروه مشاغل',
      addToJob: 'اضافه شدن به فرآیند ارسال',
      frontAudits: 'لاگ های فرانت',
      pollParserInboxes: 'ارسال کنندگان',
      receiveDateTime: 'تاریخ دریافت',
      smsCount: 'تعداد پیامک',
      priceRial: 'هزینه (ریال)',
      statistics: 'مشاهده آمار',
      pollParserLottery: 'قرعه کشی',
      winnerList: 'لیست برندگان',
      winnerCount: 'تعداد برندگان',
      addToQueue: 'ثبت مجدد در صف ارسال',
      ip: 'آی پی',
      ipRange: 'رنج آی پی',
      currentIp: 'آی پی جاری',
      appearanceSettings: 'تنظیمات ظاهری',
      formDetails: 'مشخصات فرم',
      exportRecepient: 'ذخیره ارسال هوشمند',
      importRecepients: 'ایجاد ارسال هوشمند از فایل',
      ImportRequestName: 'ایجاد درخواست ارسال هوشمند از فایل',
      selectRequestId: 'انتخاب شناسه ارسال هوشمند',
      requestId: 'شناسه ارسال',
      useToCreateToken: 'استفاده برای ساخت توکن',
      useToLoginPanel: 'استفاده برای ورود به پنل',
      running: 'فعال',
      paused: 'غیر فعال',
      do_pause: 'غیر فعال کردن',
      do_play: 'فعال کردن',
      persianPrice: 'قیمت فارسی',
      startDateTime: 'تاریخ و زمان شروع',
      endDateTime: 'تاریخ و زمان پایان',
      expireDateTime: 'تاریخ و زمان انقضا',
      englishPrice: 'قیمت انگلیسی',
      chosenSmartSmsDetail: 'جزئیات ارسال هوشمند',
      numbersCount: 'تعداد شماره ها',
      statusDatetime: 'تاریخ و ساعت آخرین وضعیت',
      lastUpdateDatetime: 'تاریخ و ساعت آخرین بروزرسانی',
      sendP2PSmart: 'ارسال هوشمند نظیربه نظیر',
      isNeedUserConfirmation: 'نیاز به تایید کاربر',
      category: 'دسته بندی',
      addNumbers: 'افزودن شماره همراه',
      numbers: 'شماره ها',
      previousMonth: 'ماه قبل',
      nextMonth: 'ماه بعد',
      deliveryStatusStats: 'آمار وضعیت گیرندگان پیام',
      messageDeliveryStatusStats: 'آمار وضعیت گیرندگان پیام',
      groupConfirmation: 'تایید گروهی',
      buyPlan: 'خرید پلن',
      occasion: 'مناسبت',
      calendar: 'تقویم',
      holiday: 'تعطیل رسمی',
      organExpireDate: 'تاریخ انقضای سازمان',
      userExpireDate: 'تاریخ انقضای کاربر',
      chart: 'نمودار',
      simType: 'نوع سیم کارت',
      requestDetail: 'جزئیات درخواست',
      smsSendingNumber: 'سرشماره ارسال پیامک',
      isRandomSend: 'ارسال به صورت تصادفی',
      smsPreview: 'پیش نمایش پیامک',
      addToPublicPlace: 'افزودن به مکان شخصی',
      balance: 'اعتبار',
      isCountTargetPassed: 'رسیده به تعداد',
      isCreditTargetPassed: 'رسیده به مبلغ نهایی',
      creditTargetValue: 'مبلغ نهایی',
      countTargetValue: 'تعداد پیامک',
      times: 'دفعات',
      commission: 'کمیسیون',
      partsCount: 'تعداد بخش',
      target: 'هدف',
      encoding: 'کدینگ',
      stats: 'آمار',
      justCurrentOrganization: 'فقط سازمان جاری',
      geometryType: 'نوع مکان',
      grayList: 'لیست خاکستری',
      airports: ' فرودگاه ها',
      airport: ' فرودگاه ',
      requestType: 'نوع درخواست',
      isRead: 'خوانده شد',
      informationUsersSeen: 'کاربران مشاهده کننده اخبار',
      receivedMessage: 'پیام دریافتی',
      startTimeAtDay: 'ساعت شروع ارسال',
      endTimeAtDay: 'ساعت پایان ارسال',
      update: 'بروزرسانی',
      priceFa: 'قیمت(FA)',
      priceEn: 'قیمت(EN)',
      totalPriceFa: 'قیمت کل(FA)',
      totalPriceEn: 'قیمت کل(EN)',
      messageCount: 'تعداد پیام ها',
      messageInConsumeCount: 'تعداد پیام ها در پردازش',
      regex: 'regex',
      expandMap: 'گسترش نقشه',
      collapseMap: 'کوچک شدن نقشه',
      incomeRatePerSecond: 'نرخ ورود به صف',
      consumersCount: 'تعداد مصرف کنندگان',
      consumeRatePerSecond: 'نرخ خروج از صف',
      duplicatedNumbersCount: 'تعداد شماره های تکراری',
      archive: 'آرشیو',
      smartSmsPercent: 'درصد تعرفه ارسال هوشمند',
      mtnSmartPercent: 'درصد تعرفه ارسال هوشمند ایرانسل',
      rightelSmartPercent: 'درصد تعرفه ارسال هوشمند رایتل',
      mciSmartPercent: 'درصد تعرفه ارسال هوشمند همراه اول',
      smartSmsClubTitle: 'عنوان باشگاه',
      smartSmsCampaignTitle: 'عنوان کمپین',
      periodType: 'نوع دوره فراخوانی',
      period: 'دوره فراخوانی',
      periodValue: 'مقدار دوره فراخوانی',
      smartRequestType: 'نوع درخواست ارسال هوشمند',
      grayListExpireHour: 'تا چند ساعت، شماره ای تکراری در نظر گرفته شود؟',
      cellList: 'لیست سلولی',
      isSmartCountAsPercent: 'درصدی',
      smartSmsClubOperationType: 'نوع عملیات باشگاه ارسال هوشمند',
      downloadPDF: 'دانلود PDF',
      downloadPowerPoint: 'دانلود Powerpoint',
      downloadImage: 'دانلود تصویر',
      smartRequestId: 'شناسه درخواست: ',
      content: 'محتوا',
      megabyte: 'مگابایت',
      kilobyte: 'کیلوبایت',
      chooseTemplate: 'انتخاب قالب',
      chooseTheme: 'انتخاب تم',
      titleOfReport: ' عنوان گزارش',
      logoUpload: 'آپلود لوگو',
      imageUpload: 'آپلود تصاویر',
      campaignReport: 'گزارش کمپین',
      editTitleOfReport: ' ویرایش عنوان گزارش',
      createReport: 'ساخت گزارش',
      editBackground: 'ویرایش پس زمینه',
      operators: 'اپراتورها',
      sendStatus: 'وضعیت ارسال ها',
      readNotification: 'خوانده شد',
      percentage: 'درصد',
      addTitle: 'افزودن عنوان',
      showFile: 'نمایش فایل',
      addRow: 'افزودن ردیف',
      socialMediaGroupPriceDetail: 'جزئیات بازه شبکه های اجتماعی ',
      groupRejection: 'عدم تایید گروهی',
      financialBalance: 'تراز مالی',
      paymentImage: 'تصویر پرداخت',
      passwordOrToken: 'کلمه عبور یا توکن',
      url: 'لینک',
      aggregatorInquiry: 'استعلام اپراتورها',
      blackListInquiry: 'استعلام لیست سیاه',
      isBlackList: 'لیست سیاه',
      isExternalBlackList: 'لیست سیاه خارجی',
      totalCount: 'تعداد کل',
      getTotalCount: 'دریافت تعداد کل',
      startDatetime: 'تاریخ شروع',
      endDatetime: 'تاریخ پایان',
      isCanSendVoice: 'امکان ارسال صدا',
      activePeriodicSmartSmsRequests: 'کمپین های درحال اجرا',
      showMore: 'نمایش بیشتر...',
      fields: 'فیلد ها',
      isUseSeparator: 'جداکننده در فیلدهای عددی',
      scheduledMessagePartsCount: 'تعداد کل پارت ها',
      platform: 'پلتفرم',
      endOfSessions: 'پایان نشست',
      currentMeeting: 'نشست فعلی',
      numberType: 'نوع خط',
      sendToBlackList: 'خط خدماتی',
      deleteFilters: 'حذف فیلترها',
      voiceMessageId: 'شناسه فایل صوتی',
      avanakVoiceMessageId: 'شناسه آوانک',
      isQuickSend: 'ارسال سریع',
      quickSendId: 'شناسه ارسال سریع',
      zoomIn: 'بزرگ نمایی',
      zoomOut: 'کوچک نمایی',
      reversePolygon: 'جا به جا کردن مختصات',
      desiredPolygon: 'مختصات مناطق مورد نظر',
      isFlashSms: 'ارسال فلش',
      checkCell: 'بررسی اعتبار منطقه',
      season: 'فصل',
      aggregateStats: 'گزارش مقایسه ای تجمیعی',
      seasonsStats: 'گزارش مقایسه ای فصل به فصل',
      firstTimeRange: 'بازه زمانی اول',
      secondTimeRange: 'بازه زمانی دوم',
      firstMonth: 'ماه اول',
      secondMonth: 'ماه دوم',
      firstSeason: 'فصل اول',
      secondSeason: 'فصل دوم',
      checkingPleaseWait: 'در حال بررسی لطفا شکیبا باشید ...',
      cellsByName: 'دریافت لیست سلول ها',
      names: 'نام ها',
      stopSending: 'توقف ارسال',
      cellListIds: 'لیست شناسه سلول ها',
      isCanSendSmartWithoutConfirmation: 'امکان ارسال هوشمند بدون تایید',
      region: 'منطقه',
      pricePerPart: 'تعرفه هر پارت پیامک',
      calculate: 'محاسبه',
      smartSmsClubFileProgresses: 'وضعیت فایل های آپلود شده',
      downloadResellerExcel: 'دانلود اکسل فروشندگان',
      isPercentageBenefitForInternational: 'آیا تعرفه بین الملل، درصدی است؟',
      internationalBenefitValue: 'مقدار سود بین الملل',
      campaignStatusInGateway: ' استعلام ایجاد لیست خاکستری در گت وی',
      clubStatusInGateway: ' استعلام ایجاد باشگاه در گت وی',
      isCreated: 'ایجاد شده؟',
      creationLocation: 'روش ثبت',
      startLocation: 'محل اجرای کمپین',
      updateGroup: 'ویرایش گروه',
      voiceGroup: 'گروه صدا',
      continueSendIfAnyOperatorHaveError:
        'اگر یکی از اپراتور ها خطا داشت، ارسال ادامه یابد؟',
      kibanaDashboard: 'داشبورد کیبانا',
      authorizationScheme: 'نوع احرازهویت',
      organizationsBlackListExceptions: 'لیست استثناها',
      reject: 'رد کردن',
      loginAudits: 'لاگ های ورود کاربران',
      alertSetting: 'تنظیم اعلان',
      isEnableSendNotification: 'ارسال اعلان فعال باشد؟',
      daysOfSendFrequencyPeriod: 'تعداد روزهای دوره',
      fromDaysMoreThanSendFrequently: 'از چند روز بیشتر از تناوب',
      toDaysMoreThanSendFrequently: 'تا چند روز بیشتر از تناوب ',
      create: 'ایجاد',
      newMenu: 'منو جدید',
      updateMenu: 'ویرایش منو',
      route: 'مسیر',
      order: 'ترتیب',
      endpoints: 'اندپوینت‌ها',
      newEndpoint: 'اندپوینت جدید',
      updateEndpoint: 'ویرایش اندپوینت',
      methods: 'متدها',
      baseUrl: 'آدرس‌ پایه',
      methodType: 'نوع متد',
      request: 'درخواست',
      response: 'پاسخ',
      responses: 'پاسخ ها',
      tips: 'نکات',
      sampleCodes: 'نمونه‌های کد',
      headerList: 'لیست هدرها',
      paramsList: 'لیست پارامترها',
      danger: 'خطا',
      isRequired: 'اجباری',
      statusCode: 'کد وضعیت',
      version: 'نسخه',
      tryIt: 'امتحان کنید',

      htmlContent: 'محتوای html',
      showDashboard: 'نمایش داشبورد ',
      smartSmsClubNumbers: ' شماره های باشگاه مشتریان هوشمند',
      strategies: 'استراتژی ها',
      pointStrategies: 'استراتژی های امتیازات',
      pointStrategiesDetail: 'جزئیات استراتژی های امتیازات',
      deviceNumbers: 'شماره های دستگاه',
      histories: 'تاریخچه',
      strategyTitle: 'استراتژی',
      backgroundImage: 'تصویر پس زمینه',
      form: 'فرم',
      items: 'آیتم ها',
      newMobileNumber: 'شماره همراه جدید',
      showForm: 'نمایش فرم',
      zoomToFit: 'تمام صفحه',
      reload: 'بارگزاری مجدد',
      if: 'اگر :',
      then: 'آنگاه :',
      singleDelete: 'حذف تکی',
      deleteWithChildren: 'حذف با زیرمجموعه',
      ifValue: 'مقدار :',
      fieldType: 'نوع فیلد',
      answerResponse: 'پاسخ به پیام',
      duplicationResponse: 'پیام تکراری',
      mobiles: 'شماره موبایل ها',
      myQuestionnaires: 'پرسشنامه‌های من',
      newQuestionnaire: 'پرسشنامه جدید',
      newSurvey: 'نظرسنجی جدید',
      farvardin: 'فروردین',
      ordibehesht: 'اردیبهشت',
      khordad: 'خرداد',
      tir: 'تیر',
      mordad: 'مرداد',
      shahrivar: 'شهریور',
      mehr: 'مهر',
      aban: 'آبان',
      azar: 'آذر',
      dey: 'دی',
      bahman: 'بهمن',
      esfand: 'اسفند',
      onlineSurvey: 'نظرسنجی',
      default: 'پیش فرض',
      blue: ' آبی',
      green: ' سبز',
      yellow: ' زرد',
      red: ' قرمز',
      purple: ' بنفش',
      orange: ' نارنجی',
      pink: ' صورتی',
      gray: ' خاکستری',
      introPage: 'صفحه شروع',
      outroPage: 'صفحه پایان',
      newQuestion: 'پرسش جدید',
      questionList: 'لیست پرسش‌ها',
      textInput: 'متنی',
      selectListInput: 'چندگزینه ای',
      answerCount: 'تعداد پاسخ',
      answer: 'پاسخ  ',
      question: 'پرسش',
      query: 'سوال',
      newAnswer: 'پاسخ جدید',
      editQuestion: 'ویرایش پرسش',
      answers: 'پاسخ‌ها',
      nextQuestion: 'پرسش بعدی',
      prevQuestion: 'پرسش قبلی',
      visitCount: 'تعداد بازدید',
      answerPattern: 'الگوی پاسخ',
      minLength: 'حداقل تعداد حروف ',
      maxLength: 'حداکثر تعداد حروف',
      onlineSurveyStatistics: 'آمار ',
      onlineSurveyResponses: 'لیست پاسخ ها',
      responseList: 'لیست پاسخ‌ها',
      created: 'تاریخ ثبت',
      finalQuestion: 'سوال پایانی',
      firstQuestion: 'اولین سوال',
      onlineSurveyTitle: 'عنوان نظرسنجی',
      responseCount: 'تعداد پاسخ',
      persianYear: 'سال شمسی',
      persianMonth: 'ماه شمسی',
      persianDay: 'روز شمسی',
      statisticsDateTime: 'تاریخ و ساعت',
      start: ' شروع',
      end: ' پایان',
      updateSurvey: 'ویرایش نظرسنجی',
      emptyMobiles: 'لیست شماره موبایل ها خالی است',
      surveyList: 'نظرسنجی آنلاین',
      addFromExistingFields: 'افزودن از فیلدهای آماده',
      questionTitle: 'متن سوال',
      copyLink: 'کپی کردن لینک',
      isPostPaid: 'پس پرداخت',
      word: 'کلمه',
      score: 'امتیاز',
      rank: 'رتبه',
      method: 'نوع تحلیل',
      addMobile: 'افزودن شماره موبایل',
      notValidAnswersResponse: 'پاسخ های نامعتبر',
      totalRecipients: 'مجموع گیرندگان انتخابی',
      expiringOrganizationsCount: ' سازمان‌های در حال انقضا',
      expiringUsersCount: ' کاربران در حال انقضا',
      expiringPrivateNumbersCount: ' خطوط در حال انقضا',
      suspendedUsersCount: ' کاربران مسدود شده',
      unAuthorizedUsersCount: ' کاربران احراز هویت نشده ',
      waitForConfirmApiTokensCount: 'توکن‌های بررسی نشده',
      waitForConfirmOtpsCount: ' قالب‌های پیامک احرازهویت بررسی نشده',
      waitForConfirmPaymentsCount: 'پرداخت‌های غیرآنلاین در حال بررسی',
      waitForConfirmSafeIpsCount: ' آی‌پی‌های بررسی نشده',
      waitForConfirmScheduledMessagesCount: ' ارسال‌های منتظر برای تایید',
      canceledNotResentLocalNetworkOutboxMessageCount:
        ' ارسال های ثبت شده با سرشماره 999999',
    },
    messages: {
      clipboard: {
        message: 'جهت کپی کردن کلیک کنید',
        copied: 'کپی شد',
      },
      htmlStatus: {
        code400: 'درخواست ناصحیح',
        code401: 'عدم دسترسی',
        code403: 'عدم دسترسی',
        code404: '404',
        code405: 'خطا',
        code500: 'خطای سرور',
        code400Msg: 'درخواست شما با مشکل مواجه شده است..',
        code401Msg: 'جهت ادامه فرآیند لازم است ابتدا وارد سیستم شوید.',
        code403Msg: 'کاربر گرامی شما مجوز دسترسی به این قسمت را ندارید .',
        code405Msg: 'متد مجاز نیست',
        code500Msg: 'در برقراری ارتباط با سرور مشکلی رخ داده است.',
      },
      validationError: {
        minLength:
          ' <b>{{title}}</b> باید حداقل <b>{{minLength}}</b> کاراکتر باشد',
        maxLength:
          ' <b>{{title}}</b> باید حداکثر <b>{{maxLength}}</b> کاراکتر باشد',
        min: 'مقدار <b>{{title}}</b> نباید از <b>{{min}}</b> کمتر باشد',
        max: 'مقدار <b>{{title}}</b> نباید از <b>{{max}}</b> بیشتر باشد',
        mobileNumberIsInvalid: 'شماره موبایل نامعتبر است',
        invalid: ' <b>{{title}}</b> نامعتبر است',
        required: 'پر کردن فیلد <b>{{title}}</b> الزامی می باشد',
        globalRequired: 'پر کردن این فیلد الزامی می باشد',
        invalidEmail: 'آدرس ایمیل معتبر نمی باشد',
        maxFileSizeInMb:
          'حداکثر حجم مجاز فایل جهت آپلود {{size}} مگابایت می باشد',
        maxFileSizeInKb:
          'حداکثر حجم مجاز فایل جهت آپلود {{size}} کیلوبایت می باشد',
        allowedFilTypes: 'فایل هایی با پسوند های {{types}} مجاز می باشند',
        confirmPassword: 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد',
        allowedFilTypesTip: 'فرمت های مجاز',
        fileMaxLengthInKB: 'حداکثر سایز فایل {{ size }} کیلوبایت می باشد',
        fileMaxLengthInGB: 'حداکثر سایز فایل {{ size }} گیگابایت می باشد',
        validFileTypes: 'فایل هایی با پسوند های {{types}} مجاز می باشند',
        fileMaxLength:
          'حداکثر حجم مجاز فایل جهت آپلود {{ size }} مگابایت می باشد. ',
        maxFileCount: 'حداکثر تعداد مجاز فایل جهت آپلود {{ count }} می باشد.',
        addAtLeastOneOption: 'حداقل یک پاسخ اضافه کنید',
        endDateShouldBiggerThanStartDate:
          'تاریخ پایان باید بزرگتر از تاریخ شروع باشد.',
      },
      noItemsToDisplay: 'موردی برای نمایش وجود ندارد',

      selectedFilters: 'فیلترهای انتخاب شده',
      selectedLoginPageTemplate:
        'لطفا قالب صفحه ورود مورد نظر خود را انتخاب کنید :',
      fewMinutesAgoWithMin: '{{min}} دقیقه پیش',
      hoursAndMinutesAgo: '{{hours}} ساعت و {{minutes}} دقیقه پیش',
      hoursAgo: '{{hours}} ساعت پیش',
      daysAndHoursAndMinutesAgo: '{{days}} روز و {{hours}} ساعت پیش',
      daysAgo: '{{days}} روز پیش',
      monthsAgo: '{{month}} ماه پیش',
      yearsAgo: '{{year}} سال پیش',
      momentsAgo: 'لحظاتی پیش',
      fewMinutesAgo: 'چند دقیقه پیش',
      isCanSendVoiceMessage:
        '<i class="mdi mdi-volume-high tw-text-primary-300 mdi-22px volume-high-icon"></i> خط ارسال صوتی',
      markReadAllNotifications: 'خواندن همه اعلان ها',
      sendTicketToSupport: 'ارسال تیکت به پشتیبانی',
      statisticsDoughnutChartText: 'تعداد کل پیام های ارسال شده',
      statisticsBarChartText: 'تعداد پیام های ارسال شده به تفکیک زمان ارسال',
      clipBoardAndFileUploadWarning:
        'توجه داشته باشید امکان استفاده از حالت های <b>آپلود فایل</b> و <b>کلیپ بورد</b>بصورت ترکیبی وجود ندارد. <br> <br> در حالت <b class="text-danger">{{modeWithDataTitle}}</b> اطلاعاتی ثبت شده است .با رفتن به حالت <b class="text-danger">{{modeTitle}}</b> این اطلاعات حذف خواهند شد. با این وجود از رفتن به حالت <b class="text-danger">{{modeTitle}}</b> مطمئن هستید؟',
      minlengthValidationError:
        'طول {{title}} نباید از {{minLength}} رقم کمتر باشد.',
      maxValidationError: ' {{title}} نباید از {{max}} رقم بیشتر باشد.',
      minValidationError: ' {{title}} نباید از {{min}} کمتر باشد.',
      maxlengthValidationError: ' {{title}} نباید از {{maxLength}} بیشتر باشد.',
      minNumberValidationError: ' {{title}} نباید از {{min}} کمتر باشد.',
      maxNumberValidationError: ' {{title}} نباید از {{max}} بیشتر باشد.',
      maxMobileNumbers:
        'حداکثر می توانید {{maxMobileNumbers}}شماره موبایل ثبت کنید . ',
      maxMobileNumbersInManualMode:
        ' در حالت دستی حداکثر می توانید {{maxMobileNumbersInManualMode}} شماره موبایل ثبت کنید. ',
      maxMobileNumbersInClipBoardMode:
        ' در حالت کلیپ بورد حداکثر می توانید {{maxMobileNumbersInClipBoardMode}} شماره موبایل ثبت کنید. ',
      deleteMessage: 'آیا از حذف این مورد مطمئن هستید ؟',
      deleteMenuMessage: 'آیا از حذف این منو مطمئن هستید ؟',
      deleteEndPointMessage: 'آیا از حذف این اندپوینت مطمئن هستید ؟',
      confirmByWritingTextMessage:
        'با حذف این مورد تمامی زیرگروه‌ها و داده‌های ذخیره شده مرتبط حذف می شوند . ',
      confirmByWritingTextMessageForStopSending:
        'در صورتی که ارسال متوقف شود، ادامه ارسال متوقف می شود ',
      cellListMessage:
        'در منطقه انتخاب شده اپراتور های زیر پشتیبانی می شود ، اگر اپراتور مورد نظر شما در لیست زیر وجود ندارد پیشنهاد می شود نسبت به تغییر یا بزرگ تر کردن مختصات خود اقدام کنید. ',
      confirmText: 'برای تایید عدد زیر را وارد کنید ',
      confirmPayment: 'آیا از تایید کردن این پرداخت مطمئن هستید ؟',
      rejectPayment: 'آیا از رد کردن این پرداخت مطمئن هستید ؟',
      rejectSend: 'آیا از عدم تایید این ارسال مطمئن هستید ؟',
      allExcelReport: 'دانلود همه با فرمت Excel',
      pageExcelReport: 'دانلود صفحه بصورت Excel',
      pageTxtReport: 'دانلود صفحه با فرمت Text',
      allTxtReport: 'دانلود همه بصورت Text',
      changePasswordMsg:
        'کاربر گرامی نیاز است جهت حفظ امنیت حساب کاربری خود، کلمه عبور خود را تغییر دهید.',
      verificationCodeIsInvalid: 'کد تایید نامتعبر است',
      textMaxLength: 'حداکثر سایز متن {{ size }} مگابایت می باشد',
      textMaxLengthInManualMode:
        'حداکثر حجم متن در حالت دستی  {{ size }} مگابایت می باشد. جهت جای گذاری با حجم بیشتر از حالت کلیپ بورد استفاده نمائید.',
      textMaxCorrectMobileNumberCountInManualMode:
        'در حالت دستی حداکثر می توانید {{size}} شماره موبایل ثبت کنید .',
      validMediaTypes: 'فایل هایی با پسوندهای زیر مجاز میباشند: ',
      successfulOperation: 'عملیات موفق',
      periodDateTimeErrorMsg:
        ' هنگامی که تاریخ شروع و تاریخ پایان برابر هستند ، ساعت شروع نمی تواند بیشتر از ساعت پایان باشد.',
      failedOperation: 'عملیات {{ operation }}  ناموفق',
      OptimalSearch: 'برای جستجو حداقل سه حرف الزامی است',
      currencyAlert: 'قیمت ها  بر اساس  {{ currency }} می باشد .  ',
      contentIsInvalid: 'محتوا نامعتبر است',
      chooseItem:
        'با زدن کلید  <i class="mdi mdi-text-box-plus-outline text-blue mdi-22px"></i> می توانید آیتم موردنظر خود را انتخاب کنید.',
      searchInOrganizations: 'جستجو در سازمان ها',
      searchInRoles: 'جستجو در نقش ها',
      insertMobile: 'شماره موبایل خود را وارد کنید',
      searchAggregator:
        'لطفا شماره موبایل را وارد کنید و سپس روی جستجو کلیک کنید',
      isValidNumber: 'لطفا شماره موبایل را وارد کنید و سپس روی تایید کلیک کنید',
      searchInUsers: 'جستجو در کاربران',
      searchInPrivateNumbers: 'جستجو در خطوط اختصاصی',
      searchInPhonebooks: 'جستجو در دفترچه تلفن',
      searchInContacts: 'جستجو در مخاطبین',
      searchInTargetPrivateNumbers: 'جستجو در خط فرستنده',
      searchText: 'متن جستجو',
      enterSocialnetworkIdPlaceHolder: 'آیدی شبکه اجتماعی را وارد کنید',
      showSearch: 'نمایش فیلترها',
      isAddSignature: 'امضا به متن پیامک اضافه شود',
      quitMsg: 'آیا قصد خروج از حساب کاربری خود را دارید؟',
      hideSearch: 'بستن فیلترها',
      imageNotUploaded: 'تصویری آپلود نشده',
      fileNotUploaded: 'فایلی آپلود نشده',
      fileIsInvalid: ' فایلی یافت نشد',
      maxIpTotalCount: '*حداکثر میتوانید 15 آی پی انتخاب کنید',
      guideToUsingSignatureAndHeader:
        '* کاربر گرامی جهت مشاهده و ویرایش امضای پیامک، از گزینه  <i class="mdi mdi-draw-pen mdi-20px text-info text-info tw-mt-1 bg-light-blue tw-p-1  rounded-circle"></i> و به منظور مشاهده و ویرایش سرتیتر پیامک، از گزینه <i class="mdi mdi-message-reply-text-outline mdi-20px text-blue tw-mt-1 bg-light-info tw-p-1  rounded-circle"></i> استفاده فرمایید.',
      uneditableSignature: '* امضای ارسال کننده غیر قابل ویرایش می‌باشد.',
      isExistSignatureInSmsBody:
        '* در صورتی که امضای ارسال کننده در متن پیام وجود داشته باشد، امضای سازمان همیشه  در انتها نوشته می شود.',
      noExistOrganization: 'سازمانی یافت نشد !',
      filterByGroup: 'فیلتر بر اساس گروه',
      updateCreditMessage: 'جهت بروزرسانی اعتبار کلیک کنید',
      separateByEnter: 'جداکننده با کلید enter',
      separateByCommaAndEnter: 'جداکننده با کاما یا کلید enter',
      removeContactFromAllPhonebook: 'حذف از همه گروه ها',
      chipListPlaceholder: 'جداکننده با کاما یا کلید enter',
      confirmPassword: 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد.',
      invalidDateErrorMsg: 'زمان استفاده از این سرویس به پایان رسیده است.',
      invalidDateErrorMsgInSend:
        'کاربر گرامی تاریخ یا زمان ارسال ثبت شده از موعدش گذشته است. جهت ارسال پیامک ، تاریخ و زمان ارسال را مجدداً تنظیم نمائید.',
      invalidMinDate:
        'تاریخ باید از تاریخ جاری بیشتر یا برابر تاریخ انتخاب شده قبلی باشد',
      maxOpenTab: 'حداکثر می‌ توانید {{ count }} تب باز کنید .',
      unblockUserMessage: 'آیا از رفع مسدودی این کاربر اطمینان دارید؟',
      noConnectionToServer: 'در برقراری ارتباط با سرور مشکلی رخ داده است',
      notOrganization: 'کابر گرامی در حال حاضر شما عضو سازمانی نیستید.',
      expired: 'کابر گرامی حساب شما منقضی شده است.',
      notActiveOrganization: 'سازمان فعلی شما غیرفعال است.',
      expireOrganization: 'سازمان شما منقضی شده است.',
      globalConfirmationMessage: 'آیا از انجام این عملیات مطمئن هستید ؟',
      archiveConfirmationMessage: 'آیا از آرشیو کردن این مورد مطمئن هستید ؟',
      notAuthenticated: 'سازمان فعلی شما احراز هویت نشده است.',
      fullTextDisplay: 'برای نمایش کامل متن کلیک کنید',
      fullText: 'متن کامل',
      clickToSeeMore: 'جهت مشاهده بیشتر کلیک کنید',
      minimumVisibleColumnsMessage: 'حداقل دو ستون باید نمایش داده شود.',
      resendMessageConfirmation: 'آیا از ارسال مجدد پیام های زیر مطمئن هستید ؟',
      groupDeletionConfirmation: 'آیا از حذف  موارد زیر مطمئن هستید ؟',
      deleteAllContactConfirmation: 'آیا از حذف  تمامی مخاطبین مطمئن هستید ؟',
      apiTokenconfirmation: 'آیا از تایید کردن این توکن مطمئن هستید ؟',
      apiTokenUndoconfirmation: 'آیا از عدم تایید این توکن مطمئن هستید ؟',
      selectItems: 'سطری را انتخاب کنید',
      eventTitle: 'توضیحی برای این مناسبت وجود ندارد',
      mapHelp:
        '<b>ابزارهای نقشه</b> </br> Zoom in (بزرگنمایی نقشه)</br> zoom out (کوچک کردن نقشه) </br> ذخیره محدوده جغرافیایی (ثبت منطقه ی انتخاب شده) </br> polygon tool (ابزار انتخاب محدوده روی نقشه که حداقل به انتخاب 3 نقطه برای تعیین محدوده نیاز است) </br> delete (حذف محدوده ی انتخاب شده) </br>جهت ویرایش، روی محدوده انتخاب شده کلیک کرده و به وسیله نقاطی که ظاهر میشوند محدوه را ویرایش نمایید.   </br> همچنین می‌توانید با انتخاب نقاط وسطی، مناطق (نقاط) بیشتری به محدوه خود اضافه نمایید.',
      excelColListError:
        'فرمت ستون های فایل حتماً باید از نوع Text و با حروف انگلیسی و بدون فاصله باشد.',
      notRegistered: 'هنوز عضو نشده اید ؟',
      notLoggedIn: 'حساب کاربری دارید ؟',
      isValidIfConditionType:
        'ارسال از قالب با شرایط انتخابی امکان پذیر نمی باشد',
      isInvalidNumber: 'ارسال از خط انتخاب شده امکان پذیر نمی باشد',
      forgetPassword: ' جهت بازیابی کلمه عبور نام کاربری خود را وارد نمائید.',
      passwordRole:
        'کلمه عبور باید ترکیبی از اعداد و حروف بزرگ و کوچک انگلیسی و کاراکترهای ^£$%&*()}{@#~?><>,|=_+- باشد.',
      minLengthField:
        'طول  {{ formFieldName }} نباید از {{minLength}} کاراکتر کمتر باشد.',
      selectFileFromFileManager: 'لطفا فایلی را انتخاب کنید',
      loginImage: 'آپلود تصاویر صفحه ورود : ',
      emptyWordList: 'لیست کلمات خالی است ',
      notSelectAnyOrganization: 'هیج سازمانی انتخاب نشده است',
      notSelectAnyMenu: 'هیج منویی انتخاب نشده است',
      ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
        '  در صورتی که خط انتخابی خدماتی نباشد ، پیامک برای شماره تلفن هایی که در لیست سیاه هستند ارسال نمی شود.',
      deActiveAuthentication:
        'در صورت ادامه ی ویرایش احرازهویت {{userName}} غیرفعال می‌شود و مدیر باید حساب {{userName}} را دوباره تایید کند. آیا مطمئن هستید؟',
      selectPrivateNumberForPhonebooks:
        'جهت مشاهده مخاطبین، ارسال کننده را انتخاب نمائید.',
      selectOrganizationForRoles: 'جهت مشاهده نقش ها سازمان را انتخاب نمائید.',
      contactImportFromExcelMaxLength:
        'حداکثر تعداد کاربران مجاز برای ثبت، {{maxLength}} می‌باشد.',
      inGroup: 'در گروه',
      requiredUserIds: 'فیلد شناسه کاربری الزامی است',
      requiredPrivateNumbers: ' فیلد شناسه خط اختصاصی الزامی است',
      requiredMsg: 'انتخاب حداقل یک مورد الزامی است.',
      deleteFromPhonebooks:
        'دقت بفرمایید اگر شماره همراه وارد شده در گروه‌ دیگری نیز وجود داشته باشد، درصورت انتخاب آن گروه‌، شماره‌ی درحال ثبت در گروه جاری اضافه نمی‌شود.',
      sendingSms: 'در حال ارسال پیامک',
      creatingCampaign: 'در حال ایجاد کمپین',
      generateRandomPassword: 'ایجاد کلمه عبور تصادفی',
      calcSmsPrice: 'در حال محاسبه هزینه',
      pleaseWaiting: 'لطفاً شکیبا باشید',
      err404Msg: ' صفحه موردنظر یافت نشد !',
      enterYourText: 'متن موردنظر خود را وارد کنید',
      isExistFilePatch:
        '<p>جهت تکمیل فرآیند تبدیل متن به صوت روی کلید پخش کلیک کنید.</p> <p>فایل صوتی موردنیاز است .</p>',
      maxReceiversMsg: 'حداکثر می توانید {{number}} شماره اضافه کنید.',
      statusListMsg: 'وضعیت هایی که شامل این گزینه می شوند عبارتند از',
      onlyJpegAndPngAreAllowed:
        'تنها فایل هایی با پسوند {{allowedFiles}} مجاز میباشند',
      maxSizeIs1mb: 'حداکثر حجم هر فایل نباید از 1 مگابایت بیشتر باشد',
      receiversExcel: 'لطفا عنوان فایل اکسل را وارد کنید',
      successfulPurchase: 'خرید شما با موفقیت انجام شد.',
      successfulDiscount: 'کد تخفیف اعمال شد.',
      notEnoughCredit: 'اعتبار شما کافی نمی باشد.',
      ruleConfirmation:
        ' ضمن مطالعه دقیق وآگاهی از شرایط و مقررات اقدام به خرید کرده و شرایط را می پذیرم',
      privateNumberPurchaseRulesTitr:
        'محتوای پیامک‌ها باید با اصول و ضوابط زیر مطابق باشد',
      organizationInfo: 'مشخصات سازمان',
      userInfo: 'مشخصات کاربری',
      planInfo: 'مشخصات پلن',
      daysLeftUntilExpires: 'روز مانده تا انقضا ',
      buyPlanUserInfoNotice:
        'کاربر گرامی جهت خرید پلن لازم است به حساب کاربری خود وارد شود . اگر حساب کاربری ندارید روی کلید ثبت نام کلیک کنید.',
      enterAuthCode: 'کد تایید را وارد کنید',
      cancelRequest:
        '<span>درخواست شما در حال پردازش است،<br>ممکن است کمی زمانبر باشد.</span>',
      noTextForShow: 'هیچ متنی برای نمایش وجود ندارد!',
      sendersListAlert:
        '<span><span>● کاربر گرامی جهت مشاهده ارسال کنندگان گزینه مورد نظر خود را انتخاب نمایید.</br>● در صورتی که هیچ گزینه ای را انتخاب نکرده باشید ، لیست تمامی ارسال کنندگان نمایش داده می شود.</span></span>',
      lotteryAlert:
        '<span> کاربر گرامی جهت انجام قرعه کشی ، می توانید گزینه مورد نظر خود را انتخاب کنید تا قرعه کشی بین افرادی که این گزینه را انتخاب کرده اند صورت گیرد.</span>',
      lotteryNotStart:
        ' جهت انجام قرعه کشی تعداد برندگان را مشخص کنید ، سپس بر روی دکمه قرعه کشی کلیک کنید .',
      numberOfWinnersLessThanNumberOfParticipants:
        'تعداد برندگان وارد شده از تعداد شرکت کنندگان بیشتر است',
      numberOfParticipants: 'جهت انجام قرعه کشی شرکت کننده ای وجود ندارد.',
      addToQueue: 'آیا از اضافه کردن مجدد پیام زیر به صف ارسال مطمئن هستید؟',
      getCurrentIpHelp1: '* برای اطلاع از آی پی جاری خود میتوانید',
      getCurrentIpHelp2: 'را انتخاب کنید',
      wrongIndex: 'اندیس گذاری اشتباه است.',
      pleaseEnterRequestNameToContinue:
        'لطفاً نام یکتا درخواست خود را وارد نمایید',
      rangeDetail:
        'دقت داشته باشید برای رنج آی پی باید رقمی بزرگتر از آخرین رقم آدرس آی پی انتخاب کنید',
      selectPolygon: 'لطفا یک محدوده را انتخاب کنید.',
      disableMapInSmartSms:
        ' در این نوع درخواست ارسال هوشمند ، انتخاب محدوده از روی نقشه غیر فعال است',
      disableMapInSmartSmsDetail:
        ' در این نوع درخواست ارسال هوشمند ، نقشه غیر فعال است',
      smartPeriodicMessage:
        'کاربر گرامی،      توجه داشته باشید درصورت انتخاب بیش از یک منطقه، تعداد ارسالی که در فیلد مربوطه وارد می‌کنید به صورت مجزا برای هر منطقه درنظر گرفته می‌شود.',
      socialMediaSizeRangeMessage: ' حجم فایل‌ها بر اساس کیلوبایت',
      dragFile: 'فایلی را درگ یا انتخاب کنید',
      pasteInfinite: 'جهت جایگذاری بینهایت،روی دکمه کلیک کنید.',
      mapOfTheCampaignLocation: 'نقشه محل اجرای کمپین',
      theNumberOfSMSSentByOperator: 'تعداد پیامک هاي ارسالی به تفکیک اپراتور',
      theNumberOfSMSSentByStatus: 'تعداد پیامک هاي ارسالی به تفکیک وضعیت',
      smsBodyContainsHeaderOrSignature:
        'توجه داشته باشید برای این ارسال کننده امضا یا سرتیتر پیامک تعریف شده است. <br>جهت مشاهده متن پیامک نهایی روی کلید پیش نمایش پیامک کلیک کنید.',
      clickToShowFile: 'جهت مشاهده روی فایل کلیک کنید',
      forbiddenCharacters:
        'در متن پیام، استفاده از کاراکتر {{forbiddenCharacters}} غیر مجاز می‌باشد.',
      activePeriodicSmartSmsRequestsDescription:
        'جدول زیر لیست آخرین کمپین های فعال در حال اجرای کاربر را نمایش می دهد ',
      isUseSeparatorChangeMessage:
        'با تغییر این گزینه، صفحه مجدداً بارگذاری می‌شود.',
      reversePolygonAlert:
        'در صورت انتخاب گزینه ی زیر، اگر نیازی به مختصات فعلی روی نقشه ندارید، ابتدا آن را حذف کنید',
      noCellMessage: 'منطقه با توجه به اپراتور انتخابی دارای سلول نمی‌باشد.',
      wrongCellList: 'مقدار وارد شده برای لیست سلولی صحیح نمی باشد',
      emptyMobileNumbers: 'لیست شماره های همراه خالی است.',
      periodicPatterns:
        'لیست الگوها در زیر ارائه شده است شما می توانید الگوی انتخاب روز مدنظر خود را انتخاب نمائید.',
      changePeriodicPatterns:
        'توجه داشته باشید انتخاب حداقل یک روز الزامی می باشد و درصورتی که روزی انتخاب نشده باشد بصورت پیش فرض تمامی روزهای بازه‌ی انتخابی در نظر گرفته می‌شود.',
      choosePeriodicPattern: 'انتخاب الگو و روزهای ارسال',
      showCalender:
        'جهت نمایش تقویم لازم است در ابتدا تاریخ شروع و تاریخ پایان را انتخاب نمائید',
      chooseDaysFromCalender:
        'به منظور نمایش و انتخاب روزهای ارسال بر‌روی دکمه نمایش تقویم کلیک کنید.',
      defaultDaysOfWeekIsSelected:
        'بصورت پیش فرض تمامی روزهای بازه‌ی انتخاب شده در نظر گرفته می شود.',
      rejectUserSafeIp: 'آیا از رد کردن این آی پی مطمئن هستید؟',
      confirmUserSafeIp: 'آیا از تایید این آی پی مطمئن هستید ؟',
      useTag:
        'در صورت تمایل به استفاده از تگ html، لطفاً آن را داخل پرانتز قرار دهید. به عنوان مثال: (p)',
      enterDescription: 'توضیحات را وارد کنید',
      inputCodeInEditor: 'نمونه کد موردنظر خود را وارد کنید',
      inputBodyCodeInEditor: 'نمونه کد Body را وارد کنید',
      searchInModels: 'جستجو در مدل‌ها به حروف کوچک و بزرگ حساس است.',
      isForceSearch:
        'برای مشاهده ی نتایج در این منو، لطفا ابتدا جستجو انجام دهید.',
      selectNumberFirst:
        'جهت مشاهده متن پیام لطفا ابتدا ارسال کننده را انتخاب کنید.',
      patternFieldHint:
        'لطفا از الگوی بدون / در ابتدای این فیلد استفاده کنید. به عنوان مثال: <b>^d+$</b>',
      changeThenConditionTypeMessage:
        'با تغییر این مورد تمامی زیرمجموعه ها حذف میشوند.',
      bulkRecipientsLimitation:
        'تعداد محدوده های ارسال باید کمتر از {{count}} باشد.',
      onlineSurveyStatisticsMsg:
        'جهت نمایش آمار بازه شروع و پایان را انتخاب کنید.',
      onlineSurveyResponsesMsg:
        'جهت نمایش لیست پاسخ‌ها نظرسنجی را انتخاب کنید.',
      redirectUrlMessage: 'پس از اتمام نظرسنجی به چه مسیری منتقل شود ؟',
      required: 'پاسخ به این سوال الزامی می‌باشد.',
      maxLength: 'حداکثر تعداد حروف پاسخ می بایست {{maxLength}} رقم باشد.',
      minLength: 'حداقل تعداد حروف پاسخ می بایست {{minLength}} رقم باشد.',
      pattern: 'پاسخ شما نامعتبر است ',
      selectThemeType: 'نوع تم را انتخاب کنید',
      enterQuestion: 'متن سوال را وارد کنید. ',
      selectQuestionType: 'نوع سوال را انتخاب کنید. ',
      enterAnswerLength: 'در‌صورت تمایل محدودیت تعداد حروف پاسخ را وارد کنید. ',
      isRequiredQuestion: 'پاسخ به سوال اجباری',
      notfoundSurvey: 'نظرسنجی یافت نشد!',
      backToHomepage: 'بازگشت به صفحه اصلی',
      enterPasswordHere: 'پاسخ را اینجا بنویسید',
      smartSignatureMessage:
        'در صورتی که امضای خط را از متن پیام حذف کنید، هنگام ارسال امضا به صورت سیستمی به متن اضافه میشود.',
      forbiddenVoiceAndSocialSend:
        'امکان ارسال صوتی و شبکه اجتماعی در این نوع ارسال وجود ندارد.',
      clipBoardAndManualCells:
        'توجه داشته باشید امکان استفاده از حالت های دستی و کلیپ بورد بصورت ترکیبی وجود ندارد. با تغییر حالت، داده های قبلی حذف میشوند. ',

      namesRegistered:
        '<span class="text-success"> <b class="tw-text-[14px] tw-font-black">{{namesCount}}</b> نام ثبت شد.',
      cellsWidgetMessage:
        'جهت مشاهده سلول های ثبت شده ابتدا روی جستجو سپس <span class="tw-font-medium"> {{downloadFile}} <i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i> </span> کلیک کنید .',
      pasteNames:
        'بازدن کلیدهای<span class="text-primary tw-text-[13px] tw-font-semibold"> (Ctrl + V) </span>یا کلیک بر‌‌روی کلید<i class="mdi mdi-clipboard-arrow-down-outline text-primary mdi-18px tw-mt-1"></i>نام های خود را اینجا جایگذاری کنید.',
      cellNamesMaxLengthInManualMode:
        'حداکثر تعداد نام ها در حالت دستی  {{ size }}  می باشد. جهت جای گذاری با تعداد بیشتر از حالت کلیپ بورد استفاده نمائید.',
      outboxAdvancedSearchHelp:
        '*برای جست وجوی پیشرفته بر روی فیلدهای شماره گیرنده،وضعیت ارسال و تحویل و متن پیام، تاریخ شروع و پایان اجباری هستند.</br> *فیلتر تاریخ ارسال اجباری است و باید کمتر از 90 روز باشد.',
    },

    components: {
      mobilesAnalysis: {
        addTitle: 'افزودن به لیست سیاه',
        wrongMobileNumbers: 'شماره موبایل های اشتباه',
        listOfMobileNumbers: 'شماره موبایل های صحیح',
        alertPart1:
          'حداکثر تعداد نمایش  {{ size }} شماره می باشد ، جهت مشاهده شماره های بیشتر روی',
        alertPart2: 'کلیک کنید .',
        downloadText: 'دانلود فایل با فرمت Text',
        downloadExcel: 'دانلود فایل با فرمت Excel',
        correctNumbers: 'شماره های صحیح',
        wrongNumbers: 'شماره های اشتباه',
        manualAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃جهت افزودن بصورت دستی شما می توانید شماره موبایل های مدنظر خود رادر فیلد زیر وارد نمائید.</p> <p class="tw-my-1">⁃این سرویس بصورت هوشمند شماره موبایل های صحیح را بررسی و ثبت می کند،همچنین مواردی که نامعتبر هستند یا به اشتباه تایپ شده اند را به عنوان خطا ،در قسمت (شماره های اشتباه) نمایش می دهد.</p> <p class="tw-my-1 text-danger tw-font-medium">⁃توجه داشته باشید شماره موبایل های تکراری حذف می شوند .</p> <p class="tw-my-1">⁃لازم به ذکر است در حالت دستی حداکثر می توانید <b>{{number}}</b> شماره موبایل ثبت کنید.</p> <p class="tw-my-1">⁃برای جایگذاری متن با حجم های بالا پیشنهاد می شود از قسمت <span class="text-info tw-font-medium">{{clipBoard}}</span> استفاده نمائید.</p>',
        uploadAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃فایل هایی با پسوندهای <b>{{fileTypes}}</b> مجاز به آپلود می باشند.</p><p class="tw-my-1">⁃حداکثر حجم مجاز فایل جهت آپلود <b> {{maxFileSize}} مگابایت </b> می باشد. </p><p class="tw-my-1 text-danger tw-font-medium">⁃دقت بفرمایید که سطر اول فایل اکسل خوانده نمی شود بنابراین می بایست از آن برای درج عنوان استفاده کنید.</p><p class="tw-my-1">⁃در زمان آماده سازی فایل به این نکته توجه داشته باشید که شماره ی گیرندگان را <b>فقط</b> در ستون اول وارد نمایید.</p><p class="tw-my-1">⁃عنوان ستون ها باید از نوع text و با حروف انگلیسی باشد .</p><p class="tw-my-1">⁃جهت دریافت نمونه فایل <a class="tw-font-bold tw-cursor-pointer " href="/assets/media/sample/sample.xlsx"download="sampleMobiles.xlsx" id="linkIdSampleMobiles"> اینجا </a>کلیک کنید.</p> <p class="tw-my-1 text-danger tw-font-medium">⁃توجه داشته باشید شماره موبایل های تکراری حذف می شوند .</p><p class="tw-my-1">⁃لازم به ذکر است حداکثر می توانید <b>{{maxMobileNumbers}}</b> شماره موبایل ثبت کنید.</p>',
        clipBoardAddDescription:
          '<p class="tw-mt-3 tw-mb-1">⁃جهت افزودن شماره موبایل شما می توانید شماره های موجود در کلیپ بورد را در فیلد زیر جایگذاری (Paste) کنید.</p><p class="tw-my-1">⁃این سرویس بصورت هوشمند شماره موبایل های صحیح را بررسی و ثبت می کند،همچنین مواردی که نامعتبر هستند یا به اشتباه تایپ شده اند را به عنوان خطا ،در قسمت (شماره های اشتباه) نمایش می دهد.</p><p class="tw-my-1 text-danger tw-font-medium">⁃توجه داشته باشید شماره موبایل های تکراری حذف می شوند .</p><p class="tw-my-1">⁃لازم به ذکر است در حالت کلیپ بورد حداکثر می توانید<b> {{maxMobileNumbers}} </b>شماره موبایل ثبت کنید.</p>',
        pasteNumber:
          'بازدن کلیدهای<span class="text-primary tw-text-[13px] tw-font-semibold"> (Ctrl + V) </span>یا کلیک بر‌‌روی کلید<i class="mdi mdi-clipboard-arrow-down-outline text-primary mdi-18px tw-mt-1"></i>شماره های خود را اینجا جایگذاری کنید.',
        numberRegistered:
          '<span class="text-success"> <b class="tw-text-[14px] tw-font-black">{{mobileNumbersCountInClipboardMode}}</b> شماره ثبت شد. </span><br>جهت مشاهده شماره موبایل های ثبت شده روی <span class="tw-font-medium"> {{downloadFile}} <i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i> </span> کلیک کنید .',
      },
      dynamicGrid: {
        props: {
          fromIndex: 'شروع از',
          sendCount: 'تعداد ارسال',
          Count: 'تعداد شماره',
          age: 'سن',
        },
      },
      smartSendConfirmation: {
        sendProperties: 'مشخصات ارسال',
        price: 'مبلغ هر پیامک',
        irr: ' ریال',
        polygonCalculatedPrice: 'هزینه ارسال محدوده',
        sendTotalPrice: 'مجموع هزینه',
        sendTotalPriceDesc:
          'هزینه به صورت تقریبی و بر اساس طول یک پیامک محاسبه می شود ',
        NextStep: 'ارسال پیامک',
      },
      domainForm: {
        imageUploaderHelpForLoginWithCarousel:
          '<p class="tw-mt-3 tw-mb-1 tw-text-base"> ⁃ عکس ارسالی الزاما باید تحت فرمت <b>jpg ، png و jpeg </b>باشد .</p> <p class="tw-my-3 tw-text-base"> ⁃ پیشنهاد می شود سایز عکس آپلودی در اندازه <b>4006px * 2116px</b> باشد.</p> <p class="tw-my-3 tw-text-base"> ⁃ حاشیه های عکس از بالا و پایین <b>378px</b> و از راست و چپ <b>756px</b> باشد.</p><p class="tw-my-3 tw-text-base">⁃ حداکثر حجم عکس <b>1MB</b> می‌باشد .</p>',
        imageUploaderHelpForRightOrCenterLogin:
          '<p class="tw-mt-3 tw-mb-1 tw-text-base"> ⁃ عکس ارسالی الزاما باید تحت فرمت <b>jpg ، png و jpeg </b>باشد .</p> <p class="tw-my-3 tw-text-base"> ⁃ پیشنهاد می شود سایز عکس آپلودی در اندازه <b>1133px * 604px</b> باشد.</p><p class="tw-my-3 tw-text-base">⁃ حداکثر حجم عکس <b>1MB</b> می‌باشد .</p>',
      },
    },
  },
};
